//the url configs for different environments for all the atom and aem endpoints
import {
  changente1Proxy,
  changente1Apigee,
  changesitProxy,
  changesitApigee,
  changeUATProxy,
  changeUATApigee,
  changePreProdProxy,
  changePreProdApigee,
  changeProdApigee
} from "./change/changeapiUrl.js";
const sitProxy = {
  PnSubsctiption:"https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/personalisation/personalization/subscribe",
  SaveSegment: "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/personalisation/personalization/segment",
  SaveCampaign: "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/personalisation/personalization/campaign", 
  GetDictonary: "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/personalisation/personalization/autolistmemebers?listname=", 

  MyVzSigninEspanolAF:
  "https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://espanol.verizon.com&remainInOverlay=N&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3A%2F%2Fespanol.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fespanol.verizon.com%252Fforyourhome%252Fordering%252Fmyverizonnew%252Fregistrationbridge.aspx",
  MyVzSigninAF:
    "https://sit-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://wwwawssit.ebiz.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fsit-ssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fsso-np.ebiz.verizon.com%252fconsumer%252fmyverizon%252frouter%253ftarget%253dhttps%25253a%25252f%25252fwwwawssit.ebiz.verizon.com%25252fforyourhome%25252fordering%25252fmyverizonnew%25252fregistrationbridge.aspx%25253f",
  MyVzSigninMV98:"https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www98.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fwww98.verizon.com%2fconsumer%2fmyverizon%2frouter%3ftarget%3dhttps%253a%252f%252fwww98.verizon.com%252finhome%252fmoves%252fqualification%253fismvflow%253dy",
  MyVzSigninMV:
    "https://sit-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://wwwawssit.ebiz.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fsit-ssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fsso-np.ebiz.verizon.com%252fconsumer%252fmyverizon%252frouter%253ftarget%253dhttps%25253a%25252f%25252fwwwawssit.ebiz.verizon.com%25252fforyourhome%25252fordering%25252fcheckavailabilitylq.aspx%25253fismvflow%25253dy",
  Wireless5Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/careflow/careflow/affinityvalidation",
  channelLineupPackageView:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/channellookup/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/channellookup/channels/allpackages",
  channelLineupVhoUrl:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/channellookup/channels/vho",
  channelProgramMasterUrl:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/channellookup/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/channellookup/channels/searchforchannelprogram",
  chatEncry: "Y",
  duedatefallout:"https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/debugger/duedatefallout",
  chatEncrypt:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/chatinfo/chatInfo/hvals",
  chatReint: "N",
  chatStore:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/chatinfo/chatInfo/storeChatInfo",
  checkAddr:
  "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addressqualification/address/qualification?addressID=",
  checkportability:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/tnportability/tnportability",
  updatebulkcart:
  "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/sit/vendorexperience/vendorexperience/recommendedCart",
  clearCart:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/cart/cart/accordion/clearcart",
  clearCartEC:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/cart/cart/accordion/clearcartec",
  compareCart:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/cart/cart/accordion/compare",
  configEntry:
    "https://wwwnte1aws.ebiz.verizon.com/content/verizon/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://wwwawssit.ebiz.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://wwwawssit.ebiz.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/sessionmanager/visitid",
  creditAssessment:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/creditcheck/creditcheck/creditfiosassessment",
  creditCheck:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/creditcheck/creditcheck/creditworthiness",
  creditRefresh:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/creditcheck/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/creditcheck/creditcheck/creditrefreshsupp",
  cancelpropensity:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/creditcheck/creditcheck/cancelpropensity",
  decryptUrl:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/accountqualification/account/decryptData",
  dobundle:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/product/products/dobundle",
  vecorder:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/product/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "/inhome/ecFooter",
  ecHeader: "/inhome/ecHeader",
  requestCallback:
  "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/order/order/requestcallback",
  encryptUrl:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/accountqualification/account/encryptData",
  fbeGetSoc:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/experience/exp/getSoc",
  fbePostSoc:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/soc/fbe/PostSoc",
  futurenotification:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addresslookup/addresses/futurenotification",
  generateToken:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/careflow/careflow/gettoken",
  getAccount:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/accountqualification/account",
  getBanners:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/experience/exp/banners",
  getCacheValue:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/experience/exp/getcachevalue",
  getCartAcc:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/cart/cart/accordion",
  getCartAccEc:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/cart/cart/accordion",
  getDisclaimer:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/experience/exp/disclaimer",
  getDisclaimerAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getDisclaimerProducts:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/experience/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/experience/exp/commondisclaimer",
  getCommonAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getPlansPromo:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/experience/exp/planspromo",
  getPlansPromoAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDueDate:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/duedate/duedate/triggerduedate",
  getExistingService:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addresslookup/addresses/existingservice",
  getFaq:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/experience/exp/faq",
    getFaqAEM:
  "https://wwwawssit.ebiz.verizon.com/personal/cas/getfaq.model.json",
  getMon: "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/mon/order/mon",
  getPartialStreetAddr:
  "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addresslookup/addresses/street?streetterm=",
    // "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/sit/addresslookup/addresses/street?streetterm=",
  getCompleteAddress:
    // "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/sit/addresslookup/addresses/address?addressid=",
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addresslookup/addresses/address?addressid=",
  getProduct:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/product/accordion/products",
  getProductEc:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/productec/accordion/products",
  getVoiceProductEc:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/productec/products",
  getSmartCartPersonalInfo:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/contactinfovalidation/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addresslookup/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "VAiecKGNC721VnSn9fQrmpMumsdxZYu3",
  getStreetAddrLocus2:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "MvaCGJaWUOM1zkdFJietJiYyq15SJGdF",
  qualification5G:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addressqualification/address/fixedwirelesscoveragecheck",
  getTerms:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/experience/exp/terms",
  getTermsAEM:
     "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getorderingtos.model.json",   
getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/experience/exp/tos",
  getUnit:
    // "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addresslookup/address/units",
   "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addresslookup/addresses/units",
  getUnitLocus:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-unit",
  getUpsell:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/product/accordion/products/upsell/",
  getVZID:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/registration/registration/getVzid",
  getZipcode:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addresslookup/addresses/zip",
  getSmartCartStatus:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/smartcart/order/smartcartstatus",
  getvendorvisitdetails:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/sessionmanager/getvendorvisitdetails",
  validateVendorToken: 
    "https://wwwawssit.ebiz.verizon.com/inhome/validatevendortoken",
    fetchEmeriosInfo: 
    "https://wwwawssit.ebiz.verizon.com/inhome/fetchEmeriosInfo",
  checkPreLink:
    "https://wwwawssit.ebiz.verizon.com/v05g/qa/vzwoffereligibility/eligibility/checkprelink?prelink=add",
  jsNotify:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/common/logger/logmsg",
  kafkaErrorAppLogs:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/common/kafka/atom_applogs",
  kafkaPageLogs:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/common/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/common/kafka/atom_visitdetails",
  learnCustomTv:
    "https://wwwawssit.ebiz.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://wwwawssit.ebiz.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/vendorexperience/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://wwwawssit.ebiz.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl:
    "https://wwwawssit.ebiz.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/common/kafka/pageconfig",
  nsiNotify:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addresslookup/addresses/nsinotification",
  orderConfirmation:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/experience/exp/getorderconfirmation",
  performEID:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/creditcheck/creditcheck/performeid",
  personlisationdmp:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/personalisation/personalization/getvzdmptoak",
  pieUrl: "https://pie.uat.verizon.com/pie/v1",
  postCacheValue:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/experience/exp/updatecachestorage",
  processSave:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/smartcart/order/processsmartcart",
  productOffersUrl:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/product/offer/products/manual",
  reflowOrderSubmission:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/debugger/ordersubmission",
  profileCart:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/cart/cart/profile",
  rapurl: "https://wwwawssit.ebiz.verizon.com/orderinfo/?src=olo",
  chatDetails:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/chatinfo/chatInfo/chatdetails",
  referFrinedValidation:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/chatinfo/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/vzwoffereligibility/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/product/products/refreshPromotions",
  removePromoCode:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/product/products/removePromotions",
  resumeSmartCart:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/smartcart/order/resumesmartcart",
  retrieveQualdetails:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addressqualification/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/smartcart/order/retrievesmartcart",
  sameDaydelivery:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/storepickup/switch/samedaydelivery",
  seeFcpDetail:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/experience/exp/fcpspecialoffers",
  sendLofNotification:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/lof/lof/sendnotification",
  sendOTP:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/contactinfovalidation/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/registration/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/common/notification/sendsmsoremail",
  setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/duedate/duedate/reserveduedate",
  smartAutoSave:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/smartcart/order/smartcartsave",
  smartSave:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/smartcart/order/smartcartsavewithparam",
  smartcartCancel:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/smartcart/order/smartcartcancel",
  storePickUp:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/storepickup/switch/storepickup",
  submitOrder:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/ordersubmission/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  updateCartAcc:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/cart/cart/accordion/updatecart",
  updateCartAccEc:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/cart/cart/accordion/updatecart",
  updateintentcart:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/cart/cart/updateintent",
  updateintentcartAcc:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/cart/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/cart/cart/accordion/updateintent",
  updateintentcartEc:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/cart/cart/updateintent",
  uploadFile:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/careflow/careflow/employeeproof",
  updateFireAlarm:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/product/products/voice/firealarm",
  getFireAlarm:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/product/products/voice/getfirealarm",     
  validateBillingAdress:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/billingvalidation/order/billing",
  validateContactInfo:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/contactinfovalidation/order/contact",
  validateCouponToken:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/careflow/careflow/validatecoupontoken",
  validateEmployee:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/careflow/careflow/validateemployee",
  validateName:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/contactinfovalidation/order/validateName",
  validateSigninUrl:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/accountqualification/account/validateSignin",
  validateSmartCartContactInfo:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/contactinfovalidation/order/validateSmartCartContactInfo",
  validatecartUrl:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/cart/cart/accordion/validate/",
  validatecartUrlEc:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/cart/cart/accordion/validate/",
  vendorFlow:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/sessionmanager/vendorflowvalidate",
  vendorFlowToken:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/sessionmanager/vendortokencreate",
  vepsUrl:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/veps/veps/payment",
  verifyOTP:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/contactinfovalidation/ssocheck/verifyccpin",
  viewDetail:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/experience/exp/viewdetails",
  viewDetailAEM:
    "hhttps://sales-bau-sit2-publisher.ebiz.verizon.com/personal/services/getlongdesc.fios",
  voicetn:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/phoneservices/phoneservices",
  vzFwdEnrollmentDetails: 
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addressqualification/address/enrollmentDetails",  
  twsSiginInDetails: 
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addressqualification/address/twsSiginInDetails",  
  vzwOfferEligibility:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/vzwoffereligibility/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/vzwoffereligibility/eligibility/getWirelessProduct",
  vzOrderInfo:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/vzorder/order/vzorderinfo",
  vzOrderDetail:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/vzorder/order/vzorderdetail",
  brtcInfo:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/vzorder/order/brtc",
  suppCancelCart:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/cart/cart/supp/",
  checkPDCdata:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/personalisation/personalization/checkpdcdata",
  updateFlowType:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/sessionmanager/updateflowtype",
  MoveCheckoutExperience:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/contactinfovalidation/order/moves/getCheckoutExperience",
  MoveLandingExperience:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/product/products/moves/getMovesExperience",
    vz15gFlow:"https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/sessionmanager/validate15recomm",
  mfrtnFlow:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/careflow/frontliners/save",
  mfrtnmoveEligibleCheck:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/careflowservice/frontliners/retrieve",
  mnhOneClickVzwAccountSave:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addressqualification/address/savewirelessaccountsystemobjectdetailstocache/",
  mnhOneClickQualification:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addressqualification/mobileandhome/ecwlnewfiosqualification",
  fiosQualification:
  "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addresslookup/addresses/fiosqualification",
  wlCustomerCheckoutInfo:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/addressqualification/mobileandhome/wlcustomercheckoutinfo",
  mnhOneClickMLP:
    "https://wwwawssit.ebiz.verizon.com/content/verizon/personal/services/fivegoneclick.nocache.html",
  ssoMHAuthiniticate:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
  "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzwoffereligibility/eligibility/fioReferralKiosk",
  fiosReferralCCAToken: "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzwoffereligibility/eligibility/generateJwtToken",
  fiosReferralVerifyToken: "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzwoffereligibility/eligibility/smspinverify",
  ssoMHEmailAuthiniticate:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",
  pollingIGBackendUrl:
    "https://securesit1.verizon.com/accessmanager/public/adaptiveauth/2fa/polling",
  verification:
    'https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzwoffereligibility/eligibility/verification',
  ssoMHGetName:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname", 
  ssoMHGetCustomerDetails:"https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/vzwoffereligibility/eligibility/getcustomerdetailsresponse",
  getProductPerks:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products", 
    getPerksAEM:"https://wwwawssit.ebiz.verizon.com/content/caas/plan/aggregated-perks.model.json",   
  runtimeValuesUrl:
    "https://atomservicesekssiteast.ebiz.verizon.com/atomapi/v1/common/pageflow/getruntimevalues?runtimekey=",
  storePickupCRP:"https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/whatsnext/whatsnext/storepickup",  
  getFccLabel:"https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/product/accordion/products/fccLabelData", 
  getMovesThrottle: "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/product/accordion/products/nsathrottlelist",
  disconnectBanner: "https://sso-np.ebiz.verizon.com/consumer/myverizon/homeoffers",
  mvaDisconnectBanner: "https://www.verizon.com/consumer/fios/secure/ui/acct/homeoffers", 
  sendVisitId : "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/updateSSP/",
  hmpFindActiveSchedule:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/hmpDigital/findActiveSchedule",
  hmpEligibilityChecks:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/hmpDigital/hmpEligibilityChecks",
  hmpHome:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/optin",
  retailStoreDetails: "https://vzwqa2.sdc.vzwcorp.com/soe/digital/prospect/peripheralsservice/getClosingAgencyDetails",
  lookupReferralNumber: "https://vzwqa2.sdc.vzwcorp.com/soe/digital/prospect/peripheralsservice/lookupRetailCollaborationCode",
  getpzaiRatingNumber: "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/product/accordion/products/fiospzai",
   getCentralAgreementTermsAEM: "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/product/products/tosCentralAgreement",   
  ...changesitProxy
};

const sitApigee = {
  PnSubsctiption:"https://api-qa.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/subscribe",
  SaveSegment: "https://api-qa.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/segment",
  SaveCampaign: "https://api-qa.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/campaign", 
  accessToken: "https://api-qa.ebiz.verizon.com/oauth/client_credential/accesstoken",
  getConsumerKey: "9eEUacA7H4WfLZQjjereh9aMgk49gR3U",
  getConsumerSecret: "yjMTSbOex8xbSzrc",
  getFiosQualification: "https://wwwawssit.ebiz.verizon.com/foryoursmallbiz/smb/api/Qualify/GetFiosQualification",
  reflowOrderSubmission:
  "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/debugger/ordersubmission",
  requestCallback:
  "https://api-qa.ebiz.verizon.com/atomapi/v1/order/order/requestcallback",
  updateFlowType:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/sessionmanager/updateflowtype",
  MoveCheckoutExperience:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/contactinfo/order/moves/getCheckoutExperience",
  MoveLandingExperience:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/moves/getMovesExperience",
  MyVzSigninMV98:"https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www98.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fwww98.verizon.com%2fconsumer%2fmyverizon%2frouter%3ftarget%3dhttps%253a%252f%252fwww98.verizon.com%252finhome%252fmoves%252fqualification%253fismvflow%253dy",
  MyVzSigninMV:
    "https://sit-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://wwwawssit.ebiz.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fsso-np.ebiz.verizon.com%2fconsumer%2fmyverizon%2frouter%3ftarget%3dhttps%253a%252f%252fwwwawssit.ebiz.verizon.com%252finhome%252fmoves%252fqualification%253fismvflow%253dy",
  MyVzSigninMVBAU:
    "https://sit-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://wwwawssit.ebiz.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fsit-ssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fsso-np.ebiz.verizon.com%252fconsumer%252fmyverizon%252frouter%253ftarget%253dhttps%25253a%25252f%25252fwwwawssit.ebiz.verizon.com%25252fforyourhome%25252fordering%25252fcheckavailabilitylq.aspx%25253fismvflow%25253dy",
    MyVzSigninEspanolAF:
    "https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://espanol.verizon.com&remainInOverlay=N&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3A%2F%2Fespanol.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fespanol.verizon.com%252Fforyourhome%252Fordering%252Fmyverizonnew%252Fregistrationbridge.aspx",
  MyVzSigninAF:
    "https://sit-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://wwwawssit.ebiz.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fsit-ssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fsso-np.ebiz.verizon.com%252fconsumer%252fmyverizon%252frouter%253ftarget%253dhttps%25253a%25252f%25252fwwwawssit.ebiz.verizon.com%25252fforyourhome%25252fordering%25252fmyverizonnew%25252fregistrationbridge.aspx%25253f",
  Wireless5Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/affinityvalidation",
  channelLineupPackageView:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/channellookup/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/channellookup/channels/allpackages",
  channelLineupVhoUrl:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/channellookup/channels/vho",
  channelProgramMasterUrl:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/channellookup/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/channellookup/channels/searchforchannelprogram",
  chatEncry: "Y",
  chatEncrypt:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/hvals",
  chatReint: "N",
  validatepartner: "/inhome/validatepartner",
  chatStore:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/storeChatInfo",
  checkAddr:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addressqualification/address/qualification?addressID=",
  fiosMnhFetch:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addressqualification/address/fiosmnh",
  checkportability:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/tnportability/tnportability",
    updatebulkcart:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/recommendedCart",
  clearCart:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/clearcart",
  clearCartEC:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/clearcartec",
  compareCart:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/compare",
  configEntry:
    "https://www.verizon.com/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://wwwawssit.ebiz.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://wwwawssit.ebiz.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId: "/inhome/generatevisitid",
  creditAssessment:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditfiosassessment",
  creditCheck:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditworthiness",
  creditRefresh:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefreshsupp",
  cancelpropensity:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/cancelpropensity",
  decryptUrl:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/decryptData",
  dobundle:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/dobundle",
    vecorder:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "/inhome/ecFooter",
  ecHeader: "/inhome/ecHeader",
  encryptUrl:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/encryptData",
  fbeGetSoc: "https://api-qa.ebiz.verizon.com/atomapi/v1/experience/exp/getSoc",
  fbePostSoc: "https://api-qa.ebiz.verizon.com/atomapi/v1/soc/fbe/PostSoc",
  futurenotification:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/futurenotification",
  generateToken:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/gettoken",
  getAccount:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account",
  getBanners:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/experience/exp/banners",
  getCacheValue:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/experience/exp/getcachevalue",
  getCartAcc: "https://api-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion",
  getCartAccEc:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion",
  getDisclaimer:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/experience/exp/disclaimer",
  getDisclaimerAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getDisclaimerProducts:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/experience/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/experience/exp/commondisclaimer",
  getCommonAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getPlansPromo:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/experience/exp/planspromo",
  getPlansPromoAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDueDate:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/duedateservice/duedate/triggerduedate",
  getExistingService:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/existingservice",
  getFaq: "https://api-qa.ebiz.verizon.com/atomapi/v1/experience/exp/faq",
  getFaqAEM:
   "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getfaq.model.json",
  getMon:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/masterordernumber/order/mon",
  getPartialStreetAddr:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/street?streetterm=",
  getCompleteAddress:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/address?addressid=",
  getProduct:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products",
  getProductEc:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/ecproductservice/accordion/products",
  getVoiceProductEc:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/ecproductservice/products",
  getSmartCartPersonalInfo:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/contactinfo/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/streetbyzip",
  getStreetAddrLocus2:
    "https://oa-stg.verizon.com/locus-typeahead/address/typeahead-address?streetterm=",
  locusapikey2: "YT2N6GkuOjvISXmvQUeSW5XA1MA990VF",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey1: "MvaCGJaWUOM1zkdFJietJiYyq15SJGdF",
  qualification5G:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addressqualification/address/fixedwirelesscoveragecheck",
  getTerms: "https://api-qa.ebiz.verizon.com/atomapi/v1/experience/exp/terms",
  getTermsAEM:
     "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getorderingtos.model.json",    
  getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos: "https://api-qa.ebiz.verizon.com/atomapi/v1/experience/exp/tos",
  getUnit:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/units",
  getUnitLocus:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-unit",
  getVZID:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/registryservice/registration/getVzid",
  getZipcode:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/zip",
  getvendorvisitdetails:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/sessionmanager/getvendorvisitdetails",
  validateVendorToken: 
    "https://wwwawssit.ebiz.verizon.com/inhome/validatevendortoken",
    fetchEmeriosInfo: 
    "https://wwwawssit.ebiz.verizon.com/inhome/fetchEmeriosInfo",
  checkPreLink:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/checkprelink?prelink=add",
  jsNotify:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/common/logger/logmsg",
  kafkaErrorAppLogs:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/common/kafka/atom_applogs",
  kafkaPageLogs:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/common/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/common/kafka/atom_visitdetails",
  learnCustomTv:
    "https://wwwawssit.ebiz.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://wwwawssit.ebiz.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://wwwawssit.ebiz.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl:
    "https://wwwawssit.ebiz.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/common/kafka/pageconfig",
  nsiNotify:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/nsinotification",
  orderConfirmation:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/experience/exp/getorderconfirmation",
  performEID:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/performeid",
  personlisationdmp:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/getvzdmptoak",
  pieUrl: "https://pie.uat.verizon.com/pie/v1",
  postCacheValue:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/experience/exp/updatecachestorage",
  processSave:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/smartcart/order/processsmartcart",
  productOffersUrl:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/offer/products/manual",
  profileCart:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/cart/cart/profile",
  rapurl: "https://wwwawssit.ebiz.verizon.com/orderinfo/?src=olo",
  chatDetails:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/chatdetails",
  referFrinedValidation:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/refreshPromotions",
  removePromoCode:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/removePromotions",
  resumeSmartCart:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/smartcart/order/resumesmartcart",
  retrieveQualdetails:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addressqualification/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/smartcart/order/retrievesmartcart",
  sameDaydelivery:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/storepickup/switch/samedaydelivery",
  seeFcpDetail:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/experience/exp/fcpspecialoffers",
  sendLofNotification:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/lofservice/lof/sendnotification",
  sendOTP:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/contactinfo/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/registryservice/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/common/notification/sendsmsoremail",
  setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/duedateservice/duedate/reserveduedate",
  smartAutoSave:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartsave",
  smartSave:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartsavewithparam",
  smartcartCancel:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartcancel",
  storePickUp:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/storepickup/switch/storepickup",
  submitOrder: "https://api-qa.ebiz.verizon.com/atomapi/v1/order/order/submit",
  tcChatUrl:
    "https://wwwawssit-collaborateext.ebiz.verizon.com/comm/includes/scripts/vztc.js",
  tokenGeneration: "/inhome/generatetoken",
  updateCartAcc:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateCartAccEc:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateintentcart:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/cart/cart/updateintent",
  updateintentcartAcc:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartEc:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/cart/cart/updateintent",
  uploadFile:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/employeeproof",
  updateFireAlarm:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/voice/firealarm",
  getFireAlarm:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/voice/getfirealarm",
  validateBillingAdress:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/billing/order/billing",
  validateContactInfo:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/contactinfo/order/contact",
  validateCouponToken:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/validatecoupontoken",
  validateEmployee:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/validateemployee",
  validateName:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/contactinfo/order/validateName",
  validateSigninUrl:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/validateSignin",
  validateSmartCartContactInfo:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/contactinfo/order/validateSmartCartContactInfo",
  validatecartUrl:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/cart/cart/validate/",
  validatecartUrlEc:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/validate/",
  vendorFlow:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/sessionmanager/vendorflowvalidate",
  vendorFlowToken:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/sessionmanager/vendortokencreate",
  vepsUrl: "https://api-qa.ebiz.verizon.com/atomapi/v1/veps/veps/payment",
  verifyOTP:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/contactinfo/ssocheck/verifyccpin",
  viewDetail:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/experience/exp/viewdetails",
  viewDetailAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/services/getlongdesc.fios",
  voicetn:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/phoneservices/phoneservices",
  vzFwdEnrollmentDetails: 
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addressqualification/address/enrollmentDetails",   
  twsSiginInDetails: 
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addressqualification/address/twsSiginInDetails",   
  vzwOfferEligibility:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getWirelessProduct",
  vzOrderInfo:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzorderservice/order/vzorderinfo",
  vzOrderDetail:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzorderservice/order/vzorderdetail",
  brtcInfo:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzorderservice/order/brtc",
  suppCancelCart:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/cart/cart/supp/",
  checkPDCdata:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/checkpdcdata",
  getSmartCartStatus:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartstatus",
    vz15gFlow:"https://api-qa.ebiz.verizon.com/atomapi/v1/sessionmanager/validate15recomm",
  mfrtnFlow:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/careflowservice/frontliners/save",
  mfrtnmoveEligibleCheck:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/careflowservice/frontliners/retrieve",
  mnhOneClickVzwAccountSave:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addressqualification/address/savewirelessaccountsystemobjectdetailstocache/",
    fiosQualification:
  "https://api-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/fiosqualification",
  mnhOneClickQualification:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addressqualification/mobileandhome/ecwlnewfiosqualification",
  mnhOneClickQualificationK8:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/sit/addressqualification/mobileandhome/ecwlnewfiosqualification",
  wlCustomerCheckoutInfo:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addressqualification/mobileandhome/wlcustomercheckoutinfo",
  mnhOneClickMarketingProfileSave:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addressqualification/address/savemaketingprofiledetailstocache/",
  mnhOneClickLoopQualSave:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addressqualification/address/saveloopqualtocache/",
  mnhOneClickLocusAddressValidationSave:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addressqualification/address/savelocusaddrvalidationdetailstocache/",
  mnhOneClickOneCreditSave:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/savesfiosonecreditdetailstocache/",
  mnhOneClickEncryptWirelessDataToken:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addressqualification/mobileandhome/encryptwirelessdatatoken",
  mnhOneClickMLP:
    "https://wwwawssit.ebiz.verizon.com/content/verizon/personal/services/fivegoneclick.nocache.html",
  ssoMHAuthiniticate:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk",
    fiosReferralCCAToken: "https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
    fiosReferralVerifyToken: "https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
    ssoMHEmailAuthiniticate:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",
  pollingIGBackendUrl:
    "https://securesit1.verizon.com/accessmanager/public/adaptiveauth/2fa/polling",
  verification:
    'https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/verification',
  ssoMHGetName:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname",
    ssoMHGetCustomerDetails:"https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getcustomerdetailsresponse",
  
  runtimeValuesUrl:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/common/pageflow/getruntimevalues?runtimekey=",
  storePickupCRP:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/notificationservice/whatsnext/storepickup",
  getProductPerks:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products",
  getPerksAEM:"https://wwwawssit.ebiz.verizon.com/content/caas/plan/aggregated-perks.model.json",
  getFccLabel:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/fccLabelData",
  getMovesThrottle: "https://api-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/nsathrottlelist",
  disconnectBanner: "https://sso-np.ebiz.verizon.com/consumer/myverizon/homeoffers",
  mvaDisconnectBanner: "https://www.verizon.com/consumer/fios/secure/ui/acct/homeoffers", 
  sendVisitId : "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/updateSSP/",
  hmpFindActiveSchedule:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/hmpDigital/findActiveSchedule",
  hmpEligibilityChecks:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/hmpDigital/hmpEligibilityChecks",
  hmpHome:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/optin",
  retailStoreDetails: "https://vzwqa2.sdc.vzwcorp.com/soe/digital/prospect/peripheralsservice/getClosingAgencyDetails",
  lookupReferralNumber: "https://vzwqa2.sdc.vzwcorp.com/soe/digital/prospect/peripheralsservice/lookupRetailCollaborationCode",
  getpzaiRatingNumber: "https://api-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/fiospzai",
  getCentralAgreementTermsAEM: "https://api-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/tosCentralAgreement",
    ...changesitApigee
};

const uatProxy = {
  Wireless5Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://atomcareflowuat.cfappsawsnpeast.ebiz.verizon.com/careflow/affinityvalidation",
  channelLineupPackageView:
    "https://atomchannellookupuat.cfappsawsnpeast.ebiz.verizon.com/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://atomchannellookupuat.cfappsawsnpeast.ebiz.verizon.com/channels/allpackages",
  channelLineupVhoUrl:
    "https://atomchannellookupuat.cfappsawsnpeast.ebiz.verizon.com/channels/vho",
  channelProgramMasterUrl:
    "https://atomchannellookupuat.cfappsawsnpeast.ebiz.verizon.com/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://atomchannellookupuat.cfappsawsnpeast.ebiz.verizon.com/channels/searchforchannelprogram",
  chatEncry: "Y",
  chatEncrypt:
    "https://atomchatinfouat.cfappsawsnpeast.ebiz.verizon.com/chatInfo/hvals",
  chatReint: "N",
  chatStore:
    "https://atomchatinfouat.cfappsawsnpeast.ebiz.verizon.com/chatInfo/storeChatInfo",
  checkAddr:
    "https://atomaddressqualificationuat.cfappsawsnpeast.ebiz.verizon.com/address/qualification?addressID=",
  checkportability:
    "https://atomtnportabilityuat.cfappsawsnpeast.ebiz.verizon.com/tnportability",
    updatebulkcart:
    "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/vendorexperience/vendorexperience/recommendedCart",
  clearCart:
    "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/accordion/clearcart",
  clearCartEC:
    "https://atomcartecuat.cfappsawsnpeast.ebiz.verizon.com/cart/accordion/clearcartec",
  compareCart:
    "https://atomcartuat.cfappsawsnpeast.ebiz.verizon.com/cart/accordion/compare",
  configEntry:
    "https://wwwawsuat.ebiz.verizon.com/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://wwwawsuat.ebiz.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://wwwawsuat.ebiz.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId:
    "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/sessionmanager/visitid",
  creditAssessment:
    "https://atomcreditcheckuat.cfappsawsnpeast.ebiz.verizon.com/creditcheck/creditfiosassessment",
  creditCheck:
    "https://atomcreditcheckuat.cfappsawsnpeast.ebiz.verizon.com/creditcheck/creditworthiness",
  creditRefresh:
    "https://atomcreditcheckuat.cfappsawsnpeast.ebiz.verizon.com/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://atomcreditcheckuat.cfappsawsnpeast.ebiz.verizon.com/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://atomaccountqualificationuat.cfappsawsnpeast.ebiz.verizon.com/account/decryptData",
  dobundle:
    "https://atomproductuat.cfappsawsnpeast.ebiz.verizon.com/products/dobundle",
    vecorder:
    "https://atomproductuat.cfappsawsnpeast.ebiz.verizon.com/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "/inhome/ecFooter",
  ecHeader: "/inhome/ecHeader",
  encryptUrl:
    "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/accountqualification/account/encryptData",
  fbeGetSoc:
    "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/experience/exp/getSoc",
  fbePostSoc:
    "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/soc/fbe/PostSoc",
  futurenotification:
    "https://atomaddresslookupuat.cfappsawsnpeast.ebiz.verizon.com/addresses/futurenotification",
  generateToken:
    "https://atomcareflowuat.cfappsawsnpeast.ebiz.verizon.com/careflow/gettoken",
  getAccount:
    "https://atomsessionmanageruat.cfappsawsnpeast.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account",
  getBanners:
    "https://atomexperienceuat.cfappsawsnpeast.ebiz.verizon.com/exp/banners",
  getCacheValue:
    "https://atomexperienceuat.cfappsawsnpeast.ebiz.verizon.com/exp/getcachevalue",
  getCartAcc:
    "https://atomcartuat.cfappsawsnpeast.ebiz.verizon.com/cart/accordion",
  getCartAccEc:
    "https://atomcartecuat.cfappsawsnpeast.ebiz.verizon.com/cart/accordion",
  getDisclaimer:
    "https://atomexperienceuat.cfappsawsnpeast.ebiz.verizon.com/exp/disclaimer",
  getDisclaimerAEM:
    "https://www98.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getDisclaimerProducts:
    "https://atomexperienceuat.cfappsawsnpeast.ebiz.verizon.com/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://atomexperienceuat.cfappsawsnpeast.ebiz.verizon.com/exp/commondisclaimer",
  getCommonAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getPlansPromo:
    "https://atomexperienceuat.cfappsawsnpeast.ebiz.verizon.com/exp/planspromo",
  getPlansPromoAEM:
    "https://www98.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDueDate:
    "https://atomduedateuat.cfappsawsnpeast.ebiz.verizon.com/duedate/triggerduedate",
  getExistingService:
    "https://atomaddresslookupuat.cfappsawsnpeast.ebiz.verizon.com/addresses/existingservice",
  getFaq: "https://atomexperienceuat.cfappsawsnpeast.ebiz.verizon.com/exp/faq",
  getFaqAEM:
    "https://www98.verizon.com/personal/cas/getfaq.model.json",
  getMon: "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/mon/order/mon",
  getPartialStreetAddr:
    "https://atomaddresslookupuat.cfappsawsnpeast.ebiz.verizon.com/addresses/street?streetterm=",
  getCompleteAddress:
    "https://atomaddresslookupuat.cfappsawsnpeast.ebiz.verizon.com/addresses/address?addressid=",
  getProduct:
    "https://atomproductuat.cfappsawsnpeast.ebiz.verizon.com/accordion/products",
  getProductEc:
    "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/productec/accordion/products",
  getVoiceProductEc:
    "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/productec/products",
  getSmartCartPersonalInfo:
    "https://atomcontactinfovalidationuat.cfappsawsnpeast.ebiz.verizon.com/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://atomaddresslookupuat.cfappsawsnpeast.ebiz.verizon.com/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "VAiecKGNC721VnSn9fQrmpMumsdxZYu3",
  getStreetAddrLocus2:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "MvaCGJaWUOM1zkdFJietJiYyq15SJGdF",
  qualification5G:
    "https://atomaddressqualificationuat.cfappsawsnpeast.ebiz.verizon.com/address/fixedwirelesscoveragecheck",
  getTerms:
    "https://atomexperienceuat.cfappsawsnpeast.ebiz.verizon.com/exp/terms",
  getTermsAEM:
     "https://wwwawssit.ebiz.verizon.com/personal/cas/getorderingtos.model.json",
    getCentralAgreementTermsAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement~html.json",
getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos: "https://atomexperienceuat.cfappsawsnpeast.ebiz.verizon.com/exp/tos",
  getUnit:
    "https://atomaddresslookupuat.cfappsawsnpeast.ebiz.verizon.com/addresses/units",
  getUnitLocus:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-unit",
  getUpsell:
    "https://atomproductuat.cfappsawsnpeast.ebiz.verizon.com/accordion/products/upsell/",
  getVZID:
    "https://atomregistrationuat.cfappsawsnpeast.ebiz.verizon.com/registration/getVzid",
  getZipcode:
    "https://atomaddresslookupuat.cfappsawsnpeast.ebiz.verizon.com/addresses/zip",
  getvendorvisitdetails:
    "https://atomsessionmanageruat.cfappsawsnpeast.ebiz.verizon.com/getvendorvisitdetails",
  jsNotify:
    "https://atomcommonuat.cfappsawsnpeast.ebiz.verizon.com/common/logger/logmsg",
  kafkaErrorAppLogs:
    "https://atomcommonuat.cfappsawsnpeast.ebiz.verizon.com/kafka/atom_applogs",
  kafkaPageLogs:
    "https://atomcommonuat.cfappsawsnpeast.ebiz.verizon.com/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://atomcommonuat.cfappsawsnpeast.ebiz.verizon.com/kafka/atom_visitdetails",
  learnCustomTv:
    "https://wwwawsuat.ebiz.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://sit-activate.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://atomvendorexperienceuat.cfappsawsnpeast.ebiz.verizon.com/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://sit-activate.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl: "https://sit-activate.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://atomcommonuat.cfappsawsnpeast.ebiz.verizon.com/kafka/pageconfig",
  nsiNotify:
    "https://atomaddresslookupuat.cfappsawsnpeast.ebiz.verizon.com/addresses/nsinotification",
  orderConfirmation:
    "https://atomexperienceuat.cfappsawsnpeast.ebiz.verizon.com/exp/getorderconfirmation",
  performEID:
    "https://atomcreditcheckuat.cfappsawsnpeast.ebiz.verizon.com/creditcheck/performeid",
  personlisationdmp:
    "https://atompersonalisationuat.cfappsawsnpeast.ebiz.verizon.com/personalization/getvzdmptoak",
  pieUrl: "https://pie.uat.verizon.com/pie/v1",
  postCacheValue:
    "https://atomexperienceuat.cfappsawsnpeast.ebiz.verizon.com/exp/updatecachestorage",
  processSave:
    "https://atomsmartcartuat.cfappsawsnpeast.ebiz.verizon.com/order/processsmartcart",
  productOffersUrl:
    "https://atomproductuat.cfappsawsnpeast.ebiz.verizon.com/offer/products/manual",
  profileCart:
    "https://atomcartecuat.cfappsawsnpeast.ebiz.verizon.com/cart/profile",
  rapurl: "https://wwwawsuat.ebiz.verizon.com/orderinfo/?src=olo",
  chatDetails:
    "https://atomchatinfouat.cfappsawsnpeast.ebiz.verizon.com/chatInfo/chatdetails",
  referFrinedValidation:
    "https://atomchatinfouat.cfappsawsnpeast.ebiz.verizon.com/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://atomvzwoffereligibilityuat.cfappsawsnpeast.ebiz.verizon.com/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://atomproductuat.cfappsawsnpeast.ebiz.verizon.com/products/refreshPromotions",
  removePromoCode:
    "https://atomproductuat.cfappsawsnpeast.ebiz.verizon.com/products/removePromotions",
  resumeSmartCart:
    "https://atomsmartcartuat.cfappsawsnpeast.ebiz.verizon.com/order/resumesmartcart",
  retrieveQualdetails:
    "https://atomaddressqualificationuat.cfappsawsnpeast.ebiz.verizon.com/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://atomsmartcartuat.cfappsawsnpeast.ebiz.verizon.com/order/retrievesmartcart",
  sameDaydelivery:
    "https://atomstorepickupuat.cfappsawsnpeast.ebiz.verizon.com/switch/samedaydelivery",
  seeFcpDetail:
    "https://atomexperienceuat.cfappsawsnpeast.ebiz.verizon.com/exp/fcpspecialoffers",
  sendLofNotification:
    "https://atomlofuat.cfappsawsnpeast.ebiz.verizon.com/lof/sendnotification",
  sendOTP:
    "https://atomssocheckuat.cfappsawsnpeast.ebiz.verizon.com/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://atomregistrationuat.cfappsawsnpeast.ebiz.verizon.com/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://atomcommonuat.cfappsawsnpeast.ebiz.verizon.com/notification/sendsmsoremail",
  setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://atomduedateuat.cfappsawsnpeast.ebiz.verizon.com/duedate/reserveduedate",
  smartAutoSave:
    "https://atomsmartcartuat.cfappsawsnpeast.ebiz.verizon.com/order/smartcartsave",
  smartSave:
    "https://atomsmartcartuat.cfappsawsnpeast.ebiz.verizon.com/order/smartcartsavewithparam",
  smartcartCancel:
    "https://atomsmartcartuat.cfappsawsnpeast.ebiz.verizon.com/order/smartcartcancel",
  getSmartCartStatus:
    "https://atomsmartcartuat.cfappsawsnpeast.ebiz.verizon.com/order/smartcartstatus",
  storePickUp:
    "https://atomstorepickupuat.cfappsawsnpeast.ebiz.verizon.com/switch/storepickup",
  submitOrder:
    "https://atomordersubmissionuat.cfappsawsnpeast.ebiz.verizon.com/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  updateCartAcc:
    "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/accordion/updatecart",
  updateCartAccEc:
    "https://atomcartecuat.cfappsawsnpeast.ebiz.verizon.com/cart/accordion/updatecart",
  updateintentcart:
    "https://atomcartuat.cfappsawsnpeast.ebiz.verizon.com/cart/updateintent",
  updateintentcartAcc:
    "https://atomcartuat.cfappsawsnpeast.ebiz.verizon.com/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://atomcartecuat.cfappsawsnpeast.ebiz.verizon.com/cart/accordion/updateintent",
  updateintentcartEc:
    "https://atomcartecuat.cfappsawsnpeast.ebiz.verizon.com/cart/updateintent",
  uploadFile:
    "https://atomcareflowuat.cfappsawsnpeast.ebiz.verizon.com/careflow/employeeproof",
  validateBillingAdress:
    "https://atombillingvalidationuat.cfappsawsnpeast.ebiz.verizon.com/order/billing",
  validateContactInfo:
    "https://atomcontactinfovalidationuat.cfappsawsnpeast.ebiz.verizon.com/order/contact",
  validateCouponToken:
    "https://atomcareflowuat.cfappsawsnpeast.ebiz.verizon.com/careflow/validatecoupontoken",
  validateEmployee:
    "https://atomcareflowuat.cfappsawsnpeast.ebiz.verizon.com/careflow/validateemployee",
  validateName:
    "https://atomcontactinfovalidationuat.cfappsawsnpeast.ebiz.verizon.com/order/validateName",
  validateSigninUrl:
    "https://atomaccountqualificationuat.cfappsawsnpeast.ebiz.verizon.com/account/validateSignin",
  validateSmartCartContactInfo:
    "https://atomcontactinfovalidationuat.cfappsawsnpeast.ebiz.verizon.com/order/validateSmartCartContactInfo",
  validatecartUrl:
    "https://atomcartuat.cfappsawsnpeast.ebiz.verizon.com/cart/validate/",
  validatecartUrlEc:
    "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/accordion/validate/",
  vendorFlow:
    "https://atomsessionmanageruat.cfappsawsnpeast.ebiz.verizon.com/vendorflowvalidate",
  vendorFlowToken:
    "https://atomsessionmanageruat.cfappsawsnpeast.ebiz.verizon.com/vendortokencreate",
  vepsUrl: "https://atomvepsuat.cfappsawsnpeast.ebiz.verizon.com/veps/payment",
  verifyOTP:
    "https://atomssocheckuat.cfappsawsnpeast.ebiz.verizon.com/ssocheck/verifyccpin",
  viewDetail:
    "https://atomexperienceuat.cfappsawsnpeast.ebiz.verizon.com/exp/viewdetails",
  viewDetailAEM:
    "https://www98.verizon.com/personal/services/getlongdesc.fios",
  voicetn:
    "https://atomphoneservicesuat.cfappsawsnpeast.ebiz.verizon.com/phoneservices",
  vzFwdEnrollmentDetails: 
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/enrollmentDetails", 
  twsSiginInDetails: 
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/twsSiginInDetails",  
  vzwOfferEligibility:
    "https://atomvzwoffereligibilityuat.cfappsawsnpeast.ebiz.verizon.com/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://atomvzwoffereligibilityuat.cfappsawsnpeast.ebiz.verizon.com/eligibility/getWirelessProduct",
  vzOrderInfo:
    "https://atomserviceseastuat.ebiz.verizon.com/v05g/sit/vzorder/order/vzorderinfo",
  vzOrderDetail:
    "https://atomserviceseastuat.ebiz.verizon.com/v05g/sit/vzorder/order/vzorderdetail",
  brtcInfo:
    "https://atomserviceseastuat.ebiz.verizon.com/v05g/sit/vzorder/order/brtc",
  suppCancelCart:
    "https://atomserviceseastuat.ebiz.verizon.com/v05g/sit/cart/cart/supp/",
  checkPDCdata:
    "https://atompersonalisationuat.cfappsawsnpeast.ebiz.verizon.com/personalization/checkpdcdata",
  mfrtnFlow:
    "https://atomserviceseastuat.ebiz.verizon.com/v05g/stg/careflow/frontliners/save",
  ssoMHAuthiniticate:
    "https://atomserviceseastuat.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://atomserviceseastuat.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk",
    fiosReferralCCAToken: "https://atomserviceseastuat.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
    fiosReferralVerifyToken: "https://atomserviceseastuat.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
  ssoMHEmailAuthiniticate:
    "https://atomserviceseastuat.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",
  pollingIGBackendUrl:
    "https://securesit1.verizon.com/accessmanager/public/adaptiveauth/2fa/polling",
  ssoMHGetName:
    "https://atomserviceseastuat.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname", 
    ssoMHGetCustomerDetails:"https://atomserviceseastuat.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getcustomerdetailsresponse",
    
    runtimeValuesUrl:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/common/pageflow/getruntimevalues?runtimekey=",
    disconnectBanner: "https://sso-np.ebiz.verizon.com/consumer/myverizon/homeoffers",
    mvaDisconnectBanner: "https://www.verizon.com/consumer/fios/secure/ui/acct/homeoffers", 
    hmpFindActiveSchedule:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/hmpDigital/findActiveSchedule",
    hmpEligibilityChecks:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/hmpDigital/hmpEligibilityChecks",
    hmpHome:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/optin",
    retailStoreDetails: "https://vzwqa2.sdc.vzwcorp.com/soe/digital/prospect/peripheralsservice/getClosingAgencyDetails",
    lookupReferralNumber: "https://vzwqa2.sdc.vzwcorp.com/soe/digital/prospect/peripheralsservice/lookupRetailCollaborationCode",
    getPerksAEM:"https://wwwawssit.ebiz.verizon.com/content/caas/plan/aggregated-perks.model.json",
    getpzaiRatingNumber: "https://api-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/fiospzai",
    ...changeUATProxy
};

/*const uatApigee = {
  MyVzSigninAF:
    "https://sit-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://wwwawssit.ebiz.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fsit-ssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fsso-np.ebiz.verizon.com%252fconsumer%252fmyverizon%252frouter%253ftarget%253dhttps%25253a%25252f%25252fwwwawssit.ebiz.verizon.com%25252fforyourhome%25252fordering%25252fmyverizonnew%25252fregistrationbridge.aspx%25253f",
  MyVzSigninMV98:"https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www98.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fwww98.verizon.com%2fconsumer%2fmyverizon%2frouter%3ftarget%3dhttps%253a%252f%252fwww98.verizon.com%252finhome%252fmoves%252fqualification%253fismvflow%253dy",
  MyVzSigninMV:
    "https://sit-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://wwwawssit.ebiz.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fsit-ssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fsso-np.ebiz.verizon.com%252fconsumer%252fmyverizon%252frouter%253ftarget%253dhttps%25253a%25252f%25252fwwwawssit.ebiz.verizon.com%25252fforyourhome%25252fordering%25252fcheckavailabilitylq.aspx%25253fismvflow%25253dy",
  Wireless5Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/affinityvalidation",
  accessToken: "https://oa-uat.ebiz.verizon.com/oauth/client_credential/accesstoken",
  getConsumerKey:"NY3FfzZUOlIUBN21MPzbqlBEel7g8aKG",
  getConsumerSecret:"X10eUvJa42wNpa3u",
  getFiosQualification: "https://wwwawsuat.ebiz.verizon.com/foryoursmallbiz/smb/api/Qualify/GetFiosQualification",
  channelLineupPackageView:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/channellookup/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/channellookup/channels/allpackages",
  channelLineupVhoUrl:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/channellookup/channels/vho",
  channelProgramMasterUrl:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/channellookup/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/channellookup/channels/searchforchannelprogram",
  chatEncry: "Y",
  validatepartner: "/inhome/validatepartner",
  chatEncrypt:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/hvals",
  chatReint: "N",
  chatStore:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/storeChatInfo",
  checkAddr:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addressqualification/address/qualification?addressID=",
  fiosMnhFetch:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addressqualification/address/fiosmnh",
  checkportability:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/tnportability/tnportability",
    updatebulkcart:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/recommendedCart",
  clearCart:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/clearcart",
  clearCartEC:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/clearcartec",
  compareCart:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/compare",
  configEntry:
    "https://wwwawsuat.ebiz.verizon.com/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://wwwawsuat.ebiz.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://wwwawsuat.ebiz.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId: "/inhome/generatevisitid",
  creditAssessment:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditfiosassessment",
  creditCheck:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditworthiness",
  creditRefresh:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/decryptData",
  dobundle:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/dobundle",
    vecorder:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "/inhome/ecFooter",
  ecHeader: "/inhome/ecHeader",
  encryptUrl:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/encryptData",
  fbeGetSoc: "https://api-dev.ebiz.verizon.com/atomapi/v1/experience/exp/getSoc",
  fbePostSoc: "https://api-dev.ebiz.verizon.com/atomapi/v1/soc/fbe/PostSoc",
  futurenotification:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/futurenotification",
  generateToken:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/gettoken",
  getAccount:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account",
  getBanners:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/experience/exp/banners",
  getCacheValue:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/experience/exp/getcachevalue",
  getCartAcc: "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion",
  getCartAccEc:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion",
  getDisclaimer:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/experience/exp/disclaimer",
  getDisclaimerAEM:
    "https://www98.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getPlansPromo:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/experience/exp/planspromo",
  getPlansPromoAEM:
    "https://www98.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDisclaimerProducts:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/experience/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/experience/exp/commondisclaimer",
  getCommonAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getDueDate:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/duedateservice/duedate/triggerduedate",
  getExistingService:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/existingservice",
  getFaq: "https://api-dev.ebiz.verizon.com/atomapi/v1/experience/exp/faq",
  getFaqAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getfaq.model.json",
  getMon:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/masterordernumber/order/mon",
  getPartialStreetAddr:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/street?streetterm=",
  getCompleteAddress:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/address?addressid=",
  getProduct:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products",
  getProductEc:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/ecproductservice/accordion/products",
  getVoiceProductEc:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/ecproductservice/products",
  getSmartCartPersonalInfo:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/contactinfo/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "VAiecKGNC721VnSn9fQrmpMumsdxZYu3",
  getStreetAddrLocus2:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "MvaCGJaWUOM1zkdFJietJiYyq15SJGdF",
  qualification5G:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addressqualification/address/fixedwirelesscoveragecheck",
  getTerms: "https://api-dev.ebiz.verizon.com/atomapi/v1/experience/exp/terms",
  getTermsAEM:
     "https://wwwawssit.ebiz.verizon.com/personal/cas/getorderingtos.model.json",
    getCentralAgreementTermsAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement~html.json",
getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos: "https://api-dev.ebiz.verizon.com/atomapi/v1/experience/exp/tos",
  getUnit:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/units",
  getUnitLocus:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-unit",
  getUpsell:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/upsell/",
  getVZID:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/registryservice/registration/getVzid",
  getZipcode:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/zip",
  getvendorvisitdetails:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/sessionmanager/getvendorvisitdetails",
    jsNotify:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/common/logger/logmsg",
  kafkaErrorAppLogs:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/common/kafka/atom_applogs",
  kafkaPageLogs:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/common/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/common/kafka/atom_visitdetails",
  learnCustomTv:
    "https://wwwawsuat.ebiz.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://sit-activate.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://sit-activate.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl: "https://sit-activate.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/common/kafka/pageconfig",
  nsiNotify:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/nsinotification",
  orderConfirmation:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/experience/exp/getorderconfirmation",
  performEID:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/performeid",
  personlisationdmp:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/getvzdmptoak",
  pieUrl: "https://pie.uat.verizon.com/pie/v1",
  postCacheValue:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/experience/exp/updatecachestorage",
  processSave:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/smartcart/order/processsmartcart",
  productOffersUrl:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/qualifiedproducts/offer/products/manual",
  profileCart:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/profile",
  rapurl: "https://wwwawsuat.ebiz.verizon.com/orderinfo/?src=olo",
  chatDetails:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/chatdetails",
  referFrinedValidation:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/refreshPromotions",
  removePromoCode:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/removePromotions",
  resumeSmartCart:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/smartcart/order/resumesmartcart",
  retrieveQualdetails:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addressqualification/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/smartcart/order/retrievesmartcart",
  sameDaydelivery:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/storepickup/switch/samedaydelivery",
  seeFcpDetail:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/experience/exp/fcpspecialoffers",
  sendLofNotification:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/lofservice/lof/sendnotification",
  sendOTP:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/contactinfo/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/registryservice/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/common/notification/sendsmsoremail",
  setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/duedateservice/duedate/reserveduedate",
  smartAutoSave:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartsave",
  smartSave:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartsavewithparam",
  smartcartCancel:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartcancel",
  getSmartCartStatus:
    " https://api-dev.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartstatus",
  storePickUp:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/storepickup/switch/storepickup",
  submitOrder: "https://api-dev.ebiz.verizon.com/atomapi/v1/order/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  tokenGeneration: "/inhome/generatetoken",
  updateCartAcc:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateCartAccEc:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateintentcart:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/updateintent",
  updateintentcartAcc:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartEc:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/updateintent",
  uploadFile:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/employeeproof",
  validateBillingAdress:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/billing/order/billing",
  validateContactInfo:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/contactinfo/order/contact",
  validateCouponToken:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/validatecoupontoken",
  validateEmployee:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/validateemployee",
  validateName:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/contactinfo/order/validateName",
  validateSigninUrl:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/validateSignin",
  validateSmartCartContactInfo:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/contactinfo/order/validateSmartCartContactInfo",
  validatecartUrl:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/validate/",
  validatecartUrlEc:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/validate/",
  vendorFlow:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/sessionmanager/vendorflowvalidate",
  vendorFlowToken:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/sessionmanager/vendortokencreate",
  vepsUrl: "https://api-dev.ebiz.verizon.com/atomapi/v1/veps/veps/payment",
  verifyOTP:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/contactinfo/ssocheck/verifyccpin",
  viewDetail:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/experience/exp/viewdetails",
  viewDetailAEM:
    "https://www98.verizon.com/personal/services/getlongdesc.fios",
  voicetn:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/phoneservices/phoneservices",
  vzFwdEnrollmentDetails: 
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addressqualification/address/enrollmentDetails", 
  twsSiginInDetails: 
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addressqualification/address/twsSiginInDetails",   
  vzwOfferEligibility:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getWirelessProduct",
  vzOrderInfo:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/vzorderservice/order/vzorderinfo",
  vzOrderDetail:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/vzorderservice/order/vzorderdetail",
  brtcInfo:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/vzorderservice/order/brtc",
  suppCancelCart: 
    "https://api-dev.ebiz.verizon.com/atomapi/v1/cart/cart/supp/",
  checkPDCdata:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/checkpdcdata",
  mnhOneClickVzwAccountSave:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addressqualification/address/savewirelessaccountsystemobjectdetailstocache/",
  mnhOneClickQualification:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addressqualification/mobileandhome/ecwlnewfiosqualification",
  wlCustomerCheckoutInfo:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addressqualification/mobileandhome/wlcustomercheckoutinfo",
  mnhOneClickMarketingProfileSave:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addressqualification/address/savemaketingprofiledetailstocache/",
  mnhOneClickLoopQualSave:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addressqualification/address/saveloopqualtocache/",
  mnhOneClickLocusAddressValidationSave:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addressqualification/address/savelocusaddrvalidationdetailstocache/",
  mnhOneClickOneCreditSave:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/savesfiosonecreditdetailstocache/",
  mnhOneClickEncryptWirelessDataToken:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/addressqualification/mobileandhome/encryptwirelessdatatoken",
  mnhOneClickMLP:
    "https://www98.verizon.com/content/verizon/personal/services/fivegoneclick.nocache.html",
  ssoMHAuthiniticate:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk",
    fiosReferralCCAToken: "https://api-dev.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
    fiosReferralVerifyToken: "https://api-dev.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
    ssoMHEmailAuthiniticate:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",
  pollingIGBackendUrl:
    "https://securesit1.verizon.com/accessmanager/public/adaptiveauth/2fa/polling",
  ssoMHGetName:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname",     
    runtimeValuesUrl:
    "https://api-dev.ebiz.verizon.com/atomapi/v1/common/pageflow/getruntimevalues?runtimekey=",
  disconnectBanner: "https://sso-np.ebiz.verizon.com/consumer/myverizon/homeoffers",
  mvaDisconnectBanner: "https://www.verizon.com/consumer/fios/secure/ui/acct/homeoffers", 
  hmpFindActiveSchedule:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/hmpDigital/findActiveSchedule",
  hmpEligibilityChecks:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/hmpDigital/hmpEligibilityChecks",
  hmpHome:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/optin",
  retailStoreDetails: "https://vzwqa2.sdc.vzwcorp.com/soe/digital/prospect/peripheralsservice/getClosingAgencyDetails",
  getPerksAEM:"https://wwwawssit.ebiz.verizon.com/content/caas/plan/aggregated-perks.model.json",
  ...changeUATApigee
};*/

const stageProxy = {
  PnSubsctiption:"https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/personalisation/personalization/subscribe",
  SaveSegment: "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/personalisation/personalization/segment",
  SaveCampaign: "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/personalisation/personalization/campaign",  
  Wireless5Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
 Lte4Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
 fiosQualification:
  "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/addresslookup/addresses/fiosqualification",
  updatebulkcart:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/vendorexperience/vendorexperience/recommendedCart",
    vz15gFlow:"https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/sessionmanager/validate15recomm",
  careFlowFormValidation:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/affinityvalidation",
  channelLineupPackageView:
    "https://atomchannellookupstg.cfappsawsnpwest.ebiz.verizon.com/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://atomchannellookupstg.cfappsawsnpwest.ebiz.verizon.com/channels/allpackages",
  channelLineupVhoUrl:
    "https://atomchannellookupstg.cfappsawsnpwest.ebiz.verizon.com/channels/vho",
  channelProgramMasterUrl:
    "https://atomchannellookupstg.cfappsawsnpwest.ebiz.verizon.com/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://atomchannellookupstg.cfappsawsnpwest.ebiz.verizon.com/channels/searchforchannelprogram",
  chatEncry: "Y",
  chatEncrypt:
    "https://atomchatinfostg.cfappsawsnpwest.ebiz.verizon.com/chatInfo/hvals",
  chatReint: "Y",
  chatStore:
    "https://atomchatinfostg.cfappsawsnpwest.ebiz.verizon.com/chatInfo/storeChatInfo",
  checkAddr:
    "https://atomaddressqualificationstg.cfappsawsnpwest.ebiz.verizon.com/address/qualification?addressID=",
  checkportability:
    "https://atomtnportabilitystg.cfappsawsnpwest.ebiz.verizon.com/tnportability",
  clearCart:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/clearcart",
  clearCartEC:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/clearcartec",
  compareCart:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/compare",
  configEntry:
    "https://www98.verizon.com/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://www98.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://www98.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId:
    "https://atomsessionmanagerstg.cfappsawsnpwest.ebiz.verizon.com/visitid",
  creditAssessment:
    "https://atomcreditcheckstg.cfappsawsnpwest.ebiz.verizon.com/creditcheck/creditfiosassessment",
  creditCheck:
    "https://atomcreditcheckstg.cfappsawsnpwest.ebiz.verizon.com/creditcheck/creditworthiness",
  creditRefresh:
    "https://atomcreditcheckstg.cfappsawsnpwest.ebiz.verizon.com/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://atomcreditcheckstg.cfappsawsnpwest.ebiz.verizon.com/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://atomaccountqualificationstg.cfappsawsnpwest.ebiz.verizon.com/account/decryptData",
  dobundle:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/products/dobundle",
    vecorder:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "https://www98.verizon.com/includes/commongf/",
  ecHeader: "https://www98.verizon.com/includes/commongh/",
  encryptUrl:
    "https://atomaccountqualificationstg.cfappsawsnpwest.ebiz.verizon.com/account/encryptData",
  fbeGetSoc:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/getSoc",
  fbePostSoc: "https://atomsocstg.cfappsawsnpwest.ebiz.verizon.com/fbe/PostSoc",
  futurenotification:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/futurenotification",
  generateToken:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/gettoken",
  getAccount:
    "https://atomsessionmanagerstg.cfappsawsnpwest.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account",
  getBanners:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/banners",
  getCacheValue:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/getcachevalue",
  getCartAcc:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion",
  getCartAccEc:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion",
  getDisclaimer:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/disclaimer",
  getDisclaimerAEM:
    "https://www98.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getDisclaimerProducts:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://preprod-east-gz.vpc.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/commondisclaimer",
  getCommonAEM:
    "https://preprod-east-gz.vpc.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getPlansPromo:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/planspromo",
  getPlansPromoAEM:
    "https://www98.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDueDate:
    "https://atomduedatestg.cfappsawsnpwest.ebiz.verizon.com/duedate/triggerduedate",
  getExistingService:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/existingservice",
  getFaq: "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/faq",
  getFaqAEM:
    "https://www98.verizon.com/personal/cas/getfaq.model.json",
  getMon: "https://atommonstg.cfappsawsnpwest.ebiz.verizon.com/order/mon",
  getPartialStreetAddr:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/street?streetterm=",
  getCompleteAddress:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/address?addressid=",
  getProduct:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/accordion/products",
  getProductEc:
    "https://atomproductecexpstg.cfappsawsnpwest.ebiz.verizon.com/accordion/products",
  getVoiceProductEc:
    "https://atomproductecexpstg.cfappsawsnpwest.ebiz.verizon.com/products",
  getSmartCartPersonalInfo:
    "https://atomcontactinfovalidationstg.cfappsawsnpwest.ebiz.verizon.com/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "VAiecKGNC721VnSn9fQrmpMumsdxZYu3",
  getStreetAddrLocus2:
    "https://oa-stg.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "YT2N6GkuOjvISXmvQUeSW5XA1MA990VF",
  qualification5G:
    "https://atomaddressqualificationstg.cfappsawsnpwest.ebiz.verizon.com/address/fixedwirelesscoveragecheck",
  getTerms:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/terms",
  getTermsAEM:
    "https://preprod-east-gz.vpc.verizon.com/personal/cas/getorderingtos.model.json", 
 
getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos: "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/tos",
  getUnit:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/units",
  getUnitLocus:
    "https://oa-stg.verizon.com/locus-address-api/address/typeahead-unit",
  getVZID:
    "https://atomregistrationstg.cfappsawsnpwest.ebiz.verizon.com/registration/getVzid",
  getZipcode:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/zip",
  getvendorvisitdetails:
    "https://atomsessionmanagerstg.cfappsawsnpwest.ebiz.verizon.com/getvendorvisitdetails",
  validateVendorToken: 
    "https://www98.verizon.com/inhome/validatevendortoken",
    fetchEmeriosInfo: 
    "https://www98.verizon.com/inhome/fetchEmeriosInfo",
  checkPreLink:
    "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/checkprelink?prelink=add",  
  jsNotify:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/logger/logmsg",
  kafkaErrorAppLogs:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/kafka/atom_applogs",
  kafkaPageLogs:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/kafka/atom_visitdetails",
  learnCustomTv: "https://www98.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://sit-activate.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://atomvendorexperiencestg.cfappsawsnpwest.ebiz.verizon.com/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://sit-activate.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl: "https://sit-activate.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/kafka/pageconfig",
  nsiNotify:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/nsinotification",
  orderConfirmation:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/getorderconfirmation",
  performEID:
    "https://atomcreditcheckstg.cfappsawsnpwest.ebiz.verizon.com/creditcheck/performeid",
  personlisationdmp:
    "https://atompersonalisationstg.cfappsawsnpwest.ebiz.verizon.com/personalization/getvzdmptoak",
  pieUrl: "https://pie.uat.verizon.com/pie/v1",
  postCacheValue:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/updatecachestorage",
  processSave:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/processsmartcart",
  productOffersUrl:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/offer/products/manual",
  profileCart:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/profile",
  rapurl: "https://stglov-activate.verizon.com/orderinfo/?src=olo",
  chatDetails:
    "https://atomchatinfostg.cfappsawsnpwest.ebiz.verizon.com/chatInfo/chatdetails",
  referFrinedValidation:
    "https://atomchatinfostg.cfappsawsnpwest.ebiz.verizon.com/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://atomvzwoffereligibilitystg.cfappsawsnpwest.ebiz.verizon.com/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/products/refreshPromotions",
  removePromoCode:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/products/removePromotions",
  resumeSmartCart:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/resumesmartcart",
  retrieveQualdetails:
    "https://atomaddressqualificationstg.cfappsawsnpwest.ebiz.verizon.com/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/retrievesmartcart",
  sameDaydelivery:
    "https://atomstorepickupstg.cfappsawsnpwest.ebiz.verizon.com/switch/samedaydelivery",
  seeFcpDetail:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/fcpspecialoffers",
  sendLofNotification:
    "https://atomlofstg.cfappsawsnpwest.ebiz.verizon.com/lof/sendnotification",
  sendOTP:
    "https://atomssocheckstg.cfappsawsnpwest.ebiz.verizon.com/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://atomregistrationstg.cfappsawsnpwest.ebiz.verizon.com/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/notification/sendsmsoremail",
  setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://atomduedatestg.cfappsawsnpwest.ebiz.verizon.com/duedate/reserveduedate",
  smartAutoSave:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/smartcartsave",
  smartSave:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/smartcartsavewithparam",
  smartcartCancel:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/smartcartcancel",
  getSmartCartStatus:
    " https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/smartcartstatus",
  storePickUp:
    "https://atomstorepickupstg.cfappsawsnpwest.ebiz.verizon.com/switch/storepickup",
  submitOrder:
    "https://atomordersubmissionstg.cfappsawsnpwest.ebiz.verizon.com/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  updateCartAcc:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/updatecart",
  updateCartAccEc:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/updatecart",
  updateintentcart:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/updateintent",
  updateintentcartAcc:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/updateintent",
  updateintentcartEc:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/updateintent",
  uploadFile:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/employeeproof",
  validateBillingAdress:
    "https://atombillingvalidationstg.cfappsawsnpwest.ebiz.verizon.com/order/billing",
  validateContactInfo:
    "https://atomcontactinfovalidationstg.cfappsawsnpwest.ebiz.verizon.com/order/contact",
  validateCouponToken:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/validatecoupontoken",
  validateEmployee:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/validateemployee",
  validateName:
    "https://atomcontactinfovalidationstg.cfappsawsnpwest.ebiz.verizon.com/order/validateName",
  validateSigninUrl:
    "https://atomaccountqualificationstg.cfappsawsnpwest.ebiz.verizon.com/account/validateSignin",
  validateSmartCartContactInfo:
    "https://atomcontactinfovalidationstg.cfappsawsnpwest.ebiz.verizon.com/order/validateSmartCartContactInfo",
  validatecartUrl:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/validate/",
  validatecartUrlEc:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/validate/",
  vendorFlow:
    "https://atomsessionmanagerstg.cfappsawsnpwest.ebiz.verizon.com/vendorflowvalidate",
  vendorFlowToken:
    "https://atomsessionmanagerstg.cfappsawsnpwest.ebiz.verizon.com/vendortokencreate",
  vepsUrl: "https://atomvepsstg.cfappsawsnpwest.ebiz.verizon.com/veps/payment",
  verifyOTP:
    "https://atomssocheckstg.cfappsawsnpwest.ebiz.verizon.com/ssocheck/verifyccpin",
  viewDetail:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/viewdetails",
  viewDetailAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/services/getlongdesc.fios",
  voicetn:
    "https://atomphoneservicesstg.cfappsawsnpwest.ebiz.verizon.com/phoneservices",
  vzFwdEnrollmentDetails: 
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/enrollmentDetails", 
  twsSiginInDetails: 
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/twsSiginInDetails",   
  vzwOfferEligibility:
    "https://atomvzwoffereligibilitystg.cfappsawsnpwest.ebiz.verizon.com/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://atomvzwoffereligibilitystg.cfappsawsnpwest.ebiz.verizon.com/eligibility/getWirelessProduct",
  checkPDCdata:
    "https://atompersonalisationstg.cfappsawsnpwest.ebiz.verizon.com/personalization/checkpdcdata",
  vzOrderInfo:
    "https://atomserviceseaststg.ebiz.verizon.com/v05g/sit/vzorder/order/vzorderinfo",
  vzOrderDetail:
    "https://atomserviceseaststg.ebiz.verizon.com/v05g/sit/vzorder/order/vzorderdetail",
  brtcInfo:
    "https://atomserviceseaststg.ebiz.verizon.com/v05g/sit/vzorder/order/brtc",
  suppCancelCart:
    "https://atomserviceseaststg.ebiz.verizon.com/v05g/sit/cart/cart/supp/",
  mfrtnFlow:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/frontliners/save",
  mfrtnmoveEligibleCheck:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/frontliners/retrieve",
  ssoMHAuthiniticate:
    "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk",
    fiosReferralCCAToken: "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
    fiosReferralVerifyToken: "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
  ssoMHEmailAuthiniticate:
    "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",
  pollingIGBackendUrl:
    "https://securesit1.verizon.com/accessmanager/public/adaptiveauth/2fa/polling",
  ssoMHGetName:
    "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname",  
    ssoMHGetCustomerDetails:"https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getcustomerdetailsresponse",

  check5GAvailability: 'https://www98.verizon.com/inhome/check5gavailability',
  wlCustomerCheckoutInfo:
  "https://api-uat.verizon.com/atomapi/v1/addressqualification/mobileandhome/wlcustomercheckoutinfo",
  disconnectBanner: "https://sso-np.ebiz.verizon.com/consumer/myverizon/homeoffers",
  mvaDisconnectBanner: "https://www.verizon.com/consumer/fios/secure/ui/acct/homeoffers",  

  hmpFindActiveSchedule:"https://www98.verizon.com/soe/digital/prospect/qualificationservice/hmpDigital/findActiveSchedule",
  hmpEligibilityChecks:"https://www98.verizon.com/soe/digital/prospect/qualificationservice/hmpDigital/hmpEligibilityChecks",
  hmpHome:"https://www98.verizon.com/soe/digital/prospect/qualificationservice/optin/hmpHome",
  retailStoreDetails: "https://www98.verizon.com/soe/digital/prospect/peripheralsservice/getClosingAgencyDetails",
  lookupReferralNumber: "https://www98.verizon.com/soe/digital/prospect/peripheralsservice/lookupRetailCollaborationCode",
 getPerksAEM:"https://www.verizon.com/content/caas/plan/aggregated-perks.model.json",
 
};

const stageApigee = {
  
  PnSubsctiption:"https://api-uat.verizon.com/atomapi/v1/persionalizationservice/personalization/subscribe",
  SaveSegment: "https://api-uat.verizon.com/atomapi/v1/persionalizationservice/personalization/segment",
  SaveCampaign: "https://api-uat.verizon.com/atomapi/v1/persionalizationservice/personalization/campaign", 
  accessToken: "https://oa-stg.verizon.com/oauth/client_credential/accesstoken",
  getConsumerKey:"sjiAt4LGSA1XpYxNy5VT73Nj4D5ezwmq",
  getConsumerSecret:"5zwI2hDARRGU0lFh",
  getFiosQualification: "https://oa-stg.verizon.com/v06g-gbcom-api/Qualify/GetFiosQualification",
  fiosQualification:
  "https://api-uat.verizon.com/atomapi/v1/addresslookup/addresses/fiosqualification",
  updatebulkcart:
    "https://api-uat.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/recommendedCart",
    vz15gFlow:"https://api-uat.verizon.com/atomapi/v1/sessionmanager/validate15recomm",
  Wireless5Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://api-uat.verizon.com/atomapi/v1/careflowservice/careflow/affinityvalidation",
  updateFlowType:
    "https://api-uat.verizon.com/atomapi/v1/sessionmanager/updateflowtype",
  channelLineupPackageView:
    "https://api-uat.verizon.com/atomapi/v1/channellookup/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://api-uat.verizon.com/atomapi/v1/channellookup/channels/allpackages",
  channelLineupVhoUrl:
    "https://api-uat.verizon.com/atomapi/v1/channellookup/channels/vho",
  channelProgramMasterUrl:
    "https://api-uat.verizon.com/atomapi/v1/channellookup/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://api-uat.verizon.com/atomapi/v1/channellookup/channels/searchforchannelprogram",
  chatEncry: "Y",
  chatEncrypt:
    "https://api-uat.verizon.com/atomapi/v1/chatinfoservice/chatInfo/hvals",
  chatReint: "Y",
  chatStore:
    "https://api-uat.verizon.com/atomapi/v1/chatinfoservice/chatInfo/storeChatInfo",
  checkAddr:
    "https://api-uat.verizon.com/atomapi/v1/addressqualification/address/qualification?addressID=",
  fiosMnhFetch:
    "https://api-uat.verizon.com/atomapi/v1/addressqualification/address/fiosmnh",
  checkportability:
    "https://api-uat.verizon.com/atomapi/v1/tnportability/tnportability",
  clearCart:
    "https://api-uat.verizon.com/atomapi/v1/cart/cart/accordion/clearcart",
  clearCartEC:
    "https://api-uat.verizon.com/atomapi/v1/cart/cart/accordion/clearcartec",
  compareCart:
    "https://api-uat.verizon.com/atomapi/v1/cart/cart/accordion/compare",
  configEntry:
    "https://www.verizon.com/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://www98.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://www98.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId: "/inhome/generatevisitid",
  //https://api-uat.verizon.com/atomapi/v1/sessionmanager/visitid
 // createVisitId: "https://api-uat.verizon.com/atomapi/v1/sessionmanager/visitid",
  validatepartner: "/inhome/validatepartner",
  MyVzSigninEspanolAF:
  "https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://espanol.verizon.com&remainInOverlay=N&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3A%2F%2Fespanol.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fespanol.verizon.com%252Fforyourhome%252Fordering%252Fmyverizonnew%252Fregistrationbridge.aspx",
  MyVzSigninMV: "https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://wwwnte1aws.ebiz.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fwww98.verizon.com%2fconsumer%2fmyverizon%2frouter%3ftarget%3dhttps%253a%252f%252fwwwnte1aws.ebiz.verizon.com%252finhome%252fmoves%252fqualification%253fismvflow%253dy",
  MyVzSigninAF:
    "https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www98.verizon.com&remainInOverlay=N&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3A%2F%2Fwww98.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fwww98.verizon.com%252Fforyourhome%252Fordering%252Fmyverizonnew%252Fregistrationbridge.aspx",
  MyVzSigninMV98:"https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www98.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fwww98.verizon.com%2fconsumer%2fmyverizon%2frouter%3ftarget%3dhttps%253a%252f%252fwww98.verizon.com%252finhome%252fmoves%252fqualification%253fismvflow%253dy",
  MyVzSigninInhomeAF:
    "https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www98.verizon.com&remainInOverlay=N&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3A%2F%2Fwww98.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3dhttps%253a%252f%252fwww98.verizon.com%252finhome%252fchange%252fsignin%253fflowtype%253daf",
  creditAssessment:
    "https://api-uat.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditfiosassessment",
  creditCheck:
    "https://api-uat.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditworthiness",
  creditRefresh:
    "https://api-uat.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://api-uat.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://api-uat.verizon.com/atomapi/v1/accountqualificationservice/account/decryptData",
  dobundle:
    "https://api-uat.verizon.com/atomapi/v1/qualifiedproducts/products/dobundle",
    vecorder:
    "https://api-uat.verizon.com/atomapi/v1/qualifiedproducts/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  disconnect: "https://api-uat.verizon.com/atomapi/v1/servicedisconnectservice/disconnectreason",
  ecFooter: "https://www98.verizon.com/includes/commongf/",
  ecHeader: "https://www98.verizon.com/includes/commongh/",
  MoveCheckoutExperience:
    "https://api-uat.verizon.com/atomapi/v1/contactinfo/order/moves/getCheckoutExperience",
  MoveLandingExperience:"https://api-uat.verizon.com/atomapi/v1/qualifiedproducts/products/moves/getMovesExperience?skipCart=n",
  encryptUrl:
    "https://api-uat.verizon.com/atomapi/v1/accountqualificationservice/account/encryptData",
  fbeGetSoc: "https://api-uat.verizon.com/atomapi/v1/experience/exp/getSoc",
  fbePostSoc: "https://api-uat.verizon.com/atomapi/v1/soc/fbe/PostSoc",
  futurenotification:
    "https://api-uat.verizon.com/atomapi/v1/addresslookup/addresses/futurenotification",
  generateToken:
    "https://api-uat.verizon.com/atomapi/v1/careflowservice/careflow/gettoken",
  getAccount:
    "https://api-uat.verizon.com/atomapi/v1/accountqualificationservice/account",
  getBanners: "https://api-uat.verizon.com/atomapi/v1/experience/exp/banners",
  getCacheValue:
    "https://api-uat.verizon.com/atomapi/v1/experience/exp/getcachevalue",
  getCartAcc: "https://api-uat.verizon.com/atomapi/v1/cart/cart/accordion",
  getCartAccEc:
    "https://api-uat.verizon.com/atomapi/v1/cart/cart/accordion",
  getDisclaimer:
    "https://api-uat.verizon.com/atomapi/v1/experience/exp/disclaimer",
  getDisclaimerAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getDisclaimerProducts:
    "https://api-uat.verizon.com/atomapi/v1/experience/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://api-uat.verizon.com/atomapi/v1/experience/exp/commondisclaimer",
  getCommonAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getPlansPromo:
    "https://api-uat.verizon.com/atomapi/v1/experience/exp/planspromo",
  getPlansPromoAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDueDate:
    "https://api-uat.verizon.com/atomapi/v1/duedateservice/duedate/triggerduedate",
  getExistingService:
    "https://api-uat.verizon.com/atomapi/v1/addresslookup/addresses/existingservice",
  getFaq: "https://api-uat.verizon.com/atomapi/v1/experience/exp/faq",
  getFaqAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getfaq.model.json",
  getMon: "https://api-uat.verizon.com/atomapi/v1/masterordernumber/order/mon",
  getPartialStreetAddr:
    "https://api-uat.verizon.com/atomapi/v1/addresslookup/addresses/street?streetterm=",
  getCompleteAddress:
    "https://api-uat.verizon.com/atomapi/v1/addresslookup/addresses/address?addressid=",
  getProduct:
    "https://api-uat.verizon.com/atomapi/v1/qualifiedproducts/accordion/products",
  getProductEc:
    "https://api-uat.verizon.com/atomapi/v1/ecproductservice/accordion/products",
  getVoiceProductEc:
    "https://api-uat.verizon.com/atomapi/v1/ecproductservice/products",
  getSmartCartPersonalInfo:
    "https://api-uat.verizon.com/atomapi/v1/contactinfo/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://api-uat.verizon.com/atomapi/v1/addresslookup/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "VAiecKGNC721VnSn9fQrmpMumsdxZYu3",
  getStreetAddrLocus2:
    "https://oa-stg.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "YT2N6GkuOjvISXmvQUeSW5XA1MA990VF",
  qualification5G:
    "https://api-uat.verizon.com/atomapi/v1/addressqualification/address/fixedwirelesscoveragecheck",
  getTerms: "https://api-uat.verizon.com/atomapi/v1/experience/exp/terms",
  getTermsAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getorderingtos.model.json", 
   
  getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos: "https://api-uat.verizon.com/atomapi/v1/experience/exp/tos",
  getUnit:
    "https://api-uat.verizon.com/atomapi/v1/addresslookup/addresses/units",
  getUnitLocus:
    "https://oa-stg.verizon.com/locus-address-api/address/typeahead-unit",
  getVZID:
    "https://api-uat.verizon.com/atomapi/v1/registryservice/registration/getVzid",
  getZipcode:
    "https://api-uat.verizon.com/atomapi/v1/addresslookup/addresses/zip",
  getvendorvisitdetails:
    "https://api-uat.verizon.com/atomapi/v1/sessionmanager/getvendorvisitdetails",
  checkPreLink:
    "https://api-uat.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/checkprelink?prelink=add",  
  jsNotify:
    "https://api-uat.verizon.com/atomapi/v1/common/logger/logmsg",
  kafkaErrorAppLogs:
    "https://api-uat.verizon.com/atomapi/v1/common/kafka/atom_applogs",
  kafkaPageLogs:
    "https://api-uat.verizon.com/atomapi/v1/common/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://api-uat.verizon.com/atomapi/v1/common/kafka/atom_visitdetails",
  learnCustomTv: "https://www98.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://sit-activate.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://oa-uat.ebiz.ebiz.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://sit-activate.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl: "https://sit-activate.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://api-uat.verizon.com/atomapi/v1/common/kafka/pageconfig",
  nsiNotify:
    "https://api-uat.verizon.com/atomapi/v1/addresslookup/addresses/nsinotification",
  orderConfirmation:
    "https://api-uat.verizon.com/atomapi/v1/experience/exp/getorderconfirmation",
  performEID:
    "https://api-uat.verizon.com/atomapi/v1/creditcheckservice/creditcheck/performeid",
  personlisationdmp:
    "https://api-uat.verizon.com/atomapi/v1/persionalizationservice/personalization/getvzdmptoak",
  pieUrl: "https://pie.uat.verizon.com/pie/v1",
  postCacheValue:
    "https://api-uat.verizon.com/atomapi/v1/experience/exp/updatecachestorage",
  processSave:
    "https://api-uat.verizon.com/atomapi/v1/smartcart/order/processsmartcart",
  productOffersUrl:
    "https://api-uat.verizon.com/atomapi/v1/qualifiedproducts/offer/products/manual",
  profileCart:
    "https://api-uat.verizon.com/atomapi/v1/cart/cart/profile",
  rapurl: "https://stglov-activate.verizon.com/orderinfo/?src=olo",
  chatDetails:
    "https://api-uat.verizon.com/atomapi/v1/chatinfoservice/chatInfo/chatdetails",
  referFrinedValidation:
    "https://api-uat.verizon.com/atomapi/v1/chatinfoservice/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://api-uat.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://api-uat.verizon.com/atomapi/v1/qualifiedproducts/products/refreshPromotions",
  removePromoCode:
    "https://api-uat.verizon.com/atomapi/v1/qualifiedproducts/products/removePromotions",
  resumeSmartCart:
    "https://api-uat.verizon.com/atomapi/v1/smartcart/order/resumesmartcart",
  reflowOrderSubmission:
    "https://atomservicesdebugger-west.verizon.com/v05g/prod/debugger/ordersubmission",
  retrieveQualdetails:
    "https://api-uat.verizon.com/atomapi/v1/addressqualification/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://api-uat.verizon.com/atomapi/v1/smartcart/order/retrievesmartcart",
  sameDaydelivery:
    "https://api-uat.verizon.com/atomapi/v1/storepickup/switch/samedaydelivery",
  seeFcpDetail:
    "https://api-uat.verizon.com/atomapi/v1/experience/exp/fcpspecialoffers",
  sendLofNotification:
    "https://api-uat.verizon.com/atomapi/v1/lofservice/lof/sendnotification",
  sendOTP:
    "https://api-uat.verizon.com/atomapi/v1/contactinfo/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://api-uat.verizon.com/atomapi/v1/registryservice/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://api-uat.verizon.com/atomapi/v1/common/notification/sendsmsoremail",
  setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://api-uat.verizon.com/atomapi/v1/duedateservice/duedate/reserveduedate",
  smartAutoSave:
    "https://api-uat.verizon.com/atomapi/v1/smartcart/order/smartcartsave",
  smartSave:
    "https://api-uat.verizon.com/atomapi/v1/smartcart/order/smartcartsavewithparam",
  smartcartCancel:
    "https://api-uat.verizon.com/atomapi/v1/smartcart/order/smartcartcancel",
  getSmartCartStatus:
    "https://api-uat.verizon.com/atomapi/v1/smartcart/order/smartcartstatus",
  storePickUp:
    "https://api-uat.verizon.com/atomapi/v1/storepickup/switch/storepickup",
  submitOrder: "https://api-uat.verizon.com/atomapi/v1/order/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  tokenGeneration: "/inhome/generatetoken",
  updateCartAcc:
    "https://api-uat.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateCartAccEc:
    "https://api-uat.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateintentcart:
    "https://api-uat.verizon.com/atomapi/v1/cart/cart/updateintent",
  updateintentcartAcc:
    "https://api-uat.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://api-uat.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartEc:
    "https://api-uat.verizon.com/atomapi/v1/cart/cart/updateintent",
  uploadFile:
    "https://api-uat.verizon.com/atomapi/v1/careflowservice/careflow/employeeproof",
  validateBillingAdress:
    "https://api-uat.verizon.com/atomapi/v1/billing/order/billing",
  validateContactInfo:
    "https://api-uat.verizon.com/atomapi/v1/contactinfo/order/contact",
  validateCouponToken:
    "https://api-uat.verizon.com/atomapi/v1/careflowservice/careflow/validatecoupontoken",
  validateEmployee:
    "https://api-uat.verizon.com/atomapi/v1/careflowservice/careflow/validateemployee",
  validateName:
    "https://api-uat.verizon.com/atomapi/v1/contactinfo/order/validateName",
  validateSigninUrl:
    "https://api-uat.verizon.com/atomapi/v1/accountqualificationservice/account/validateSignin",
  validateSmartCartContactInfo:
    "https://api-uat.verizon.com/atomapi/v1/contactinfo/order/validateSmartCartContactInfo",
  validatecartUrl: "https://api-uat.verizon.com/atomapi/v1/cart/cart/validate/",
  validatecartUrlEc:
    "https://api-uat.verizon.com/atomapi/v1/cart/cart/accordion/validate/",
  vendorFlow:
    "https://api-uat.verizon.com/atomapi/v1/sessionmanager/vendorflowvalidate",
  vendorFlowToken:
    "https://api-uat.verizon.com/atomapi/v1/sessionmanager/vendortokencreate",
  vepsUrl: "https://api-uat.verizon.com/atomapi/v1/veps/veps/payment",
  verifyOTP:
    "https://api-uat.verizon.com/atomapi/v1/contactinfo/ssocheck/verifyccpin",
  viewDetail:
    "https://api-uat.verizon.com/atomapi/v1/experience/exp/viewdetails",
  viewDetailAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/services/getlongdesc.fios",
  voicetn: "https://api-uat.verizon.com/atomapi/v1/phoneservices/phoneservices",
  vzFwdEnrollmentDetails: 
  "https://api-uat.verizon.com/atomapi/v1/addressqualification/address/enrollmentDetails", 
  twsSiginInDetails: 
  "https://api-uat.verizon.com/atomapi/v1/addressqualification/address/twsSiginInDetails",  
  vzwOfferEligibility:
    "https://api-uat.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://api-uat.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getWirelessProduct",
  checkPDCdata:
    "https://api-uat.verizon.com/atomapi/v1/persionalizationservice/personalization/checkpdcdata",
  vzOrderInfo:
    "https://api-uat.verizon.com/atomapi/v1/vzorderservice/order/vzorderinfo",
  vzOrderDetail:
    "https://api-uat.verizon.com/atomapi/v1/vzorderservice/order/vzorderdetail",
  brtcInfo:
    "https://api-uat.verizon.com/atomapi/v1/vzorderservice/order/brtc",
  suppCancelCart:
   "https://api-uat.verizon.com/atomapi/v1/cart/cart/supp/",
  mfrtnFlow:
    "https://api-uat.verizon.com/atomapi/v1/careflowservice/frontliners/save",
  ssoMHAuthiniticate:
    "https://api-uat.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://api-uat.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk",
    fiosReferralCCAToken: "https://api-uat.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
    fiosReferralVerifyToken: "https://api-uat.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
    ssoMHEmailAuthiniticate:
    "https://api-uat.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",
  pollingIGBackendUrl:
    "https://securesit1.verizon.com/accessmanager/public/adaptiveauth/2fa/polling",
  verification:
    'https://api-uat.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/verification',
  ssoMHGetName:
    "https://api-uat.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname",  
    ssoMHGetCustomerDetails:"https://api-uat.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getcustomerdetailsresponse",
   
  mfrtnmoveEligibleCheck:
    "https://api-uat.verizon.com/atomapi/v1/careflowservice/frontliners/retrieve",
  wlCustomerCheckoutInfo:
    "https://api-uat.verizon.com/atomapi/v1/addressqualification/mobileandhome/wlcustomercheckoutinfo",
  getFccLabel:"https://api-uat.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/fccLabelData", 
  check5GAvailability: 'https://www98.verizon.com/inhome/check5gavailability', 
  disconnectBanner: "https://sso-np.ebiz.verizon.com/consumer/myverizon/homeoffers",
  mvaDisconnectBanner: "https://www.verizon.com/consumer/fios/secure/ui/acct/homeoffers", 
  hmpFindActiveSchedule:"https://www98.verizon.com/soe/digital/prospect/qualificationservice/hmpDigital/findActiveSchedule",
  hmpEligibilityChecks:"https://www98.verizon.com/soe/digital/prospect/qualificationservice/hmpDigital/hmpEligibilityChecks",
  hmpHome:"https://www98.verizon.com/soe/digital/prospect/qualificationservice/optin/hmpHome",
  retailStoreDetails: "https://www98.verizon.com/soe/digital/prospect/peripheralsservice/getClosingAgencyDetails",
 getPerksAEM:"https://www.verizon.com/content/caas/plan/aggregated-perks.model.json",
 getMovesThrottle:"https://api-uat.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/nsathrottlelist",
 getpzaiRatingNumber: "https://api-uat.verizon.com/atomapi/v1//qualifiedproducts/accordion/products/fiospzai",
 getCentralAgreementTermsAEM: "https://api-uat.verizon.com/atomapi/v1/qualifiedproducts/products/tosCentralAgreement",
 
    ...changeUATApigee
};
const uatApigee = {
  MyVzSigninAF:
    "https://sit-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://wwwawssit.ebiz.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fsit-ssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fsso-np.ebiz.verizon.com%252fconsumer%252fmyverizon%252frouter%253ftarget%253dhttps%25253a%25252f%25252fwwwawssit.ebiz.verizon.com%25252fforyourhome%25252fordering%25252fmyverizonnew%25252fregistrationbridge.aspx%25253f",
  MyVzSigninMV98:"https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www98.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fwww98.verizon.com%2fconsumer%2fmyverizon%2frouter%3ftarget%3dhttps%253a%252f%252fwww98.verizon.com%252finhome%252fmoves%252fqualification%253fismvflow%253dy",
  MyVzSigninMV:
    "https://sit-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://wwwawssit.ebiz.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fsit-ssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fsso-np.ebiz.verizon.com%252fconsumer%252fmyverizon%252frouter%253ftarget%253dhttps%25253a%25252f%25252fwwwawssit.ebiz.verizon.com%25252fforyourhome%25252fordering%25252fcheckavailabilitylq.aspx%25253fismvflow%25253dy",
  Wireless5Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/affinityvalidation",
  accessToken: "https://oa-dev2.ebiz.verizon.com/oauth/client_credential/accesstoken",
  getConsumerKey:"NY3FfzZUOlIUBN21MPzbqlBEel7g8aKG",
  getConsumerSecret:"X10eUvJa42wNpa3u",
  getFiosQualification: "https://wwwawsuat.ebiz.verizon.com/foryoursmallbiz/smb/api/Qualify/GetFiosQualification",
  channelLineupPackageView:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/channellookup/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/channellookup/channels/allpackages",
  channelLineupVhoUrl:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/channellookup/channels/vho",
  channelProgramMasterUrl:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/channellookup/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/channellookup/channels/searchforchannelprogram",
  chatEncry: "Y",
  validatepartner: "/inhome/validatepartner",
  chatEncrypt:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/hvals",
  chatReint: "N",
  chatStore:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/storeChatInfo",
  checkAddr:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/qualification?addressID=",
  fiosMnhFetch:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/fiosmnh",
  checkportability:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/tnportability/tnportability",
    updatebulkcart:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/recommendedCart",
  clearCart:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/clearcart",
  clearCartEC:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/clearcartec",
  compareCart:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/compare",
  configEntry:
    "https://wwwawsuat.ebiz.verizon.com/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://wwwawsuat.ebiz.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://wwwawsuat.ebiz.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId: "/inhome/generatevisitid",
  creditAssessment:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditfiosassessment",
  creditCheck:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditworthiness",
  creditRefresh:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/decryptData",
  dobundle:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/dobundle",
    vecorder:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "/inhome/ecFooter",
  ecHeader: "/inhome/ecHeader",
  encryptUrl:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/encryptData",
  fbeGetSoc: "https://oa-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/getSoc",
  fbePostSoc: "https://oa-dev2.ebiz.verizon.com/atomapi/v1/soc/fbe/PostSoc",
  futurenotification:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/futurenotification",
  generateToken:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/gettoken",
  getAccount:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account",
  getBanners:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/banners",
  getCacheValue:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/getcachevalue",
  getCartAcc: "https://oa-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion",
  getCartAccEc:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion",
  getDisclaimer:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/disclaimer",
  getDisclaimerAEM:
    "https://www98.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getPlansPromo:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/planspromo",
  getPlansPromoAEM:
    "https://www98.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDisclaimerProducts:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/commondisclaimer",
  getCommonAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getDueDate:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/duedateservice/duedate/triggerduedate",
  getExistingService:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/existingservice",
  getFaq: "https://oa-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/faq",
  getFaqAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getfaq.model.json",
  getMon:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/masterordernumber/order/mon",
  getPartialStreetAddr:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/street?streetterm=",
  getCompleteAddress:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/address?addressid=",
  getProduct:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products",
  getProductEc:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/ecproductservice/accordion/products",
  getVoiceProductEc:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/ecproductservice/products",
  getSmartCartPersonalInfo:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/contactinfo/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "VAiecKGNC721VnSn9fQrmpMumsdxZYu3",
  getStreetAddrLocus2:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "MvaCGJaWUOM1zkdFJietJiYyq15SJGdF",
  qualification5G:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/fixedwirelesscoveragecheck",
  getTerms: "https://oa-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/terms",
  getTermsAEM:
     "https://wwwawssit.ebiz.verizon.com/personal/cas/getorderingtos.model.json",
   
getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos: "https://oa-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/tos",
  getUnit:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/units",
  getUnitLocus:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-unit",
  getUpsell:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/upsell/",
  getVZID:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/registryservice/registration/getVzid",
  getZipcode:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/zip",
  getvendorvisitdetails:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/sessionmanager/getvendorvisitdetails",
    jsNotify:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/common/logger/logmsg",
  kafkaErrorAppLogs:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/common/kafka/atom_applogs",
  kafkaPageLogs:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/common/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/common/kafka/atom_visitdetails",
  learnCustomTv:
    "https://wwwawsuat.ebiz.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://sit-activate.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://sit-activate.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl: "https://sit-activate.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/common/kafka/pageconfig",
  nsiNotify:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/nsinotification",
  orderConfirmation:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/getorderconfirmation",
  performEID:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/performeid",
  personlisationdmp:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/getvzdmptoak",
  pieUrl: "https://pie.uat.verizon.com/pie/v1",
  postCacheValue:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/updatecachestorage",
  processSave:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/smartcart/order/processsmartcart",
  productOffersUrl:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/offer/products/manual",
  profileCart:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/profile",
  rapurl: "https://wwwawsuat.ebiz.verizon.com/orderinfo/?src=olo",
  chatDetails:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/chatdetails",
  referFrinedValidation:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/refreshPromotions",
  removePromoCode:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/removePromotions",
  resumeSmartCart:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/smartcart/order/resumesmartcart",
  retrieveQualdetails:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/smartcart/order/retrievesmartcart",
  sameDaydelivery:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/storepickup/switch/samedaydelivery",
  seeFcpDetail:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/fcpspecialoffers",
  sendLofNotification:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/lofservice/lof/sendnotification",
  sendOTP:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/contactinfo/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/registryservice/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/common/notification/sendsmsoremail",
  setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/duedateservice/duedate/reserveduedate",
  smartAutoSave:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartsave",
  smartSave:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartsavewithparam",
  smartcartCancel:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartcancel",
  getSmartCartStatus:
    " https://oa-dev2.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartstatus",
  storePickUp:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/storepickup/switch/storepickup",
  submitOrder: "https://oa-dev2.ebiz.verizon.com/atomapi/v1/order/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  tokenGeneration: "/inhome/generatetoken",
  updateCartAcc:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateCartAccEc:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateintentcart:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/updateintent",
  updateintentcartAcc:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartEc:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/updateintent",
  uploadFile:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/employeeproof",
  validateBillingAdress:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/billing/order/billing",
  validateContactInfo:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/contactinfo/order/contact",
  validateCouponToken:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/validatecoupontoken",
  validateEmployee:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/validateemployee",
  validateName:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/contactinfo/order/validateName",
  validateSigninUrl:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/validateSignin",
  validateSmartCartContactInfo:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/contactinfo/order/validateSmartCartContactInfo",
  validatecartUrl:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/validate/",
  validatecartUrlEc:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/validate/",
  vendorFlow:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/sessionmanager/vendorflowvalidate",
  vendorFlowToken:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/sessionmanager/vendortokencreate",
  vepsUrl: "https://oa-dev2.ebiz.verizon.com/atomapi/v1/veps/veps/payment",
  verifyOTP:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/contactinfo/ssocheck/verifyccpin",
  viewDetail:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/viewdetails",
  viewDetailAEM:
    "https://www98.verizon.com/personal/services/getlongdesc.fios",
  voicetn:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/phoneservices/phoneservices",
  vzFwdEnrollmentDetails: 
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/enrollmentDetails", 
  twsSiginInDetails: 
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/twsSiginInDetails",   
  vzwOfferEligibility:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getWirelessProduct",
  vzOrderInfo:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/vzorderservice/order/vzorderinfo",
  vzOrderDetail:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/vzorderservice/order/vzorderdetail",
  brtcInfo:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/vzorderservice/order/brtc",
  suppCancelCart: 
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/supp/",
  checkPDCdata:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/checkpdcdata",
  mnhOneClickVzwAccountSave:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/savewirelessaccountsystemobjectdetailstocache/",
  mnhOneClickQualification:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/mobileandhome/ecwlnewfiosqualification",
  wlCustomerCheckoutInfo:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/mobileandhome/wlcustomercheckoutinfo",
  mnhOneClickMarketingProfileSave:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/savemaketingprofiledetailstocache/",
  mnhOneClickLoopQualSave:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/saveloopqualtocache/",
  mnhOneClickLocusAddressValidationSave:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/savelocusaddrvalidationdetailstocache/",
  mnhOneClickOneCreditSave:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/savesfiosonecreditdetailstocache/",
  mnhOneClickEncryptWirelessDataToken:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/mobileandhome/encryptwirelessdatatoken",
  mnhOneClickMLP:
    "https://www98.verizon.com/content/verizon/personal/services/fivegoneclick.nocache.html",
  ssoMHAuthiniticate:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk",
    fiosReferralCCAToken: "https://oa-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
    fiosReferralVerifyToken: "https://oa-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
    ssoMHEmailAuthiniticate:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",
  pollingIGBackendUrl:
    "https://securesit1.verizon.com/accessmanager/public/adaptiveauth/2fa/polling",
  ssoMHGetName:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname", 
    ssoMHGetCustomerDetails:"https://oa-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getcustomerdetailsresponse",
    
    runtimeValuesUrl:
    "https://oa-dev2.ebiz.verizon.com/atomapi/v1/common/pageflow/getruntimevalues?runtimekey=",
  disconnectBanner: "https://sso-np.ebiz.verizon.com/consumer/myverizon/homeoffers",
  mvaDisconnectBanner: "https://www.verizon.com/consumer/fios/secure/ui/acct/homeoffers", 
  hmpFindActiveSchedule:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/hmpDigital/findActiveSchedule",
  hmpEligibilityChecks:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/hmpDigital/hmpEligibilityChecks",
  hmpHome:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/optin",
  retailStoreDetails: "https://vzwqa2.sdc.vzwcorp.com/soe/digital/prospect/peripheralsservice/getClosingAgencyDetails",
  lookupReferralNumber: "https://vzwqa2.sdc.vzwcorp.com/soe/digital/prospect/peripheralsservice/lookupRetailCollaborationCode",
  getPerksAEM:"https://wwwawssit.ebiz.verizon.com/content/caas/plan/aggregated-perks.model.json",
  getMovesThrottle:"https://oa-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/nsathrottlelist",
  getpzaiRatingNumber: "https://oa-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/fiospzai",
  getCentralAgreementTermsAEM: "https://oa-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/tosCentralAgreement",
  ...changeUATApigee
};

const pilotProxy = {
  Wireless5Gurl: "https:/www.verizon.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl:"https://www.verizon.com/home/lte-home-internet/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/affinityvalidation",
  channelLineupPackageView:
    "https://atomchannellookupstg.cfappsawsnpwest.ebiz.verizon.com/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://atomchannellookupstg.cfappsawsnpwest.ebiz.verizon.com/channels/allpackages",
  channelLineupVhoUrl:
    "https://atomchannellookupstg.cfappsawsnpwest.ebiz.verizon.com/channels/vho",
  channelProgramMasterUrl:
    "https://atomchannellookupstg.cfappsawsnpwest.ebiz.verizon.com/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://atomchannellookupstg.cfappsawsnpwest.ebiz.verizon.com/channels/searchforchannelprogram",
  chatEncry: "Y",
  chatEncrypt:
    "https://atomchatinfostg.cfappsawsnpwest.ebiz.verizon.com/chatInfo/hvals",
  chatReint: "Y",
  chatStore:
    "https://atomchatinfostg.cfappsawsnpwest.ebiz.verizon.com/chatInfo/storeChatInfo",
  checkAddr:
    "https://atomaddressqualificationstg.cfappsawsnpwest.ebiz.verizon.com/address/qualification?addressID=",
  checkportability:
    "https://atomtnportabilitystg.cfappsawsnpwest.ebiz.verizon.com/tnportability",
  clearCart:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/clearcart",
  clearCartEC:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/clearcartec",
  compareCart:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/compare",
  configEntry:
    "https://www98.verizon.com/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://wwwaws98.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://wwwaws98.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId:
    "https://atomsessionmanagerstg.cfappsawsnpwest.ebiz.verizon.com/visitid",
  creditAssessment:
    "https://atomcreditcheckstg.cfappsawsnpwest.ebiz.verizon.com/creditcheck/creditfiosassessment",
  creditCheck:
    "https://atomcreditcheckstg.cfappsawsnpwest.ebiz.verizon.com/creditcheck/creditworthiness",
  creditRefresh:
    "https://atomcreditcheckstg.cfappsawsnpwest.ebiz.verizon.com/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://atomcreditcheckstg.cfappsawsnpwest.ebiz.verizon.com/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://atomaccountqualificationstg.cfappsawsnpwest.ebiz.verizon.com/account/decryptData",
  dobundle:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/products/dobundle",
    vecorder:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "https://www98.verizon.com/includes/commongf/",
  ecHeader: "https://www98.verizon.com/includes/commongh/",
  encryptUrl:
    "https://atomaccountqualificationstg.cfappsawsnpwest.ebiz.verizon.com/account/encryptData",
  fbeGetSoc:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/getSoc",
  fbePostSoc: "https://atomsocstg.cfappsawsnpwest.ebiz.verizon.com/fbe/PostSoc",
  futurenotification:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/futurenotification",
  generateToken:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/gettoken",
  getAccount:
    "https://atomsessionmanagerstg.cfappsawsnpwest.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account",
  getBanners:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/banners",
  getCacheValue:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/getcachevalue",
  getCartAcc:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion",
  getCartAccEc:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion",
  getDisclaimer:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/disclaimer",
  getDisclaimerAEM:
    "https://www.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getDisclaimerProducts:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://preprod-east-gz.vpc.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/commondisclaimer",
  getCommonAEM:
    "https://preprod-east-gz.vpc.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getPlansPromo:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/planspromo",
  getPlansPromoAEM:
    "https://www.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDueDate:
    "https://atomduedatestg.cfappsawsnpwest.ebiz.verizon.com/duedate/triggerduedate",
  getExistingService:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/existingservice",
  getFaq: "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/faq",
  getFaqAEM:
    "https://www.verizon.com/personal/cas/getfaq.model.json",
  getMon: "https://atommonstg.cfappsawsnpwest.ebiz.verizon.com/order/mon",
  getPartialStreetAddr:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/street?streetterm=",
  getCompleteAddress:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/address?addressid=",
  getProduct:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/accordion/products",
  getProductEc:
    "https://atomproductecexpstg.cfappsawsnpwest.ebiz.verizon.com/accordion/products",
  getVoiceProductEc:
    "https://atomproductecexpstg.cfappsawsnpwest.ebiz.verizon.com/products",
  getSmartCartPersonalInfo:
    "https://atomcontactinfovalidationstg.cfappsawsnpwest.ebiz.verizon.com/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "3hBtC8PjGnZ5pG3AmtcFnGmlPtTbiwa4",
  getStreetAddrLocus2:
    "https://oa-stg.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "YT2N6GkuOjvISXmvQUeSW5XA1MA990VF",
  qualification5G:
    "https://atomaddressqualificationstg.cfappsawsnpwest.ebiz.verizon.com/address/fixedwirelesscoveragecheck",
  getTerms:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/terms",
  getTermsAEM:
    "https://preprod-east-gz.vpc.verizon.com/personal/cas/getorderingtos.model.json", 
    getCentralAgreementTermsAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement~html.json",
  getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos: "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/tos",
  getUnit:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/units",
  getUnitLocus:
  "https://oa-stg.verizon.com/locus-address-api/address/typeahead-unit",
  getVZID:
    "https://atomregistrationstg.cfappsawsnpwest.ebiz.verizon.com/registration/getVzid",
  getZipcode:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/zip",
  getvendorvisitdetails:
    "https://atomsessionmanagerstg.cfappsawsnpwest.ebiz.verizon.com/getvendorvisitdetails",
  checkPreLink:
    "https://atomvzwoffereligibilitystg.cfappsawsnpwest.ebiz.verizon.com/eligibility/checkprelink?prelink=add",
  validateVendorToken: 
    "https://www98.verizon.com/inhome/validatevendortoken",
    fetchEmeriosInfo: 
    "https://www98.verizon.com/inhome/fetchEmeriosInfo",
  jsNotify:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/logger/logmsg",
  kafkaErrorAppLogs:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/kafka/atom_applogs",
  kafkaPageLogs:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/kafka/atom_visitdetails",
  learnCustomTv: "https://www98.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://sit-activate.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://atomvendorexperiencestg.cfappsawsnpwest.ebiz.verizon.com/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://sit-activate.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl: "https://sit-activate.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/kafka/pageconfig",
  nsiNotify:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/nsinotification",
  orderConfirmation:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/getorderconfirmation",
  performEID:
    "https://atomcreditcheckstg.cfappsawsnpwest.ebiz.verizon.com/creditcheck/performeid",
  personlisationdmp:
    "https://atompersonalisationstg.cfappsawsnpwest.ebiz.verizon.com/personalization/getvzdmptoak",
  pieUrl: "https://pie.prod.verizon.com/pie/v1",
  postCacheValue:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/updatecachestorage",
  processSave:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/processsmartcart",
  productOffersUrl:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/offer/products/manual",
  profileCart:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/profile",
  chatDetails:
    "https://atomchatinfostg.cfappsawsnpwest.ebiz.verizon.com/chatInfo/chatdetails",
  referFrinedValidation:
    "https://atomchatinfostg.cfappsawsnpwest.ebiz.verizon.com/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://atomvzwoffereligibilitystg.cfappsawsnpwest.ebiz.verizon.com/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/products/refreshPromotions",
  removePromoCode:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/products/removePromotions",
  resumeSmartCart:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/resumesmartcart",
  retrieveQualdetails:
    "https://atomaddressqualificationstg.cfappsawsnpwest.ebiz.verizon.com/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/retrievesmartcart",
  sameDaydelivery:
    "https://atomstorepickupstg.cfappsawsnpwest.ebiz.verizon.com/switch/samedaydelivery",
  seeFcpDetail:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/fcpspecialoffers",
  seeDetail:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/fcpspecialoffers",
  sendLofNotification:
    "https://atomlofstg.cfappsawsnpwest.ebiz.verizon.com/lof/sendnotification",
  sendOTP:
    "https://atomssocheckstg.cfappsawsnpwest.ebiz.verizon.com/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://atomregistrationstg.cfappsawsnpwest.ebiz.verizon.com/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/notification/sendsmsoremail",
  setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://atomduedatestg.cfappsawsnpwest.ebiz.verizon.com/duedate/reserveduedate",
  smartAutoSave:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/smartcartsave",
  smartSave:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/smartcartsavewithparam",
  smartcartCancel:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/smartcartcancel",
  getSmartCartStatus:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/smartcartstatus",
  storePickUp:
    "https://atomstorepickupstg.cfappsawsnpwest.ebiz.verizon.com/switch/storepickup",
  submitOrder:
    "https://atomordersubmissionstg.cfappsawsnpwest.ebiz.verizon.com/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  updateCartAcc:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/updatecart",
  updateCartAccEc:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/updatecart",
  updateintentcart:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/updateintent",
  updateintentcartAcc:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/updateintent",
  updateintentcartEc:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/updateintent",
  uploadFile:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/employeeproof",
  updateFireAlarm:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/products/voice/firealarm",
  getFireAlarm:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/products/voice/getfirealarm",  
  validateBillingAdress:
    "https://atombillingvalidationstg.cfappsawsnpwest.ebiz.verizon.com/order/billing",
  validateContactInfo:
    "https://atomcontactinfovalidationstg.cfappsawsnpwest.ebiz.verizon.com/order/contact",
  validateCouponToken:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/validatecoupontoken",
  validateEmployee:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/validateemployee",
  validateName:
    "https://atomcontactinfovalidationstg.cfappsawsnpwest.ebiz.verizon.com/order/validateName",
  validateSigninUrl:
    "https://atomaccountqualificationstg.cfappsawsnpwest.ebiz.verizon.com/account/validateSignin",
  validateSmartCartContactInfo:
    "https://atomcontactinfovalidationstg.cfappsawsnpwest.ebiz.verizon.com/order/validateSmartCartContactInfo",
  validatecartUrl:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/validate/",
  validatecartUrlEc:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/validate/",
  vendorFlow:
    "https://atomsessionmanagerstg.cfappsawsnpwest.ebiz.verizon.com/vendorflowvalidate",
  vendorFlowToken:
    "https://atomsessionmanagerstg.cfappsawsnpwest.ebiz.verizon.com/vendortokencreate",
  vepsUrl: "https://atomvepsstg.cfappsawsnpwest.ebiz.verizon.com/veps/payment",
  verifyOTP:
    "https://atomssocheckstg.cfappsawsnpwest.ebiz.verizon.com/ssocheck/verifyccpin",
  viewDetail:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/viewdetails",
  viewDetailAEM:
    "https://www.verizon.com/personal/services/getlongdesc.fios",
  voicetn:
    "https://atomphoneservicesstg.cfappsawsnpwest.ebiz.verizon.com/phoneservices",
  vzFwdEnrollmentDetails: 
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/enrollmentDetails", 
  twsSiginInDetails: 
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/twsSiginInDetails", 
  vzwOfferEligibility:
    "https://atomvzwoffereligibilitystg.cfappsawsnpwest.ebiz.verizon.com/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://atomvzwoffereligibilitystg.cfappsawsnpwest.ebiz.verizon.com/eligibility/getWirelessProduct",
  checkPDCdata:
    "https://atompersonalisationstg.cfappsawsnpwest.ebiz.verizon.com/personalization/checkpdcdata",
  vzOrderInfo:
    "https://atomserviceseaststg.ebiz.verizon.com/v05g/sit/vzorder/order/vzorderinfo",
  vzOrderDetail:
    "https://atomserviceseaststg.ebiz.verizon.com/v05g/sit/vzorder/order/vzorderdetail",
  brtcInfo:
    "https://atomserviceseaststg.ebiz.verizon.com/v05g/sit/vzorder/order/brtc",
  suppCancelCart:
    "https://atomserviceseaststg.ebiz.verizon.com/v05g/sit/cart/cart/supp/",
  mfrtnFlow:
    "https://atomserviceseaststg.ebiz.verizon.com/v05g/stg/careflow/frontliners/save",
  ssoMHAuthiniticate:
    "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk",
    fiosReferralCCAToken: "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
    fiosReferralVerifyToken: "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
    ssoMHEmailAuthiniticate:
    "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",
    
  pollingIGBackendUrl:
    "https://login.verizonwireless.com/accessmanager/public/adaptiveauth/2fa/polling",
  ssoMHGetName:
    "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname",
    ssoMHGetCustomerDetails:"https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getcustomerdetailsresponse",
  
  storePickupCRP: "https://api-uat.verizon.com/atomapi/v1/notificationservice/whatsnext/storepickup",
  disconnectBanner: "https://www.verizon.com/consumer/myverizon/homeoffers",
  mvaDisconnectBanner: "https://www.verizon.com/consumer/fios/secure/ui/acct/homeoffers", 
  sendVisitId : "https://api.verizon.com/atomapi/v1/cart/cart/updateSSP/", 
  retentionOffer : "https://api.verizon.com/atomapi/v1/cart/cart/checkEligibleOffer/",
  updateFlowType:
    "https://atomserviceseaststg.verizon.com/atomapi/v1/sessionmanager/updateflowtype",
    getPerksAEM:"https://www.verizon.com/content/caas/plan/aggregated-perks.model.json",
  ...changePreProdProxy
};

const pilotApigee = {
  Wireless5Gurl: "https://www.verizon.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl:"https://www.verizon.com/home/lte-home-internet/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://api-stg.verizon.com/atomapi/v1/careflowservice/careflow/affinityvalidation",
  getAffinityCompanyList: "https://api-stg.verizon.com/atomapi/v1/careflowservice/careflow/getCompaniesList",
  emailValidationURL:"https://api-stg.verizon.com/atomapi/v1/careflowservice/careflow/validateemail",
  manualEmailValidationURL:"https://api-stg.verizon.com/atomapi/v1/careflowservice/careflow/manualvalidation",
  channelLineupPackageView:
    "https://api-stg.verizon.com/atomapi/v1/channellookup/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://api-stg.verizon.com/atomapi/v1/channellookup/channels/allpackages",
  channelLineupVhoUrl:
    "https://api-stg.verizon.com/atomapi/v1/channellookup/channels/vho",
  channelProgramMasterUrl:
    "https://api-stg.verizon.com/atomapi/v1/channellookup/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://api-stg.verizon.com/atomapi/v1/channellookup/channels/searchforchannelprogram",
  chatEncry: "Y",
  chatEncrypt:
    "https://api-stg.verizon.com/atomapi/v1/chatinfoservice/chatInfo/hvals",
  chatReint: "Y",
  chatStore:
    "https://api-stg.verizon.com/atomapi/v1/chatinfoservice/chatInfo/storeChatInfo",
  checkAddr:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/qualification?addressID=",
  fiosMnhFetch:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/fiosmnh",
  checkportability:
    "https://api-stg.verizon.com/atomapi/v1/tnportability/tnportability",
  clearCart:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion/clearcart",
  clearCartEC:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion/clearcartec",
  compareCart:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion/compare",
  configEntry:
    "https://www.verizon.com/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://www98.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://www98.verizon.com/personal/services/getaccordionmapping.notification.json",
  emergencyNotificationStatesConfigUrl:
    "https://www98.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId: "/inhome/generatevisitid",
  creditAssessment:
    "https://api-stg.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditfiosassessment",
  creditCheck:
    "https://api-stg.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditworthiness",
  creditRefresh:
    "https://api-stg.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://api-stg.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://api-stg.verizon.com/atomapi/v1/accountqualificationservice/account/decryptData",
  dobundle:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/products/dobundle",
    vecorder:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "https://www98.verizon.com/includes/commongf/",
  ecHeader: "https://www98.verizon.com/includes/commongh/",
  encryptUrl:
    "https://api-stg.verizon.com/atomapi/v1/accountqualificationservice/account/encryptData",
  fbeGetSoc: "https://api-stg.verizon.com/atomapi/v1/experience/exp/getSoc",
  fbePostSoc: "https://api-stg.verizon.com/atomapi/v1/soc/fbe/PostSoc",
  futurenotification:
    "https://api-stg.verizon.com/atomapi/v1/addresslookup/addresses/futurenotification",
  generateToken:
    "https://api-stg.verizon.com/atomapi/v1/careflowservice/careflow/gettoken",
  getAccount:
    "https://api-stg.verizon.com/atomapi/v1/accountqualificationservice/account",
  getBanners: "https://api-stg.verizon.com/atomapi/v1/experience/exp/banners",
  getCacheValue:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/getcachevalue",
  getCartAcc: "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion",
  getCartAccEc:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion",
  getDisclaimer:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/disclaimer",
  getDisclaimerAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getDisclaimerProducts:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/commondisclaimer",
  getCommonAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getPlansPromo:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/planspromo",
  getPlansPromoAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDueDate:
    "https://api-stg.verizon.com/atomapi/v1/duedateservice/duedate/triggerduedate",
  getExistingService:
    "https://api-stg.verizon.com/atomapi/v1/addresslookup/addresses/existingservice",
  getFaq: "https://api-stg.verizon.com/atomapi/v1/experience/exp/faq",
  getFaqAEM:
     "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getfaq.model.json",
  getMon: "https://api-stg.verizon.com/atomapi/v1/masterordernumber/order/mon",
  getPartialStreetAddr:
    "https://api-stg.verizon.com/atomapi/v1/addresslookup/addresses/street?streetterm=",
  getCompleteAddress:
    "https://api-stg.verizon.com/atomapi/v1/addresslookup/addresses/address?addressid=",
  getProduct:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/accordion/products",
  getProductEc:
    "https://api-stg.verizon.com/atomapi/v1/ecproductservice/accordion/products",
  getVoiceProductEc:
    "https://api-stg.verizon.com/atomapi/v1/ecproductservice/products",
  getSmartCartPersonalInfo:
    "https://api-stg.verizon.com/atomapi/v1/contactinfo/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://api-stg.verizon.com/atomapi/v1/addresslookup/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "YT2N6GkuOjvISXmvQUeSW5XA1MA990VF",
  getStreetAddrLocus2:
  "https://oa-stg.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "YT2N6GkuOjvISXmvQUeSW5XA1MA990VF",
  qualification5G:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/fixedwirelesscoveragecheck",
  getTerms: "https://api-stg.verizon.com/atomapi/v1/experience/exp/terms",
  getTermsAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getorderingtos.model.json",     
  getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos: "https://api-stg.verizon.com/atomapi/v1/experience/exp/tos",
  getUnit:
    "https://api-stg.verizon.com/atomapi/v1/addresslookup/addresses/units",
  getUnitLocus:
  "https://oa-stg.verizon.com/locus-address-api/address/typeahead-unit",
  getVZID:
    "https://api-stg.verizon.com/atomapi/v1/registryservice/registration/getVzid",
  getZipcode:
    "https://api-stg.verizon.com/atomapi/v1/addresslookup/addresses/zip",
  getvendorvisitdetails:
    "https://api-stg.verizon.com/atomapi/v1/sessionmanager/getvendorvisitdetails",
  checkPreLink:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/checkprelink?prelink=add",
  jsNotify:
    "https://api-stg.verizon.com/atomapi/v1/common/logger/logmsg",
  kafkaErrorAppLogs:
    "https://api-stg.verizon.com/atomapi/v1/common/kafka/atom_applogs",
  kafkaPageLogs:
    "https://api-stg.verizon.com/atomapi/v1/common/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://api-stg.verizon.com/atomapi/v1/common/kafka/atom_visitdetails",
  learnCustomTv: "https://www98.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://sit-activate.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://api-stg.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://sit-activate.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl: "https://sit-activate.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://api-stg.verizon.com/atomapi/v1/common/kafka/pageconfig",
  nsiNotify:
    "https://api-stg.verizon.com/atomapi/v1/addresslookup/addresses/nsinotification",
  orderConfirmation:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/getorderconfirmation",
  performEID:
    "https://api-stg.verizon.com/atomapi/v1/creditcheckservice/creditcheck/performeid",
  personlisationdmp:
    "https://api-stg.verizon.com/atomapi/v1/persionalizationservice/personalization/getvzdmptoak",
  pieUrl: "https://pie.prod.verizon.com/pie/v1",
  postCacheValue:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/updatecachestorage",
  processSave:
    "https://api-stg.verizon.com/atomapi/v1/smartcart/order/processsmartcart",
  productOffersUrl:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/offer/products/manual",
  profileCart:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/profile",
  chatDetails:
    "https://api-stg.verizon.com/atomapi/v1/chatinfoservice/chatInfo/chatdetails",
  referFrinedValidation:
    "https://api-stg.verizon.com/atomapi/v1/chatinfoservice/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/products/refreshPromotions",
  removePromoCode:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/products/removePromotions",
  resumeSmartCart:
    "https://api-stg.verizon.com/atomapi/v1/smartcart/order/resumesmartcart",
  retrieveQualdetails:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://api-stg.verizon.com/atomapi/v1/smartcart/order/retrievesmartcart",
  sameDaydelivery:
    "https://api-stg.verizon.com/atomapi/v1/storepickup/switch/samedaydelivery",
  seeFcpDetail:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/fcpspecialoffers",
  sendLofNotification:
    "https://api-stg.verizon.com/atomapi/v1/lofservice/lof/sendnotification",
  sendOTP:
    "https://api-stg.verizon.com/atomapi/v1/contactinfo/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://api-stg.verizon.com/atomapi/v1/registryservice/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://api-stg.verizon.com/atomapi/v1/common/notification/sendsmsoremail",
  setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://api-stg.verizon.com/atomapi/v1/duedateservice/duedate/reserveduedate",
  smartAutoSave:
    "https://api-stg.verizon.com/atomapi/v1/smartcart/order/smartcartsave",
  smartSave:
    "https://api-stg.verizon.com/atomapi/v1/smartcart/order/smartcartsavewithparam",
  smartcartCancel:
    "https://api-stg.verizon.com/atomapi/v1/smartcart/order/smartcartcancel",
  getSmartCartStatus:
    "https://api-stg.verizon.com/atomapi/v1/smartcart/order/smartcartstatus",
  storePickUp:
    "https://api-stg.verizon.com/atomapi/v1/storepickup/switch/storepickup",
  submitOrder: "https://api-stg.verizon.com/atomapi/v1/order/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  tokenGeneration: "/inhome/generatetoken",
  updateCartAcc:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateCartAccEc:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateintentcart:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/updateintent",
  updateintentcartAcc:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartEc:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/updateintent",
  uploadFile:
    "https://api-stg.verizon.com/atomapi/v1/careflowservice/careflow/employeeproof",
  updateFireAlarm:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/products/voice/firealarm",
  getFireAlarm:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/products/voice/getfirealarm",  
  validateBillingAdress:
    "https://api-stg.verizon.com/atomapi/v1/billing/order/billing",
  validateContactInfo:
    "https://api-stg.verizon.com/atomapi/v1/contactinfo/order/contact",
  validateCouponToken:
    "https://api-stg.verizon.com/atomapi/v1/careflowservice/careflow/validatecoupontoken",
  validateEmployee:
    "https://api-stg.verizon.com/atomapi/v1/careflowservice/careflow/validateemployee",
  validateName:
    "https://api-stg.verizon.com/atomapi/v1/contactinfo/order/validateName",
  validateSigninUrl:
    "https://api-stg.verizon.com/atomapi/v1/accountqualificationservice/account/validateSignin",
  validateSmartCartContactInfo:
    "https://api-stg.verizon.com/atomapi/v1/contactinfo/order/validateSmartCartContactInfo",
  validatecartUrl: "https://api-stg.verizon.com/atomapi/v1/cart/cart/validate/",
  validatecartUrlEc:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion/validate/",
  vendorFlow:
    "https://api-stg.verizon.com/atomapi/v1/sessionmanager/vendorflowvalidate",
  vendorFlowToken:
    "https://api-stg.verizon.com/atomapi/v1/sessionmanager/vendortokencreate",
  vepsUrl: "https://api-stg.verizon.com/atomapi/v1/veps/veps/payment",
  verifyOTP:
    "https://api-stg.verizon.com/atomapi/v1/contactinfo/ssocheck/verifyccpin",
  viewDetail:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/viewdetails",
  viewDetailAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/services/getlongdesc.fios",
  voicetn: "https://api-stg.verizon.com/atomapi/v1/phoneservices/phoneservices",
  vzFwdEnrollmentDetails: 
  "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/enrollmentDetails",
  twsSiginInDetails: 
  "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/twsSiginInDetails", 
  vzwOfferEligibility:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getWirelessProduct",
  MoveCheckoutExperience:
    "https://api-stg.verizon.com/atomapi/v1/contactinfo/order/moves/getCheckoutExperience",
  MoveLandingExperience:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/products/moves/getMovesExperience",
  MyVzSigninAF:
    "https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www.verizon.com&remainInOverlay=N&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3A%2F%2Fwww.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fwww.verizon.com%252Fforyourhome%252Fordering%252Fmyverizonnew%252Fregistrationbridge.aspx",
  MyVzSigninMV98:"https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www98.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fwww98.verizon.com%2fconsumer%2fmyverizon%2frouter%3ftarget%3dhttps%253a%252f%252fwww98.verizon.com%252finhome%252fmoves%252fqualification%253fismvflow%253dy",
  MyVzSigninMV:
    "https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fwww.verizon.com%252fforyourhome%252fmyaccount%252fngen%252fpr%252fcommon%252fergcon.aspx%253ftarget%253dhttps%25253a%25252f%25252forderinglite-gz-east.vpc.verizon.com%25252finhome%25252fqualification%25253fismvflow%25253dy",
  MyVzSigninMVBAU:
    "https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fwww.verizon.com%252fforyourhome%252fmyaccount%252fngen%252fpr%252fcommon%252fergcon.aspx%253ftarget%253dhttps%25253a%25252f%25252fwww.verizon.com%25252fforyourhome%25252fordering%25252fcheckavailabilitylq.aspx%25253fismvflow%25253dy",
  checkPDCdata:
    "https://api-stg.verizon.com/atomapi/v1/persionalizationservice/personalization/checkpdcdata",
  vzOrderInfo:
    "https://api-stg.verizon.com/atomapi/v1/vzorderservice/order/vzorderinfo",
  vzOrderDetail:
    "https://api-stg.verizon.com/atomapi/v1/vzorderservice/order/vzorderdetail",
  brtcInfo:
    "https://api-stg.verizon.com/atomapi/v1/vzorderservice/order/brtc",
  suppCancelCart: 
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/supp/",
  mfrtnFlow:
    "https://api-stg.verizon.com/atomapi/v1/careflowservice/frontliners/save",
  mnhOneClickVzwAccountSave:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/savewirelessaccountsystemobjectdetailstocache/",
  mnhOneClickQualification:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/mobileandhome/ecwlnewfiosqualification",
  wlCustomerCheckoutInfo:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/mobileandhome/wlcustomercheckoutinfo",
  mnhOneClickMarketingProfileSave:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/savemaketingprofiledetailstocache/",
  mnhOneClickLoopQualSave:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/saveloopqualtocache/",
  mnhOneClickLocusAddressValidationSave:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/savelocusaddrvalidationdetailstocache/",
  mnhOneClickOneCreditSave:
    "https://api-stg.verizon.com/atomapi/v1/creditcheckservice/creditcheck/savesfiosonecreditdetailstocache/",
  mnhOneClickEncryptWirelessDataToken:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/mobileandhome/encryptwirelessdatatoken",
  mnhOneClickMLP:
    "https://www.verizon.com/content/verizon/personal/services/fivegoneclick.nocache.html",
  ssoMHAuthiniticate:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk",
    fiosReferralCCAToken: "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
    fiosReferralVerifyToken: "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
    ssoMHEmailAuthiniticate:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",

  pollingIGBackendUrl:
    "https://login.verizonwireless.com/accessmanager/public/adaptiveauth/2fa/polling",
  verification:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/verification",
  ssoMHGetName:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname", 
    ssoMHGetCustomerDetails:"https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getcustomerdetailsresponse",
 
  runtimeValuesUrl:
    "https://api-stg.verizon.com/atomapi/v1/common/pageflow/getruntimevalues?runtimekey=",
  accessToken: "https://oa-stg.verizon.com/oauth/client_credential/accesstoken",
  getConsumerKey:"sjiAt4LGSA1XpYxNy5VT73Nj4D5ezwmq",
  getConsumerSecret:"5zwI2hDARRGU0lFh",
  getFiosQualification: "https://oa-stg.verizon.com/v06g-gbcom-api/Qualify/GetFiosQualification",
  generateTokenForVzw:"https://api-stg.verizon.com/atomapi/v1/cart/mh/encryptvzwexternaltoken",
  storePickupCRP:"https://api-stg.verizon.com/atomapi/v1/notificationservice/whatsnext/storepickup",
  getFccLabel:"https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/fccLabelData",
  getMovesThrottle: "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/nsathrottlelist",
  disconnectBanner: "https://www.verizon.com/consumer/myverizon/homeoffers",
  mvaDisconnectBanner: "https://www.verizon.com/consumer/fios/secure/ui/acct/homeoffers", 
  sendVisitId : "https://api.verizon.com/atomapi/v1/cart/cart/updateSSP/",
  retentionOffer : "https://api.verizon.com/atomapi/v1/cart/cart/checkEligibleOffer/",
  updateFlowType:
    "https://api-stg.verizon.com/atomapi/v1/sessionmanager/updateflowtype",
    getPerksAEM:"https://www.verizon.com/content/caas/plan/aggregated-perks.model.json",
   getpzaiRatingNumber: "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/fiospzai",
   getCentralAgreementTermsAEM: "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/products/tosCentralAgreement",
  ...changePreProdApigee
};

const preProdProxy = {
  Wireless5Gurl: "https://www.verizon.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl: "https://www.verizon.com/home/lte-home-internet/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/affinityvalidation",
  channelLineupPackageView:
    "https://atomchannellookupstg.cfappsawsnpwest.ebiz.verizon.com/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://atomchannellookupstg.cfappsawsnpwest.ebiz.verizon.com/channels/allpackages",
  channelLineupVhoUrl:
    "https://atomchannellookupstg.cfappsawsnpwest.ebiz.verizon.com/channels/vho",
  channelProgramMasterUrl:
    "https://atomchannellookupstg.cfappsawsnpwest.ebiz.verizon.com/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://atomchannellookupstg.cfappsawsnpwest.ebiz.verizon.com/channels/searchforchannelprogram",
  chatEncry: "Y",
  chatEncrypt:
    "https://atomchatinfostg.cfappsawsnpwest.ebiz.verizon.com/chatInfo/hvals",
  chatReint: "Y",
  chatStore:
    "https://atomchatinfostg.cfappsawsnpwest.ebiz.verizon.com/chatInfo/storeChatInfo",
  checkAddr:
    "https://atomaddressqualificationstg.cfappsawsnpwest.ebiz.verizon.com/address/qualification?addressID=",
  checkportability:
    "https://atomtnportabilitystg.cfappsawsnpwest.ebiz.verizon.com/tnportability",
  clearCart:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/clearcart",
  clearCartEC:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/clearcartec",
  compareCart:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/compare",
  configEntry:
    "https://www98.verizon.com/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://wwwaws98.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://wwwaws98.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId:
    "https://atomsessionmanagerstg.cfappsawsnpwest.ebiz.verizon.com/visitid",
  creditAssessment:
    "https://atomcreditcheckstg.cfappsawsnpwest.ebiz.verizon.com/creditcheck/creditfiosassessment",
  creditCheck:
    "https://atomcreditcheckstg.cfappsawsnpwest.ebiz.verizon.com/creditcheck/creditworthiness",
  creditRefresh:
    "https://atomcreditcheckstg.cfappsawsnpwest.ebiz.verizon.com/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://atomcreditcheckstg.cfappsawsnpwest.ebiz.verizon.com/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://atomaccountqualificationstg.cfappsawsnpwest.ebiz.verizon.com/account/decryptData",
  dobundle:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/products/dobundle",
    vecorder:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "https://www98.verizon.com/includes/commongf/",
  ecHeader: "https://www98.verizon.com/includes/commongh/",
  encryptUrl:
    "https://atomaccountqualificationstg.cfappsawsnpwest.ebiz.verizon.com/account/encryptData",
  fbeGetSoc:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/getSoc",
  fbePostSoc: "https://atomsocstg.cfappsawsnpwest.ebiz.verizon.com/fbe/PostSoc",
  futurenotification:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/futurenotification",
  generateToken:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/gettoken",
  getAccount:
    "https://atomsessionmanagerstg.cfappsawsnpwest.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account",
  getBanners:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/banners",
  getCacheValue:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/getcachevalue",
  getCartAcc:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion",
  getCartAccEc:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion",
  getDisclaimer:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/disclaimer",
  getDisclaimerAEM:
    "https://www98.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getDisclaimerProducts:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://preprod-east-gz.vpc.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/commondisclaimer",
  getCommonAEM:
    "https://preprod-east-gz.vpc.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getPlansPromo:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/planspromo",
  getPlansPromoAEM:
    "https://www98.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDueDate:
    "https://atomduedatestg.cfappsawsnpwest.ebiz.verizon.com/duedate/triggerduedate",
  getExistingService:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/existingservice",
  getFaq: "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/faq",
  getFaqAEM:
    "https://www98.verizon.com/personal/cas/getfaq.model.json",
  getMon: "https://atommonstg.cfappsawsnpwest.ebiz.verizon.com/order/mon",
  getPartialStreetAddr:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/street?streetterm=",
  getCompleteAddress:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/address?addressid=",
  getProduct:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/accordion/products",
  getProductEc:
    "https://atomproductecexpstg.cfappsawsnpwest.ebiz.verizon.com/accordion/products",
  getProductPerks:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/accordion/products",
  getProductPerksEc:
    "https://atomproductecexpstg.cfappsawsnpwest.ebiz.verizon.com/accordion/products",
  getPerksAEM:"https://sales-bau-sit1-publisher.ebiz.verizon.com/content/caas/plan/aggregated-perks.model.json",
  getVoiceProductEc:
    "https://atomproductecexpstg.cfappsawsnpwest.ebiz.verizon.com/products",
  getSmartCartPersonalInfo:
    "https://atomcontactinfovalidationstg.cfappsawsnpwest.ebiz.verizon.com/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "3hBtC8PjGnZ5pG3AmtcFnGmlPtTbiwa4",
  getStreetAddrLocus2:
  "https://oa-stg.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "YT2N6GkuOjvISXmvQUeSW5XA1MA990VF",
  qualification5G:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/addressqualification/address/fixedwirelesscoveragecheck",
  getTerms:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/terms",
  getTermsAEM:
    "https://preprod-east-gz.vpc.verizon.com/personal/cas/getorderingtos.model.json", 
    getCentralAgreementTermsAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement~html.json",
  getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos: "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/tos",
  getUnit:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/units",
  getUnitLocus:
  "https://oa-stg.verizon.com/locus-address-api/address/typeahead-unit",
  getVZID:
    "https://atomregistrationstg.cfappsawsnpwest.ebiz.verizon.com/registration/getVzid",
  getZipcode:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/zip",
  getvendorvisitdetails:
    "https://atomsessionmanagerstg.cfappsawsnpwest.ebiz.verizon.com/getvendorvisitdetails",
  validateVendorToken: 
    "https://preprod-east-gz.vpc.verizon.com/inhome/validatevendortoken",
    fetchEmeriosInfo: 
    "https://preprod-east-gz.vpc.verizon.com/inhome/fetchEmeriosInfo",
  checkPreLink:
    "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/checkprelink?prelink=add",
  jsNotify:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/logger/logmsg",
  kafkaErrorAppLogs:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/kafka/atom_applogs",
  kafkaPageLogs:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/kafka/atom_visitdetails",
  learnCustomTv: "https://www98.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://sit-activate.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://atomvendorexperiencestg.cfappsawsnpwest.ebiz.verizon.com/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://sit-activate.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl: "https://sit-activate.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/kafka/pageconfig",
  nsiNotify:
    "https://atomaddresslookupstg.cfappsawsnpwest.ebiz.verizon.com/addresses/nsinotification",
  orderConfirmation:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/getorderconfirmation",
  performEID:
    "https://atomcreditcheckstg.cfappsawsnpwest.ebiz.verizon.com/creditcheck/performeid",
  personlisationdmp:
    "https://atompersonalisationstg.cfappsawsnpwest.ebiz.verizon.com/personalization/getvzdmptoak",
  pieUrl: "https://pie.prod.verizon.com/pie/v1",
  postCacheValue:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/updatecachestorage",
  processSave:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/processsmartcart",
  productOffersUrl:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/offer/products/manual",
  profileCart:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/profile",
  chatDetails:
    "https://atomchatinfostg.cfappsawsnpwest.ebiz.verizon.com/chatInfo/chatdetails",
  referFrinedValidation:
    "https://atomchatinfostg.cfappsawsnpwest.ebiz.verizon.com/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://atomvzwoffereligibilitystg.cfappsawsnpwest.ebiz.verizon.com/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/products/refreshPromotions",
  removePromoCode:
    "https://atomproductstg.cfappsawsnpwest.ebiz.verizon.com/products/removePromotions",
  resumeSmartCart:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/resumesmartcart",
  retrieveQualdetails:
    "https://atomaddressqualificationstg.cfappsawsnpwest.ebiz.verizon.com/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/retrievesmartcart",
  sameDaydelivery:
    "https://atomstorepickupstg.cfappsawsnpwest.ebiz.verizon.com/switch/samedaydelivery",
  seeFcpDetail:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/fcpspecialoffers",
  seeDetail:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/fcpspecialoffers",
  sendLofNotification:
    "https://atomlofstg.cfappsawsnpwest.ebiz.verizon.com/lof/sendnotification",
  sendOTP:
    "https://atomssocheckstg.cfappsawsnpwest.ebiz.verizon.com/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://atomregistrationstg.cfappsawsnpwest.ebiz.verizon.com/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://atomcommonstg.cfappsawsnpwest.ebiz.verizon.com/notification/sendsmsoremail",
    setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://atomduedatestg.cfappsawsnpwest.ebiz.verizon.com/duedate/reserveduedate",
  smartAutoSave:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/smartcartsave",
  smartSave:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/smartcartsavewithparam",
  smartcartCancel:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/smartcartcancel",
  getSmartCartStatus:
    "https://atomsmartcartstg.cfappsawsnpwest.ebiz.verizon.com/order/smartcartstatus",
  storePickUp:
    "https://atomstorepickupstg.cfappsawsnpwest.ebiz.verizon.com/switch/storepickup",
  submitOrder:
    "https://atomordersubmissionstg.cfappsawsnpwest.ebiz.verizon.com/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  updateCartAcc:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/updatecart",
  updateCartAccEc:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/updatecart",
  updateintentcart:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/updateintent",
  updateintentcartAcc:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/updateintent",
  updateintentcartEc:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/updateintent",
  uploadFile:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/employeeproof",
  validateBillingAdress:
    "https://atombillingvalidationstg.cfappsawsnpwest.ebiz.verizon.com/order/billing",
  validateContactInfo:
    "https://atomcontactinfovalidationstg.cfappsawsnpwest.ebiz.verizon.com/order/contact",
  validateCouponToken:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/validatecoupontoken",
  validateEmployee:
    "https://atomcareflowstg.cfappsawsnpwest.ebiz.verizon.com/careflow/validateemployee",
  validateName:
    "https://atomcontactinfovalidationstg.cfappsawsnpwest.ebiz.verizon.com/order/validateName",
  validateSigninUrl:
    "https://atomaccountqualificationstg.cfappsawsnpwest.ebiz.verizon.com/account/validateSignin",
  validateSmartCartContactInfo:
    "https://atomcontactinfovalidationstg.cfappsawsnpwest.ebiz.verizon.com/order/validateSmartCartContactInfo",
  validatecartUrl:
    "https://atomcartstg.cfappsawsnpwest.ebiz.verizon.com/cart/validate/",
  validatecartUrlEc:
    "https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/validate/",
  vendorFlow:
    "https://atomsessionmanagerstg.cfappsawsnpwest.ebiz.verizon.com/vendorflowvalidate",
  vendorFlowToken:
    "https://atomsessionmanagerstg.cfappsawsnpwest.ebiz.verizon.com/vendortokencreate",
  vepsUrl: "https://atomvepsstg.cfappsawsnpwest.ebiz.verizon.com/veps/payment",
  verifyOTP:
    "https://atomssocheckstg.cfappsawsnpwest.ebiz.verizon.com/ssocheck/verifyccpin",
  viewDetail:
    "https://atomexperiencestg.cfappsawsnpwest.ebiz.verizon.com/exp/viewdetails",
  viewDetailAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/services/getlongdesc.fios",
  voicetn:
    "https://atomphoneservicesstg.cfappsawsnpwest.ebiz.verizon.com/phoneservices",
    vzFwdEnrollmentDetails: 
    "https://atomaddressqualificationstg.cfappsawsnpwest.ebiz.verizon.com/address/enrollmentDetails", 
  twsSiginInDetails: 
    "https://atomaddressqualificationstg.cfappsawsnpwest.ebiz.verizon.com/address/twsSiginInDetails", 
  vzwOfferEligibility:
    "https://atomvzwoffereligibilitystg.cfappsawsnpwest.ebiz.verizon.com/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://atomvzwoffereligibilitystg.cfappsawsnpwest.ebiz.verizon.com/eligibility/getWirelessProduct",
  checkPDCdata:
    "https://atompersonalisationstg.cfappsawsnpwest.ebiz.verizon.com/personalization/checkpdcdata",
  vzOrderInfo:
    "https://atomserviceseaststg.ebiz.verizon.com/v05g/sit/vzorder/order/vzorderinfo",
  vzOrderDetail:
    "https://atomserviceseaststg.ebiz.verizon.com/v05g/sit/vzorder/order/vzorderdetail",
  brtcInfo:
    "https://atomserviceseaststg.ebiz.verizon.com/v05g/sit/vzorder/order/brtc",
  suppCancelCart:
    "https://atomserviceseaststg.ebiz.verizon.com/v05g/sit/cart/cart/supp/",
  ssoMHAuthiniticate:
    "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk",
    fiosReferralCCAToken: "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
    fiosReferralVerifyToken: "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
    ssoMHEmailAuthiniticate:
    "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",
  pollingIGBackendUrl:
    "https://login.verizonwireless.com/accessmanager/public/adaptiveauth/2fa/polling",
  ssoMHGetName:
    "https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname",  
    ssoMHGetCustomerDetails:"https://atomserviceseaststg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getcustomerdetailsresponse",

  mfrtnFlow:
    "https://atomserviceseaststg.ebiz.verizon.com/v05g/stg/careflow/frontliners/save",
  generateTokenForVzw:"https://atomcartecstg.cfappsawsnpwest.ebiz.verizon.com/cart/mh/encryptvzwexternaltoken",
  check5GAvailability: 'https://www.verizon.com/soe/digital/prospect/qualificationservice/nse/check5GAvailability', 
  disconnectBanner: "https://sso-np3.ebiz.verizon.com/consumer/myverizon/homeoffers",
  mvaDisconnectBanner: "https://www.verizon.com/consumer/fios/secure/ui/acct/homeoffers", 
  sendVisitId : "https://api-stg.verizon.com/atomapi/v1/cart/cart/updateSSP/",
  hmpFindActiveSchedule:"https://www.verizon.com/soe/digital/prospect/qualificationservice/hmpDigital/findActiveSchedule",
  hmpEligibilityChecks:"https://www.verizon.com/soe/digital/prospect/qualificationservice/hmpDigital/hmpEligibilityChecks",
  hmpHome:"https://www.verizon.com/soe/digital/prospect/qualificationservice/optin/hmpHome",
  retailStoreDetails: "https://www.verizon.com/soe/digital/prospect/peripheralsservice/getClosingAgencyDetails",
  lookupReferralNumber: "https://www.verizon.com/soe/digital/prospect/peripheralsservice/lookupRetailCollaborationCode",
  updateFlowType:
    "https://atomserviceseaststg.ebiz.verizon.com/atomapi/v1/sessionmanager/updateflowtype",
  ...changePreProdProxy
};

const preProdApigee = {
  Wireless5Gurl: "https://www.verizon.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl: "https://www.verizon.com/home/lte-home-internet/?src=inhome&doLqCall=Y",
  accessToken: "https://oa-stg.verizon.com/oauth/client_credential/accesstoken",
  getConsumerKey:"sjiAt4LGSA1XpYxNy5VT73Nj4D5ezwmq",
  getConsumerSecret:"5zwI2hDARRGU0lFh",
  getFiosQualification: "https://oa-stg.verizon.com/v06g-gbcom-api/Qualify/GetFiosQualification",
  careFlowFormValidation:
    "https://api-stg.verizon.com/atomapi/v1/careflowservice/careflow/affinityvalidation",
  getAffinityCompanyList: "https://api-stg.verizon.com/atomapi/v1/careflowservice/careflow/getCompaniesList",
  emailValidationURL:"https://api-stg.verizon.com/atomapi/v1/careflowservice/careflow/validateemail",
  manualEmailValidationURL:"https://api-stg.verizon.com/atomapi/v1/careflowservice/careflow/manualvalidation",
  channelLineupPackageView:
    "https://api-stg.verizon.com/atomapi/v1/channellookup/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://api-stg.verizon.com/atomapi/v1/channellookup/channels/allpackages",
  channelLineupVhoUrl:
    "https://api-stg.verizon.com/atomapi/v1/channellookup/channels/vho",
  channelProgramMasterUrl:
    "https://api-stg.verizon.com/atomapi/v1/channellookup/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://api-stg.verizon.com/atomapi/v1/channellookup/channels/searchforchannelprogram",
  chatEncry: "Y",
  qualification5G:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/fixedwirelesscoveragecheck",
  chatEncrypt:
    "https://api-stg.verizon.com/atomapi/v1/chatinfoservice/chatInfo/hvals",
  chatReint: "Y",
  chatStore:
    "https://api-stg.verizon.com/atomapi/v1/chatinfoservice/chatInfo/storeChatInfo",
  checkAddr:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/qualification?addressID=",
  fiosMnhFetch:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/fiosmnh",
  checkportability:
    "https://api-stg.verizon.com/atomapi/v1/tnportability/tnportability",
  clearCart:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion/clearcart",
  clearCartEC:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion/clearcartec",
  compareCart:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion/compare",
  configEntry:
    "https://www98.verizon.com/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://www98.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://www98.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId: "/inhome/generatevisitid",
  creditAssessment:
    "https://api-stg.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditfiosassessment",
  creditCheck:
    "https://api-stg.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditworthiness",
  creditRefresh:
    "https://api-stg.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://api-stg.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://api-stg.verizon.com/atomapi/v1/accountqualificationservice/account/decryptData",
  dobundle:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/products/dobundle",
    vecorder:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "https://www98.verizon.com/includes/commongf/",
  ecHeader: "https://www98.verizon.com/includes/commongh/",
  encryptUrl:
    "https://api-stg.verizon.com/atomapi/v1/accountqualificationservice/account/encryptData",
  fbeGetSoc: "https://api-stg.verizon.com/atomapi/v1/experience/exp/getSoc",
  fbePostSoc: "https://api-stg.verizon.com/atomapi/v1/soc/fbe/PostSoc",
  futurenotification:
    "https://api-stg.verizon.com/atomapi/v1/addresslookup/addresses/futurenotification",
  generateToken:
    "https://api-stg.verizon.com/atomapi/v1/careflowservice/careflow/gettoken",
  getAccount:
    "https://api-stg.verizon.com/atomapi/v1/accountqualificationservice/account",
  getBanners: "https://api-stg.verizon.com/atomapi/v1/experience/exp/banners",
  getCacheValue:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/getcachevalue",
  getCartAcc: "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion",
  getCartAccEc:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion",
  getPlansPromo:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/planspromo",
  reflowOrderSubmission:
    "https://atomservicespreprod-west.verizon.com/v05g/preprod/debugger/ordersubmission",
  getPlansPromoAEM:
    "https://www98.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDisclaimerProducts:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://preprod-east-gz.vpc.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/commondisclaimer",
  getCommonAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getDisclaimer:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/disclaimer",
  getDisclaimerAEM:
    "https://www98.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getDueDate:
    "https://api-stg.verizon.com/atomapi/v1/duedateservice/duedate/triggerduedate",
  getExistingService:
    "https://api-stg.verizon.com/atomapi/v1/addresslookup/addresses/existingservice",
  getFaq: "https://api-stg.verizon.com/atomapi/v1/experience/exp/faq",
  getFaqAEM:
    "https://www98.verizon.com/personal/cas/getfaq.model.json",
  getMon: "https://api-stg.verizon.com/atomapi/v1/masterordernumber/order/mon",
  getPartialStreetAddr:
    "https://api-stg.verizon.com/atomapi/v1/addresslookup/addresses/street?streetterm=",
  getCompleteAddress:
    "https://api-stg.verizon.com/atomapi/v1/addresslookup/addresses/address?addressid=",
  getProduct:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/accordion/products",
  getProductEc:
    "https://api-stg.verizon.com/atomapi/v1/ecproductservice/accordion/products",
  getProductPerks:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/accordion/products",
  getProductPerksEc:
    "https://api-stg.verizon.com/atomapi/v1/ecproductservice/accordion/products",
  getPerksAEM:"https://sales-bau-sit1-publisher.ebiz.verizon.com/content/caas/plan/aggregated-perks.model.json",
  getVoiceProductEc:
    "https://api-stg.verizon.com/atomapi/v1/ecproductservice/products",
  getSmartCartPersonalInfo:
    "https://api-stg.verizon.com/atomapi/v1/contactinfo/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://api-stg.verizon.com/atomapi/v1/addresslookup/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "5vbCkJw5g5e3LNaY8cgcnPpyQGPrhjIw",
  getStreetAddrLocus2:
  "https://oa-stg.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "5vbCkJw5g5e3LNaY8cgcnPpyQGPrhjIw",
  getTerms: "https://api-stg.verizon.com/atomapi/v1/experience/exp/terms",
  getTermsAEM:
    "https://preprod-east-gz.vpc.verizon.com/personal/cas/getorderingtos.model.json",     
  getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos: "https://api-stg.verizon.com/atomapi/v1/experience/exp/tos",
  getUnit:
    "https://api-stg.verizon.com/atomapi/v1/addresslookup/addresses/units",
  getUnitLocus:
  "https://oa-stg.verizon.com/locus-address-api/address/typeahead-unit",
  getVZID:
    "https://api-stg.verizon.com/atomapi/v1/registryservice/registration/getVzid",
  getZipcode:
    "https://api-stg.verizon.com/atomapi/v1/addresslookup/addresses/zip",
  getvendorvisitdetails:
    "https://api-stg.verizon.com/atomapi/v1/sessionmanager/getvendorvisitdetails",
  validateVendorToken: 
    "https://preprod-east-gz.vpc.verizon.com/inhome/validatevendortoken",
    fetchEmeriosInfo: 
    "https://preprod-east-gz.vpc.verizon.com/inhome/fetchEmeriosInfo",
  checkPreLink:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/checkprelink?prelink=add",
  jsNotify:
    "https://api-stg.verizon.com/atomapi/v1/common/logger/logmsg",
  kafkaErrorAppLogs:
    "https://api-stg.verizon.com/atomapi/v1/common/kafka/atom_applogs",
  kafkaPageLogs:
    "https://api-stg.verizon.com/atomapi/v1/common/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://api-stg.verizon.com/atomapi/v1/common/kafka/atom_visitdetails",
  learnCustomTv: "https://www98.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://sit-activate.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://api-stg.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://sit-activate.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl: "https://sit-activate.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://api-stg.verizon.com/atomapi/v1/common/kafka/pageconfig",
  nsiNotify:
    "https://api-stg.verizon.com/atomapi/v1/addresslookup/addresses/nsinotification",
  orderConfirmation:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/getorderconfirmation",
  performEID:
    "https://api-stg.verizon.com/atomapi/v1/creditcheckservice/creditcheck/performeid",
  personlisationdmp:
    "https://api-stg.verizon.com/atomapi/v1/persionalizationservice/personalization/getvzdmptoak",
  pieUrl: "https://pie.prod.verizon.com/pie/v1",
  postCacheValue:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/updatecachestorage",
  processSave:
    "https://api-stg.verizon.com/atomapi/v1/smartcart/order/processsmartcart",
  productOffersUrl:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/offer/products/manual",
  profileCart:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/profile",
  chatDetails:
    "https://api-stg.verizon.com/atomapi/v1/chatinfoservice/chatInfo/chatdetails",
  referFrinedValidation:
    "https://api-stg.verizon.com/atomapi/v1/chatinfoservice/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/products/refreshPromotions",
  removePromoCode:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/products/removePromotions",
  resumeSmartCart:
    "https://api-stg.verizon.com/atomapi/v1/smartcart/order/resumesmartcart",
  retrieveQualdetails:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://api-stg.verizon.com/atomapi/v1/smartcart/order/retrievesmartcart",
  sameDaydelivery:
    "https://api-stg.verizon.com/atomapi/v1/storepickup/switch/samedaydelivery",
  seeFcpDetail:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/fcpspecialoffers",
  sendLofNotification:
    "https://api-stg.verizon.com/atomapi/v1/lofservice/lof/sendnotification",
  sendOTP:
    "https://api-stg.verizon.com/atomapi/v1/contactinfo/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://api-stg.verizon.com/atomapi/v1/registryservice/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://api-stg.verizon.com/atomapi/v1/common/notification/sendsmsoremail",
    setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://api-stg.verizon.com/atomapi/v1/duedateservice/duedate/reserveduedate",
  smartAutoSave:
    "https://api-stg.verizon.com/atomapi/v1/smartcart/order/smartcartsave",
  smartSave:
    "https://api-stg.verizon.com/atomapi/v1/smartcart/order/smartcartsavewithparam",
  smartcartCancel:
    "https://api-stg.verizon.com/atomapi/v1/smartcart/order/smartcartcancel",
  getSmartCartStatus:
    "https://api-stg.verizon.com/atomapi/v1/smartcart/order/smartcartstatus",
  storePickUp:
    "https://api-stg.verizon.com/atomapi/v1/storepickup/switch/storepickup",
  submitOrder: "https://api-stg.verizon.com/atomapi/v1/order/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  tokenGeneration: "/inhome/generatetoken",
  updateCartAcc:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateCartAccEc:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateintentcart:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/updateintent",
  updateintentcartAcc:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartEc:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/updateintent",
  uploadFile:
    "https://api-stg.verizon.com/atomapi/v1/careflowservice/careflow/employeeproof",
  validateBillingAdress:
    "https://api-stg.verizon.com/atomapi/v1/billing/order/billing",
  validateContactInfo:
    "https://api-stg.verizon.com/atomapi/v1/contactinfo/order/contact",
  validateCouponToken:
    "https://api-stg.verizon.com/atomapi/v1/careflowservice/careflow/validatecoupontoken",
  validateEmployee:
    "https://api-stg.verizon.com/atomapi/v1/careflowservice/careflow/validateemployee",
  validateName:
    "https://api-stg.verizon.com/atomapi/v1/contactinfo/order/validateName",
  validateSigninUrl:
    "https://api-stg.verizon.com/atomapi/v1/accountqualificationservice/account/validateSignin",
  validateSmartCartContactInfo:
    "https://api-stg.verizon.com/atomapi/v1/contactinfo/order/validateSmartCartContactInfo",
  validatecartUrl: "https://api-stg.verizon.com/atomapi/v1/cart/cart/validate/",
  validatecartUrlEc:
    "https://api-stg.verizon.com/atomapi/v1/cart/cart/accordion/validate/",
  vendorFlow:
    "https://api-stg.verizon.com/atomapi/v1/sessionmanager/vendorflowvalidate",
  vendorFlowToken:
    "https://api-stg.verizon.com/atomapi/v1/sessionmanager/vendortokencreate",
  vepsUrl: "https://api-stg.verizon.com/atomapi/v1/veps/veps/payment",
  verifyOTP:
    "https://api-stg.verizon.com/atomapi/v1/contactinfo/ssocheck/verifyccpin",
  viewDetail:
    "https://api-stg.verizon.com/atomapi/v1/experience/exp/viewdetails",
  viewDetailAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/services/getlongdesc.fios",
  voicetn: "https://api-stg.verizon.com/atomapi/v1/phoneservices/phoneservices",
  vzFwdEnrollmentDetails: 
  "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/enrollmentDetails", 
  twsSiginInDetails: 
   "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/twsSiginInDetails",
  vzwOfferEligibility:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getWirelessProduct",
  MoveCheckoutExperience:
    "https://api-stg.verizon.com/atomapi/v1/contactinfo/order/moves/getCheckoutExperience",
  MoveLandingExperience:
    "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/products/moves/getMovesExperience",
    MyVzSigninEspanolAF:
    "https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://espanol.verizon.com&remainInOverlay=N&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3A%2F%2Fespanol.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fespanol.verizon.com%252Fforyourhome%252Fordering%252Fmyverizonnew%252Fregistrationbridge.aspx",
  MyVzSigninAF:
    "https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www.verizon.com&remainInOverlay=N&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3A%2F%2Fwww.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fwww.verizon.com%252Fforyourhome%252Fordering%252Fmyverizonnew%252Fregistrationbridge.aspx",
  MyVzSigninMV98:"https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www98.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fwww98.verizon.com%2fconsumer%2fmyverizon%2frouter%3ftarget%3dhttps%253a%252f%252fwww98.verizon.com%252finhome%252fmoves%252fqualification%253fismvflow%253dy",
  MyVzSigninMV:
    "https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www98.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fwww98.verizon.com%2fconsumer%2fmyverizon%2frouter%3ftarget%3dhttps%253a%252f%252fwww98.verizon.com%252finhome%252fmoves%252fqualification%253fismvflow%253dy",
  MyVzSigninMVBAU:
    "https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fwww.verizon.com%252fforyourhome%252fmyaccount%252fngen%252fpr%252fcommon%252fergcon.aspx%253ftarget%253dhttps%25253a%25252f%25252fwww.verizon.com%25252fforyourhome%25252fordering%25252fcheckavailabilitylq.aspx%25253fismvflow%25253dy",
  checkPDCdata:
    "https://api-stg.verizon.com/atomapi/v1/persionalizationservice/personalization/checkpdcdata",
  vzOrderInfo:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzorderservice/order/vzorderinfo",
  vzOrderDetail:
    "https://api-stg.verizon.com/atomapi/v1/vzorderservice/order/vzorderdetail",
  brtcInfo:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzorderservice/order/brtc",
  suppCancelCart:
   "https://api-stg.verizon.com/atomapi/v1/cart/cart/supp/",
  mfrtnFlow:
    "https://api-stg.verizon.com/atomapi/v1/careflowservice/frontliners/save",
  mfrtnmoveEligibleCheck:
    "https://api-stg.verizon.com/atomapi/v1/careflowservice/frontliners/retrieve",
  UTDrecommendationinfo:
    "https://api.verizon.com/atomapi/v1/ecexperienceservice/accountexp/ultimatetrialrecommendationinfo",
  UTDsspuage:
    "https://api.verizon.com/atomapi/v1/repguidanceservice/usage/sspusageinfo?zipCode=",
  mnhOneClickVzwAccountSave:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/savewirelessaccountsystemobjectdetailstocache/",
  mnhOneClickQualification:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/mobileandhome/ecwlnewfiosqualification",
  wlCustomerCheckoutInfo:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/mobileandhome/wlcustomercheckoutinfo",
  mnhOneClickMarketingProfileSave:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/savemaketingprofiledetailstocache/",
  mnhOneClickLoopQualSave:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/saveloopqualtocache/",
  mnhOneClickLocusAddressValidationSave:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/address/savelocusaddrvalidationdetailstocache/",
  mnhOneClickOneCreditSave:
    "https://api-stg.verizon.com/atomapi/v1/creditcheckservice/creditcheck/savesfiosonecreditdetailstocache/",
  mnhOneClickEncryptWirelessDataToken:
    "https://api-stg.verizon.com/atomapi/v1/addressqualification/mobileandhome/encryptwirelessdatatoken",
  ssoMHAuthiniticate:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk",
    fiosReferralCCAToken: "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
    fiosReferralVerifyToken: "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
    ssoMHEmailAuthiniticate:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",
  pollingIGBackendUrl:
    "https://login.verizonwireless.com/accessmanager/public/adaptiveauth/2fa/polling",
  verification:
    'https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/verification',
  ssoMHGetName:
    "https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname",
    ssoMHGetCustomerDetails:"https://api-stg.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getcustomerdetailsresponse",
 
     
  mnhOneClickMLP:
    "https://www.verizon.com/content/verizon/personal/services/fivegoneclick.nocache.html",
    runtimeValuesUrl:
    "https://api-stg.verizon.com/atomapi/v1/common/pageflow/getruntimevalues?runtimekey=",
    generateTokenForVzw:"https://api-stg.verizon.com/atomapi/v1/cart/mh/encryptvzwexternaltoken",
    getFccLabel:"https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/fccLabelData",
    getMovesThrottle: "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/nsathrottlelist",
    check5GAvailability: 'https://www.verizon.com/soe/digital/prospect/qualificationservice/nse/check5GAvailability', 
    disconnectBanner: "https://sso-np3.ebiz.verizon.com/consumer/myverizon/homeoffers",
    mvaDisconnectBanner: "https://www.verizon.com/consumer/fios/secure/ui/acct/homeoffers", 
    sendVisitId : "https://api-stg.verizon.com/atomapi/v1/cart/cart/updateSSP/",
    hmpFindActiveSchedule:"https://www.verizon.com/soe/digital/prospect/qualificationservice/hmpDigital/findActiveSchedule",
    hmpEligibilityChecks:"https://www.verizon.com/soe/digital/prospect/qualificationservice/hmpDigital/hmpEligibilityChecks",
    hmpHome:"https://www.verizon.com/soe/digital/prospect/qualificationservice/optin/hmpHome",
    retailStoreDetails: "https://www.verizon.com/soe/digital/prospect/peripheralsservice/getClosingAgencyDetails",
    lookupReferralNumber: "https://www.verizon.com/soe/digital/prospect/peripheralsservice/lookupRetailCollaborationCode",
    updateFlowType:
    "https://api-stg.verizon.com/atomapi/v1/atomapi/v1/sessionmanager/updateflowtype",
    getCentralAgreementTermsAEM: "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/products/tosCentralAgreement",
    getpzaiRatingNumber: "https://api-stg.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/fiospzai",    
  ...changePreProdApigee
};

const prodApigee = {
  MyVzSigninEspanolAF:
  "https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://espanol.verizon.com&remainInOverlay=N&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3A%2F%2Fespanol.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fespanol.verizon.com%252Fforyourhome%252Fordering%252Fmyverizonnew%252Fregistrationbridge.aspx",
  MyVzSigninEspanolAFNew:
  "https://secure.verizon.com/signin?userNameOnly=true&clientId=VZCOMBQ&goto=https%3A%2F%2Fespanol.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fespanol.verizon.com%252Fforyourhome%252Fordering%252Fmyverizonnew%252Fregistrationbridge.aspx",
  MyVzSigninAF:
    "https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www.verizon.com&remainInOverlay=N&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3A%2F%2Fwww.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fwww.verizon.com%252Fforyourhome%252Fordering%252Fmyverizonnew%252Fregistrationbridge.aspx",
  MyVzSigninAFNew:
    "https://secure.verizon.com/signin?userNameOnly=true&clientId=VZCOMBQ&goto=https%3A%2F%2Fwww.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fwww.verizon.com%252Fforyourhome%252Fordering%252Fmyverizonnew%252Fregistrationbridge.aspx",
  MyVzSigninInhomeAF:
	"https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www.verizon.com&remainInOverlay=N&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3A%2F%2Fwww.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fwww.verizon.com%252finhome%252fchange%252fsignin%253fflowtype%253daf",
  MyVzSigninInhomeAFNew:
    "https://secure.verizon.com/signin?userNameOnly=true&clientId=VZCOMBQ&goto=https%3A%2F%2Fwww.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fwww.verizon.com%252finhome%252fchange%252fsignin%253fflowtype%253daf",
  MyVzSigninMVBAU:
    "https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fwww.verizon.com%252fforyourhome%252fmyaccount%252fngen%252fpr%252fcommon%252fergcon.aspx%253ftarget%253dhttps%25253a%25252f%25252fwww.verizon.com%25252fforyourhome%25252fordering%25252fcheckavailabilitylq.aspx%25253fismvflow%25253dy",
  MyVzSigninMVBAUNew:
    "https://secure.verizon.com/signin?mode=i&userNameOnly=true&clientId=VZCOMBQ&goto=https%3a%2f%2fssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fwww.verizon.com%252fforyourhome%252fmyaccount%252fngen%252fpr%252fcommon%252fergcon.aspx%253ftarget%253dhttps%25253a%25252f%25252fwww.verizon.com%25252fforyourhome%25252fordering%25252fcheckavailabilitylq.aspx%25253fismvflow%25253dy",
  MyVzSigninMV:
    "https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3A%2F%2Fwww.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Fsrc%3DRAPPOS%26target%3Dhttps%253a%252f%252fwww.verizon.com%252finhome%2Fmoves%252fqualification%253fismvflow%253dy",
  MyVzSigninMVNew:
    "https://secure.verizon.com/signin?mode=i&userNameOnly=true&clientId=VZCOMBQ&goto=https%3A%2F%2Fwww.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Fsrc%3DRAPPOS%26target%3Dhttps%253a%252f%252fwww.verizon.com%252finhome%2Fmoves%252fqualification%253fismvflow%253dy",
  Wireless5Gurl: "https://www.verizon.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl:"https://www.verizon.com/home/lte-home-internet/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://api.verizon.com/atomapi/v1/careflowservice/careflow/affinityvalidation",
  getAffinityCompanyList : "https://api.verizon.com/atomapi/v1/careflowservice/careflow/getCompaniesList",
  emailValidationURL:"https://api.verizon.com/atomapi/v1/careflowservice/careflow/validateemail",
  manualEmailValidationURL:"https://api.verizon.com/atomapi/v1/careflowservice/careflow/manualvalidation",
  channelLineupPackageView:
    "https://api.verizon.com/atomapi/v1/channellookup/channels/packageviewbyname",
  accessToken: "https://oa.verizon.com/oauth/client_credential/accesstoken",
  getConsumerKey: "AzBf13sFeP4kqglli4Kfc1verqZClqP3",
  getConsumerSecret: "zeRQXh3GUNnK9OIw",
  getFiosQualification: "https://www.verizon.com/foryoursmallbiz/smb/api/Qualify/GetFiosQualification",
  channelLineupPackagesUrl:
    "https://api.verizon.com/atomapi/v1/channellookup/channels/allpackages",
  channelLineupVhoUrl:
    "https://api.verizon.com/atomapi/v1/channellookup/channels/vho",
  channelProgramMasterUrl:
    "https://api.verizon.com/atomapi/v1/channellookup/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://api.verizon.com/atomapi/v1/channellookup/channels/searchforchannelprogram",
  chatEncry: "Y",
  chatEncrypt:
    "https://api.verizon.com/atomapi/v1/chatinfoservice/chatInfo/hvals",
  requestCallback:
    "https://api.verizon.com/atomapi/v1/order/order/requestcallback",
  chatReint: "N",
  validatepartner: "/inhome/validatepartner",
  chatStore:
    "https://api.verizon.com/atomapi/v1/chatinfoservice/chatInfo/storeChatInfo",
  checkAddr:
    "https://api.verizon.com/atomapi/v1/addressqualification/address/qualification?addressID=",
  fiosMnhFetch:
    "https://api.verizon.com/atomapi/v1/addressqualification/address/fiosmnh",
  checkportability:
    "https://api.verizon.com/atomapi/v1/tnportability/tnportability",
  clearCart: "https://api.verizon.com/atomapi/v1/cart/cart/accordion/clearcart",
  clearCartEC:
    "https://api.verizon.com/atomapi/v1/cart/cart/accordion/clearcartec",
  compareCart: "https://api.verizon.com/atomapi/v1/cart/cart/accordion/compare",
  configEntry:
    "https://www.verizon.com/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://www.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://www.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId: "https://www.verizon.com/inhome/generatevisitid",
  creditAssessment:
    "https://api.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditfiosassessment",
  creditCheck:
    "https://api.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditworthiness",
  creditRefresh:
    "https://api.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://api.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://api.verizon.com/atomapi/v1/accountqualificationservice/account/decryptData",
  dobundle:
    "https://api.verizon.com/atomapi/v1/qualifiedproducts/products/dobundle",

    vecorder:
    "https://api.verizon.com/atomapi/v1/qualifiedproducts/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893.js",
  ecFooter: "https://www.verizon.com/includes/commongf/",
  ecHeader: "https://www.verizon.com/includes/commongh/",
  encryptUrl:
    "https://api.verizon.com/atomapi/v1/accountqualificationservice/account/encryptData",
  fbeGetSoc: "https://api.verizon.com/atomapi/v1/experience/exp/getSoc",
  fbePostSoc: "https://api.verizon.com/atomapi/v1/soc/fbe/PostSoc",
  futurenotification:
    "https://api.verizon.com/atomapi/v1/addresslookup/addresses/futurenotification",
  generateToken:
    "https://api.verizon.com/atomapi/v1/careflowservice/careflow/gettoken",
  getAccount:
    "https://api.verizon.com/atomapi/v1/accountqualificationservice/account",
  getBanners: "https://api.verizon.com/atomapi/v1/experience/exp/banners",
  getCacheValue:
    "https://api.verizon.com/atomapi/v1/experience/exp/getcachevalue",
  getCartAcc: "https://api.verizon.com/atomapi/v1/cart/cart/accordion",
  getCartAccEc:"https://api.verizon.com/atomapi/v1/cart/cart/accordion",
  getDisclaimer: "https://api.verizon.com/atomapi/v1/experience/exp/disclaimer",
  getDisclaimerAEM:
    "https://www.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getPlansPromo: "https://api.verizon.com/atomapi/v1/experience/exp/planspromo",
  getPlansPromoAEM:
    "https://www.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://www.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDisclaimerProducts:
    "https://api.verizon.com/atomapi/v1/experience/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://www.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://api.verizon.com/atomapi/v1/experience/exp/commondisclaimer",
  getCommonAEM:
    "https://www.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getDueDate:
    "https://api.verizon.com/atomapi/v1/duedateservice/duedate/triggerduedate",
  getExistingService:
    "https://api.verizon.com/atomapi/v1/addresslookup/addresses/existingservice",
  getFaq: "https://api.verizon.com/atomapi/v1/experience/exp/faq",
  getFaqAEM:
    "https://www.verizon.com/personal/cas/getfaq.model.json",
  getMon: "https://api.verizon.com/atomapi/v1/masterordernumber/order/mon",
  getPartialStreetAddr:
    "https://api.verizon.com/atomapi/v1/addresslookup/addresses/street?streetterm=",
  getCompleteAddress:
    "https://api.verizon.com/atomapi/v1/addresslookup/addresses/address?addressid=",
  getProduct:
    "https://api.verizon.com/atomapi/v1/qualifiedproducts/accordion/products",
  getProductEc:
    "https://api.verizon.com/atomapi/v1/ecproductservice/accordion/products",
  getVoiceProductEc:
    "https://api.verizon.com/atomapi/v1/ecproductservice/products",
  getSmartCartPersonalInfo:
    "https://api.verizon.com/atomapi/v1/contactinfo/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://api.verizon.com/atomapi/v1/addresslookup/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://api.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "3hBtC8PjGnZ5pG3AmtcFnGmlPtTbiwa4",
  getStreetAddrLocus2:
    "https://api.verizon.com/locus-typeahead/address/typeahead-address?streetterm=",
  locusapikey2: "5vbCkJw5g5e3LNaY8cgcnPpyQGPrhjIw",
  qualification5G:
    "https://api.verizon.com/atomapi/v1/addressqualification/address/fixedwirelesscoveragecheck",
  getTerms: "https://api.verizon.com/atomapi/v1/experience/exp/terms",
  getTermsAEM:
    "https://www.verizon.com/personal/cas/getorderingtos.model.json",
  getCentralAgreementTermsAEM: "https://www.verizon.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement~html.json",    
  getCentralAgreementTermsSpanishAEM: "https://www.verizon.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos: "https://api.verizon.com/atomapi/v1/experience/exp/tos",
  getUnit: "https://api.verizon.com/atomapi/v1/addresslookup/addresses/units",
  getUnitLocus:
  "https://api.verizon.com/locus-typeahead/address/typeahead-unit",
  getVZID:
    "https://api.verizon.com/atomapi/v1/registryservice/registration/getVzid",
  getZipcode: "https://api.verizon.com/atomapi/v1/addresslookup/addresses/zip",
  getvendorvisitdetails:
    "https://api.verizon.com/atomapi/v1/sessionmanager/getvendorvisitdetails",
  validateVendorToken: 
    "https://www.verizon.com/inhome/validatevendortoken",
    fetchEmeriosInfo: 
    "https://www.verizon.com/soe/digital/prospect/qualificationservice/vfw/fetchEmeriosInfo",
  checkPreLink:
    "https://api.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/checkprelink?prelink=add",
  jsNotify:
    "https://api.verizon.com/atomapi/v1/common/logger/logmsg",
  kafkaErrorAppLogs:
    "https://api.verizon.com/atomapi/v1/common/kafka/atom_applogs",
  kafkaPageLogs:
    "https://api.verizon.com/atomapi/v1/common/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://api.verizon.com/atomapi/v1/common/kafka/atom_visitdetails",
  learnCustomTv: "https://www.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://sit-activate.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://api.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://sit-activate.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl: "https://sit-activate.verizon.com/orderinfo/registrationwidget",
  loggingEnabler: "https://api.verizon.com/atomapi/v1/common/kafka/pageconfig",
  nsiNotify:
    "https://api.verizon.com/atomapi/v1/addresslookup/addresses/nsinotification",
  orderConfirmation:
    "https://api.verizon.com/atomapi/v1/experience/exp/getorderconfirmation",
  performEID:
    "https://api.verizon.com/atomapi/v1/creditcheckservice/creditcheck/performeid",
  personlisationdmp:
    "https://api.verizon.com/atomapi/v1/persionalizationservice/personalization/getvzdmptoak",
  pieUrl: "https://pie.prod.verizon.com/pie/v1",
  postCacheValue:
    "https://api.verizon.com/atomapi/v1/experience/exp/updatecachestorage",
  processSave:
    "https://api.verizon.com/atomapi/v1/smartcart/order/processsmartcart",
  productOffersUrl:
    "https://api.verizon.com/atomapi/v1/qualifiedproducts/offer/products/manual",
  profileCart: "https://api.verizon.com/atomapi/v1/cart/cart/profile",
  rapurl: "https://www.verizon.com/orderinfo/?src=olo",
  reflowOrderSubmission:
  "https://atomservicesdebugger-west.verizon.com/v05g/prod/debugger/ordersubmission",
  chatDetails:
    "https://api.verizon.com/atomapi/v1/chatinfoservice/chatInfo/chatdetails",
  referFrinedValidation:
    "https://api.verizon.com/atomapi/v1/chatinfoservice/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://api.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://api.verizon.com/atomapi/v1/qualifiedproducts/products/refreshPromotions",
  removePromoCode:
    "https://api.verizon.com/atomapi/v1/qualifiedproducts/products/removePromotions",
  resumeSmartCart:
    "https://api.verizon.com/atomapi/v1/smartcart/order/resumesmartcart",
  retrieveQualdetails:
    "https://api.verizon.com/atomapi/v1/addressqualification/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://api.verizon.com/atomapi/v1/smartcart/order/retrievesmartcart",
  sameDaydelivery:
    "https://api.verizon.com/atomapi/v1/storepickup/switch/samedaydelivery",
  seeFcpDetail:
    "https://api.verizon.com/atomapi/v1/experience/exp/fcpspecialoffers",
  sendLofNotification:
    "https://api.verizon.com/atomapi/v1/lofservice/lof/sendnotification",
  sendOTP:
    "https://api.verizon.com/atomapi/v1/contactinfo/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://api.verizon.com/atomapi/v1/registryservice/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://api.verizon.com/atomapi/v1/common/notification/sendsmsoremail",
    setBrowserInfo: "https://www.verizon.com/inhome/setbrowserinfo",
  setDueDate:
    "https://api.verizon.com/atomapi/v1/duedateservice/duedate/reserveduedate",
  smartAutoSave:
    "https://api.verizon.com/atomapi/v1/smartcart/order/smartcartsave",
  smartSave:
    "https://api.verizon.com/atomapi/v1/smartcart/order/smartcartsavewithparam",
  smartcartCancel:
    "https://api.verizon.com/atomapi/v1/smartcart/order/smartcartcancel",
  getSmartCartStatus:
    "https://api.verizon.com/atomapi/v1/smartcart/order/smartcartstatus",
  storePickUp:
    "https://api.verizon.com/atomapi/v1/storepickup/switch/storepickup",
  submitOrder: "https://api.verizon.com/atomapi/v1/order/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  tokenGeneration: "https://www.verizon.com/inhome/generatetoken",
  updateCartAcc:
    "https://api.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateCartAccEc:
    "https://api.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateintentcart: "https://api.verizon.com/atomapi/v1/cart/cart/updateintent",
  updateintentcartAcc:
    "https://api.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://api.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartEc:
    "https://api.verizon.com/atomapi/v1/cart/cart/updateintent",
  uploadFile:
    "https://api.verizon.com/atomapi/v1/careflowservice/careflow/employeeproof",
  updateFireAlarm:
    "https://api.verizon.com/atomapi/v1/qualifiedproducts/products/voice/firealarm",
  getFireAlarm:
    "https://api.verizon.com/atomapi/v1/qualifiedproducts/products/voice/getfirealarm",  
  validateBillingAdress:
    "https://api.verizon.com/atomapi/v1/billing/order/billing",
  validateContactInfo:
    "https://api.verizon.com/atomapi/v1/contactinfo/order/contact",
  validateCouponToken:
    "https://api.verizon.com/atomapi/v1/careflowservice/careflow/validatecoupontoken",
  validateEmployee:
    "https://api.verizon.com/atomapi/v1/careflowservice/careflow/validateemployee",
  validateName:
    "https://api.verizon.com/atomapi/v1/contactinfo/order/validateName",
  validateSigninUrl:
    "https://api.verizon.com/atomapi/v1/accountqualificationservice/account/validateSignin",
  validateSmartCartContactInfo:
    "https://api.verizon.com/atomapi/v1/contactinfo/order/validateSmartCartContactInfo",
  validatecartUrl: "https://api.verizon.com/atomapi/v1/cart/cart/validate/",
  validatecartUrlEc:"https://api.verizon.com/atomapi/v1/cart/cart/accordion/validate/",
  vendorFlow:
    "https://api.verizon.com/atomapi/v1/sessionmanager/vendorflowvalidate",
  vendorFlowToken:
    "https://api.verizon.com/atomapi/v1/sessionmanager/vendortokencreate",
  fiosQualification:
    "https://api.verizon.com/atomapi/v1/addresslookup/addresses/fiosqualification",
  updatebulkcart:
    "https://api.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/recommendedCart",
    vz15gFlow: "https://api.verizon.com/atomapi/v1/sessionmanager/validate15recomm",
  vepsUrl: "https://api.verizon.com/atomapi/v1/veps/veps/payment",
  verifyOTP:
    "https://api.verizon.com/atomapi/v1/contactinfo/ssocheck/verifyccpin",
  viewDetail: "https://api.verizon.com/atomapi/v1/experience/exp/viewdetails",
  viewDetailAEM:
    "https://www.verizon.com/personal/services/getlongdesc.fios",
  voicetn: "https://api.verizon.com/atomapi/v1/phoneservices/phoneservices",
  vzFwdEnrollmentDetails: 
  "https://api.verizon.com/atomapi/v1/addressqualification/address/enrollmentDetails", 
  twsSiginInDetails: 
   "https://api.verizon.com/atomapi/v1/addressqualification/address/twsSiginInDetails", 
  vzwOfferEligibility:
    "https://api.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://api.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getWirelessProduct",
  MoveCheckoutExperience:
    "https://api.verizon.com/atomapi/v1/contactinfo/order/moves/getCheckoutExperience",
  MoveLandingExperience:
    "https://api.verizon.com/atomapi/v1/qualifiedproducts/products/moves/getMovesExperience",
  updateFlowType:
    "https://api.verizon.com/atomapi/v1/sessionmanager/updateflowtype",
  checkPDCdata:
    "https://api.verizon.com/atomapi/v1/persionalizationservice/personalization/checkpdcdata",
  vzOrderInfo:
    "https://api.verizon.com/atomapi/v1/vzorderservice/order/vzorderinfo",
  vzOrderDetail:
    "https://api.verizon.com/atomapi/v1/vzorderservice/order/vzorderdetail",
  brtcInfo:
    "https://api.verizon.com/atomapi/v1/vzorderservice/order/brtc",
  suppCancelCart:
   "https://api.verizon.com/atomapi/v1/cart/cart/supp/",
  mfrtnFlow:
    "https://api.verizon.com/atomapi/v1/careflowservice/frontliners/save",
  mfrtnmoveEligibleCheck:
    "https://api.verizon.com/atomapi/v1/careflowservice/frontliners/retrieve",
  UTDrecommendationinfo:
    "https://api.verizon.com/atomapi/v1/ecexperienceservice/accountexp/ultimatetrialrecommendationinfo",
  UTDsspuage:
    "https://api.verizon.com/atomapi/v1/repguidanceservice/usage/sspusageinfo?zipCode=",
  mnhOneClickVzwAccountSave:
    "https://api.verizon.com/atomapi/v1/addressqualification/address/savewirelessaccountsystemobjectdetailstocache/",
  mnhOneClickQualification:
    "https://api.verizon.com/atomapi/v1/addressqualification/mobileandhome/ecwlnewfiosqualification",
  wlCustomerCheckoutInfo:
    "https://api.verizon.com/atomapi/v1/addressqualification/mobileandhome/wlcustomercheckoutinfo",
  mnhOneClickMarketingProfileSave:
    "https://api.verizon.com/atomapi/v1/addressqualification/address/savemaketingprofiledetailstocache/",
  mnhOneClickLoopQualSave:
    "https://api.verizon.com/atomapi/v1/addressqualification/address/saveloopqualtocache/",
  mnhOneClickLocusAddressValidationSave:
    "https://api.verizon.com/atomapi/v1/addressqualification/address/savelocusaddrvalidationdetailstocache/",
  mnhOneClickOneCreditSave:
    "https://api.verizon.com/atomapi/v1/creditcheckservice/creditcheck/savesfiosonecreditdetailstocache/",
  mnhOneClickEncryptWirelessDataToken:
    "https://api.verizon.com/atomapi/v1/addressqualification/mobileandhome/encryptwirelessdatatoken",
  mnhOneClickMLP:
    "https://www.verizon.com/content/verizon/personal/services/fivegoneclick.nocache.html",
  ssoMHAuthiniticate:
    "https://api.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://api.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk",
    fiosReferralCCAToken: "https://api.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
    fiosReferralVerifyToken: "https://api.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
    ssoMHEmailAuthiniticate:
    "https://api.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",
  pollingIGBackendUrl:
    "https://login.verizonwireless.com/accessmanager/public/adaptiveauth/2fa/polling",
  verification:
    'https://api.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/verification',
  ssoMHGetName:
    "https://api.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname", 
    ssoMHGetCustomerDetails:"https://api.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getcustomerdetailsresponse", 
    
    runtimeValuesUrl:
    "https://api.verizon.com/atomapi/v1/common/pageflow/getruntimevalues?runtimekey=",
    generateTokenForVzw:"https://api.verizon.com/atomapi/v1/cart/mh/encryptvzwexternaltoken",
    storePickupCRP:"https://api.verizon.com/atomapi/v1/notificationservice/whatsnext/storepickup",
    check5GAvailability: 'https://www.verizon.com/soe/digital/prospect/qualificationservice/nse/check5GAvailability',
    getFccLabel:"https://api.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/fccLabelData",
    getMovesThrottle: "https://api.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/nsathrottlelist",    
    disconnectBanner: "https://www.verizon.com/consumer/myverizon/homeoffers",
    mvaDisconnectBanner: "https://www.verizon.com/consumer/fios/secure/ui/acct/homeoffers", 
    sendVisitId : "https://api.verizon.com/atomapi/v1/cart/cart/updateSSP/",
    retentionOffer : "https://api.verizon.com/atomapi/v1/cart/cart/checkEligibleOffer/",
    hmpFindActiveSchedule:"https://www.verizon.com/soe/digital/prospect/qualificationservice/hmpDigital/findActiveSchedule",
    hmpEligibilityChecks:"https://www.verizon.com/soe/digital/prospect/qualificationservice/hmpDigital/hmpEligibilityChecks",
    hmpHome:"https://www.verizon.com/soe/digital/prospect/qualificationservice/optin/hmpHome",
    retailStoreDetails: "https://www.verizon.com/soe/digital/prospect/peripheralsservice/getClosingAgencyDetails",
    lookupReferralNumber: "https://www.verizon.com/soe/digital/prospect/peripheralsservice/lookupRetailCollaborationCode",
   getPerksAEM:"https://www.verizon.com/content/caas/plan/aggregated-perks.model.json",
   getpzaiRatingNumber: "https://api.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/fiospzai",
  ...changeProdApigee
};

const nte1Proxy = {
  PnSubsctiption:"https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/personalisation/personalization/subscribe",
  SaveSegment: "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/personalisation/personalization/segment",
  SaveCampaign: "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/personalisation/personalization/campaign", 
  accessToken: "https://api-qa.ebiz.verizon.com/atomapi/v1/oauth/accesstoken",
  getConsumerKey: "9eEUacA7H4WfLZQjjereh9aMgk49gR3U",
  getConsumerSecret: "yjMTSbOex8xbSzrc",
  getFiosQualification: "https://wwwnte1aws.ebiz.verizon.com/foryoursmallbiz/smb/api/Qualify/GetFiosQualification",
  GetDictonary: "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/personalisation/personalization/autolistmemebers?listname=", 
  duedatefallout:"https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/debugger/duedatefallout",
  fiosQualification:
  "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/addresslookup/addresses/fiosqualification",
  vz15gFlow:"https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/sessionmanager/validate15recomm",
  requestCallback:
  "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/order/order/requestcallback",
  reflowOrderSubmission:
  "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/debugger/ordersubmission",
  MyVzSigninAF:
    "https://sit-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://wwwawssit.ebiz.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fsit-ssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fsso-np.ebiz.verizon.com%252fconsumer%252fmyverizon%252frouter%253ftarget%253dhttps%25253a%25252f%25252fwwwawssit.ebiz.verizon.com%25252fforyourhome%25252fordering%25252fmyverizonnew%25252fregistrationbridge.aspx%25253f",
  MyVzSigninMV98:"https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www98.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fwww98.verizon.com%2fconsumer%2fmyverizon%2frouter%3ftarget%3dhttps%253a%252f%252fwww98.verizon.com%252finhome%252fmoves%252fqualification%253fismvflow%253dy",
  MyVzSigninMV:
    "https://sit-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://wwwawssit.ebiz.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fsit-ssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fsso-np.ebiz.verizon.com%252fconsumer%252fmyverizon%252frouter%253ftarget%253dhttps%25253a%25252f%25252fwwwawssit.ebiz.verizon.com%25252fforyourhome%25252fordering%25252fcheckavailabilitylq.aspx%25253fismvflow%25253dy",
  Wireless5Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/careflow/careflow/affinityvalidation",
  getAffinityCompanyList:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/careflow/careflow/getCompaniesList",
  emailValidationURL:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/careflow/careflow/validateemail",
  manualEmailValidationURL:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/careflow/careflow/manualvalidation",
  wlCustomerCheckoutInfo:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/addressqualification/mobileandhome/wlcustomercheckoutinfo",
  channelLineupPackageView:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/channellookup/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/channellookup/channels/allpackages",
  channelLineupVhoUrl:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/channellookup/channels/vho",
  channelProgramMasterUrl:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/channellookup/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/channellookup/channels/searchforchannelprogram",
  chatEncry: "Y",
  chatEncrypt:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/chatinfo/chatInfo/hvals",
  chatReint: "N",
  chatStore:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/chatinfo/chatInfo/storeChatInfo",
  checkAddr:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/addressqualification/address/qualification?addressID=",
  checkportability:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/tnportability/tnportability",
  updatebulkcart:
  "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vendorexperience/vendorexperience/recommendedCart",
  clearCart:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/cart/cart/accordion/clearcart",
  clearCartEC:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/cart/cart/accordion/clearcartec",
  compareCart:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/cart/cart/accordion/compare",
  configEntry:
    "https://www.verizon.com/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://wwwawssit.ebiz.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://wwwawssit.ebiz.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId:
    "https://atomservicesekssiteast.ebiz.verizon.com/v05g/sit/sessionmanager/visitid",
  creditAssessment:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/creditcheck/creditcheck/creditfiosassessment",
  creditCheck:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/creditcheck/creditcheck/creditworthiness",
  creditRefresh:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/creditcheck/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/creditcheck/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/accountqualification/account/decryptData",
  dobundle:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/products/dobundle",
    vecorder:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "/inhome/ecFooter",
  ecHeader: "/inhome/ecHeader",
  encryptUrl:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/accountqualification/account/encryptData",
  fbeGetSoc:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/experience/exp/getSoc",
  fbePostSoc:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/soc/fbe/PostSoc",
  futurenotification:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/addresslookup/addresses/futurenotification",
  generateToken:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/careflow/careflow/gettoken",
  getAccount:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/accountqualification/account",
  getBanners:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/experience/exp/banners",
  getCacheValue:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/experience/exp/getcachevalue",
  getCartAcc:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/cart/cart/accordion",
  getCartAccEc:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/cart/cart/accordion",
  getDisclaimer:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/experience/exp/disclaimer",
  getDisclaimerAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getDisclaimerProducts:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/experience/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/experience/exp/commondisclaimer",
  getCommonAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getPlansPromo:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/experience/exp/planspromo",
  getPlansPromoAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getProductsAEM: "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/services/getproducts.fios<service>.json",
  getPerksAEM: "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/caas/plan/aggregated-perks.model.json",
  getDueDate:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/duedate/duedate/triggerduedate",
  getExistingService:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/addresslookup/addresses/existingservice",
  getFaq:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/experience/exp/faq",
    getFaqAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getfaq.model.json",
  getMon: "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/mon/order/mon",
  getPartialStreetAddr:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/addresslookup/addresses/street?streetterm=",
  getCompleteAddress:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/addresslookup/addresses/address?addressid=",
  getProduct:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/accordion/products",
  getProductPerks:
    "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/product/accordion/products",
  getProductPerksEC:
    "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/productec/accordion/products",
  getProductEc:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/productec/accordion/products",
  getKeywordSearch:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/productec/accordion/products/keywordsearch",  
  getVoiceProductEc:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/productec/products",
  getSmartCartPersonalInfo:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/contactinfovalidation/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/addresslookup/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "VAiecKGNC721VnSn9fQrmpMumsdxZYu3",
  getStreetAddrLocus2:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "MvaCGJaWUOM1zkdFJietJiYyq15SJGdF",
  qualification5G:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/addressqualification/address/fixedwirelesscoveragecheck",
  getTerms:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/experience/exp/terms",
  getTermsAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getorderingtos.model.json",  
  getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json", 

  getTos:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/experience/exp/tos",
  getUnit:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/addresslookup/addresses/units",
  getUnitLocus:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-unit",
  getUpsell:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/accordion/products/upsell/",
  getVZID:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/registration/registration/getVzid",
  getZipcode:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/addresslookup/addresses/zip",
  getSmartCartStatus:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/smartcart/order/smartcartstatus",
  getvendorvisitdetails:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/sessionmanager/getvendorvisitdetails",
  validateVendorToken: 
    "https://wwwnte1aws.ebiz.verizon.com/inhome/validatevendortoken",
  fetchEmeriosInfo: 
    "https://wwwnte1aws.ebiz.verizon.com/inhome/fetchEmeriosInfo",
  checkPreLink:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzwoffereligibility/eligibility/checkprelink?prelink=add",  
  jsNotify:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/common/logger/logmsg",
  kafkaErrorAppLogs:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/common/kafka/atom_applogs",
  kafkaPageLogs:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/common/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
  kafkaAppLogsUrl: "/inhome/applogs",
  logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/common/kafka/atom_visitdetails",
  learnCustomTv:
    "https://wwwawssit.ebiz.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://wwwawssit.ebiz.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vendorexperience/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://wwwawssit.ebiz.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl:
    "https://wwwawssit.ebiz.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/common/kafka/pageconfig",
  nsiNotify:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/addresslookup/addresses/nsinotification",
  orderConfirmation:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/experience/exp/getorderconfirmation",
  performEID:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/creditcheck/creditcheck/performeid",
  personlisationdmp:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/personalisation/personalization/getvzdmptoak",
  pieUrl: "https://pie.uat.verizon.com/pie/v1",
  postCacheValue:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/experience/exp/updatecachestorage",
  processSave:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/smartcart/order/processsmartcart",
  productOffersUrl:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/offer/products/manual",
  profileCart:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/cart/cart/profile",
  rapurl: "https://wwwnte1aws.ebiz.verizon.com/orderinfo/?src=olo",
  chatDetails:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/chatinfo/chatInfo/chatdetails",
  referFrinedValidation:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/chatinfo/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzwoffereligibility/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/products/refreshPromotions",
  removePromoCode:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/products/removePromotions",
  resumeSmartCart:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/smartcart/order/resumesmartcart",
  retrieveQualdetails:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/addressqualification/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/smartcart/order/retrievesmartcart",
  sameDaydelivery:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/storepickup/switch/samedaydelivery",
  seeFcpDetail:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/experience/exp/fcpspecialoffers",
  sendLofNotification:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/lof/lof/sendnotification",
  sendOTP:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/contactinfovalidation/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/registration/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/common/notification/sendsmsoremail",
    setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/duedate/duedate/reserveduedate",
  smartAutoSave:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/smartcart/order/smartcartsave",
  smartSave:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/smartcart/order/smartcartsavewithparam",
  smartcartCancel:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/smartcart/order/smartcartcancel",
  storePickUp:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/storepickup/switch/storepickup",
  submitOrder:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/ordersubmission/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  updateCartAcc:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/cart/cart/accordion/updatecart",
  updateCartAccEc:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/cart/cart/accordion/updatecart",
  updateintentcart:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/cart/cart/updateintent",
  updateintentcartAcc:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/cart/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/cart/cart/accordion/updateintent",
  updateintentcartEc:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/cart/cart/updateintent",
  uploadFile:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/careflow/careflow/employeeproof",
  updateFireAlarm:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/products/voice/firealarm",
  getFireAlarm:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/products/voice/getfirealarm",  
  validateBillingAdress:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/billingvalidation/order/billing",
  validateContactInfo:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/contactinfovalidation/order/contact",
  validateCouponToken:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/careflow/careflow/validatecoupontoken",
  validateEmployee:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/careflow/careflow/validateemployee",
  validateName:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/contactinfovalidation/order/validateName",
  validateSigninUrl:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/accountqualification/account/validateSignin",
  validateSmartCartContactInfo:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/contactinfovalidation/order/validateSmartCartContactInfo",
  validatecartUrl:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/cart/cart/accordion/validate/",
  validatecartUrlEc:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/cart/cart/accordion/validate/",
  vendorFlow:
    "https://atomserviceseksqaeast.ebiz.verizon.com/qa/v05g/sessionmanager/vendorflowvalidate",
  vendorFlowToken:
    "https://atomserviceseksqaeast.ebiz.verizon.com/qa/v05g/sessionmanager/vendortokencreate",
  vepsUrl:
    "https://atomserviceseksqaeast.ebiz.verizon.com/qa/v05g/veps/veps/payment",
  verifyOTP:
    "https://atomserviceseksqaeast.ebiz.verizon.com/qa/v05g/contactinfovalidation/ssocheck/verifyccpin",
  viewDetail:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/experience/exp/viewdetails",
  viewDetailAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/services/getlongdesc.fios",
  voicetn:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/phoneservices/phoneservices",
    vzFwdEnrollmentDetails: 
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/addressqualification/address/enrollmentDetails", 
  twsSiginInDetails: 
   "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/addressqualification/address/twsSiginInDetails", 
  vzwOfferEligibility:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzwoffereligibility/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzwoffereligibility/eligibility/getWirelessProduct",
  vzOrderInfo:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzorder/order/vzorderinfo",
  vzOrderDetail:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzorder/order/vzorderdetail",
  brtcInfo:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzorder/order/brtc",
  suppCancelCart:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/cart/cart/supp/",
  checkPDCdata:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/personalisation/personalization/checkpdcdata",
  updateFlowType:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/sessionmanager/updateflowtype",
  MoveCheckoutExperience:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/contactinfovalidation/order/moves/getCheckoutExperience",
  MoveLandingExperience:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/products/moves/getMovesExperience",
  mfrtnFlow:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/careflow/frontliners/save",
  ssoMHAuthiniticate:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzwoffereligibility/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzwoffereligibility/eligibility/fioReferralKiosk",
    fiosReferralCCAToken: "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzwoffereligibility/eligibility/generateJwtToken",
    fiosReferralVerifyToken: "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzwoffereligibility/eligibility/smspinverify",
    ssoMHEmailAuthiniticate:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzwoffereligibility/eligibility/emailvalidate",
  pollingIGBackendUrl:
    "https://securesit1.verizon.com/accessmanager/public/adaptiveauth/2fa/polling",
  ssoMHGetName:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/vzwoffereligibility/eligibility/getfirstname",
    ssoMHGetCustomerDetails:"https://atomservicesekssiteast.ebiz.verizon.com/v05g/qa/vzwoffereligibility/eligibility/getcustomerdetailsresponse",
  
  mfrtnmoveEligibleCheck:
    "https://api-dev2.ebiz.verizon.com/v05g/qa/careflow/frontliners/retrieve",
  generateTokenForVzw:"https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/cart/mh/encryptvzwexternaltoken",
  storePickupCRP:"https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/whatsnext/whatsnext/storepickup",
  getFccLabel:"https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/accordion/products/fccLabelData",
  getMovesThrottle: "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/accordion/products/nsathrottlelist",
  check5GAvailability: 'https://www.verizon.com/soe/digital/prospect/qualificationservice/nse/check5GAvailability',
  disconnectBanner: "https://sso-np.ebiz.verizon.com/consumer/myverizon/homeoffers",
  mvaDisconnectBanner: "https://www.verizon.com/consumer/fios/secure/ui/acct/homeoffers", 
  sendVisitId: "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/updateSSP/",
  retentionOffer : "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/checkEligibleOffer/",
  hmpFindActiveSchedule:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/hmpDigital/findActiveSchedule",
  hmpEligibilityChecks:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/hmpDigital/hmpEligibilityChecks",
  hmpHome:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/optin",
  retailStoreDetails: "https://vzwqa2.sdc.vzwcorp.com/soe/digital/prospect/peripheralsservice/getClosingAgencyDetails",
  lookupReferralNumber: "https://vzwqa2.sdc.vzwcorp.com/soe/digital/prospect/peripheralsservice/lookupRetailCollaborationCode",
  getpzaiRatingNumber: "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/accordion/products/fiospzai",
  getCentralAgreementTermsAEM: "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/products/tosCentralAgreement",
  ...changente1Proxy
};

const nte1Apigee = {
  
  PnSubsctiption:"https://api-dev2.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/subscribe",
  SaveSegment: "https://api-dev2.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/segment",
  SaveCampaign: "https://api-dev2.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/campaign", 
  accessToken: "https://api-qa.ebiz.verizon.com/oauth/client_credential/accesstoken",
  getConsumerKey: "9eEUacA7H4WfLZQjjereh9aMgk49gR3U",
  getConsumerSecret: "yjMTSbOex8xbSzrc",  
  getFiosQualification: "https://wwwnte1aws.ebiz.verizon.com/foryoursmallbiz/smb/api/Qualify/GetFiosQualification",
  PZAIAccessToken: "https://oa-uat.ebiz.verizon.com/ha6v-soi-oauth/generateToken",
  PZAISOIInsights: "https://oa-uat.ebiz.verizon.com/soi/rtinsights",  
  requestCallback:
  "https://api-dev2.ebiz.verizon.com/atomapi/v1/order/order/requestcallback",
  fiosQualification:
  "https://api-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/fiosqualification",
  reflowOrderSubmission:
  "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/debugger/ordersubmission",
  MoveCheckoutExperience:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/contactinfo/order/moves/getCheckoutExperience",
  MoveLandingExperience:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/moves/getMovesExperience",
  MyVzSigninAF:
    "https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www98.verizon.com&remainInOverlay=N&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3A%2F%2Fwww98.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fwww98.verizon.com%252Fforyourhome%252Fordering%252Fmyverizonnew%252Fregistrationbridge.aspx",
  MyVzSigninInhomeAF:
    "https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www98.verizon.com&remainInOverlay=N&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3A%2F%2Fwww98.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3dhttps%253a%252f%252fwww98.verizon.com%252finhome%252fchange%252fsignin%253fflowtype%253daf",
  MyVzSigninMV98:"https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www98.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fwww98.verizon.com%2fconsumer%2fmyverizon%2frouter%3ftarget%3dhttps%253a%252f%252fwww98.verizon.com%252finhome%252fmoves%252fqualification%253fismvflow%253dy",
  MyVzSigninMV: "https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://wwwnte1aws.ebiz.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fwww98.verizon.com%2fconsumer%2fmyverizon%2frouter%3ftarget%3dhttps%253a%252f%252fwwwnte1aws.ebiz.verizon.com%252finhome%252fmoves%252fqualification%253fismvflow%253dy",
  MyVzSigninMVBAU:
    "https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www98.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fwww98.verizon.com%2fconsumer%2fmyverizon%2frouter%3ftarget%3dhttps%253a%252f%252fwww98.verizon.com%252finhome%252fmoves%252fqualification%253fismvflow%253dy",
  Wireless5Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/affinityvalidation",
  channelLineupPackageView:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/channellookup/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/channellookup/channels/allpackages",
  channelLineupVhoUrl:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/channellookup/channels/vho",
  channelProgramMasterUrl:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/channellookup/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/channellookup/channels/searchforchannelprogram",
  chatEncry: "Y",
  chatEncrypt:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/hvals",
  chatReint: "N",
  validatepartner: "/inhome/validatepartner",
  chatStore:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/storeChatInfo",
  checkAddr:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/qualification?addressID=",
  fiosMnhFetch:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/fiosmnh",
  checkportability:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/tnportability/tnportability",
  updatebulkcart:
  "https://api-dev2.ebiz.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/recommendedCart",
  clearCart:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/clearcart",
  clearCartEC:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/clearcartec",
  compareCart:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/compare",
  configEntry:
    "https://www.verizon.com/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://wwwnte1aws.ebiz.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://wwwnte1aws.ebiz.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId: "/inhome/generatevisitid",
  //createVisitId:"https://api-dev2.ebiz.verizon.com/atomapi/v1/sessionmanager/visitid",
  creditAssessment:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/creditcheck/creditfiosassessment",
  creditCheck:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditworthiness",
  creditRefresh:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/decryptData",
  dobundle:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/dobundle",
    vecorder:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "/inhome/ecFooter",
  ecHeader: "/inhome/ecHeader",
  encryptUrl:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/encryptData",
  fbeGetSoc:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/getSoc",
  fbePostSoc: "https://api-dev2.ebiz.verizon.com/atomapi/v1/soc/fbe/PostSoc",
  futurenotification:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/futurenotification",
  generateToken:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/gettoken",
  getAccount:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account",
  getBanners:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/banners",
  getCacheValue:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/getcachevalue",
  getCartAcc:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion",
  getCartAccEc:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion",
  getDisclaimer:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/disclaimer",
  getDisclaimerAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getPlansPromo:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/planspromo",
  getPlansPromoAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDisclaimerProducts:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/commondisclaimer",
  getCommonAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getDueDate:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/duedateservice/duedate/triggerduedate",
  getExistingService:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/existingservice",
  getFaq: "https://api-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/faq",
  getFaqAEM:
  "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getfaq.model.json",
  getMon:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/masterordernumber/order/mon",
  getPartialStreetAddr:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/street?streetterm=",
  getCompleteAddress:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/address?addressid=",
  getProduct:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products",
  getProductEc:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/ecproductservice/accordion/products",
  getProductPerks:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products",
  getProductPerksEC:
    "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/productec/accordion/products",
  getKeywordSearch:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/ecproductservice/accordion/products/keywordsearch",  
  getVoiceProductEc:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/ecproductservice/products",
  getSmartCartPersonalInfo:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/contactinfo/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "VAiecKGNC721VnSn9fQrmpMumsdxZYu3",
  getStreetAddrLocus2:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "MvaCGJaWUOM1zkdFJietJiYyq15SJGdF",
  qualification5G:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/fixedwirelesscoveragecheck",
  getTerms: "https://api-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/terms",
  getTermsAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getorderingtos.model.json",
  // getCentralAgreementTermsAEM: "https://vzwqa3.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement~html.json",
  getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos: "https://api-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/tos",
  getUnit:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/units",
  getUnitLocus:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-unit",
  getVZID:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/registryservice/registration/getVzid",
  getZipcode:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/zip",
  getvendorvisitdetails:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/sessionmanager/getvendorvisitdetails",
  validateVendorToken:  
    "https://wwwnte1aws.ebiz.verizon.com/inhome/validatevendortoken",
  fetchEmeriosInfo: 
    "https://wwwnte1aws.ebiz.verizon.com/inhome/fetchEmeriosInfo",
  checkPreLink:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/checkprelink?prelink=add",
  jsNotify:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/common/logger/logmsg",
  kafkaErrorAppLogs:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/common/kafka/atom_applogs",
  kafkaPageLogs:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/common/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
  kafkaAppLogsUrl: "/inhome/applogs",
  logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/common/kafka/atom_visitdetails",
  learnCustomTv:
    "https://wwwnte1aws.ebiz.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://sit-activate.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://sit-activate.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl: "https://sit-activate.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/common/kafka/pageconfig",
  nsiNotify:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/nsinotification",
  orderConfirmation:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/getorderconfirmation",
  performEID:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/performeid",
  personlisationdmp:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/getvzdmptoak",
  pieUrl: "https://pie.uat.verizon.com/pie/v1",
  postCacheValue:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/updatecachestorage",
  processSave:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/smartcart/order/processsmartcart",
  productOffersUrl:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/offer/products/manual",
  profileCart:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/profile",
  rapurl: "https://wwwnte1aws.ebiz.verizon.com/orderinfo/?src=olo",
  chatDetails:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/chatdetails",
  referFrinedValidation:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/refreshPromotions",
  removePromoCode:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/removePromotions",
  resumeSmartCart:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/smartcart/order/resumesmartcart",
  retrieveQualdetails:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/smartcart/order/retrievesmartcart",
  sameDaydelivery:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/storepickup/switch/samedaydelivery",
  seeFcpDetail:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/fcpspecialoffers",
  sendLofNotification:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/lofservice/lof/sendnotification",
  sendOTP:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/registryservice/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/common/notification/sendsmsoremail",
    setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/duedateservice/duedate/reserveduedate",
  smartAutoSave:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartsave",
  smartSave:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartsavewithparam",
  smartcartCancel:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartcancel",
getSmartCartStatus:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartstatus",
  storePickUp:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/storepickup/switch/storepickup",
  submitOrder:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/order/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  tokenGeneration: "/inhome/generatetoken",
  updateCartAcc:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateCartAccEc:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateFlowType:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/sessionmanager/updateflowtype",
  updateintentcart:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/updateintent",
  updateintentcartAcc:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartEc:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/updateintent",
  uploadFile:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/employeeproof",
  updateFireAlarm:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/voice/firealarm",
  getFireAlarm:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/voice/getfirealarm",
  validateBillingAdress:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/billing/order/billing",
  validateContactInfo:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/contactinfo/order/contact",
  validateCouponToken:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/validatecoupontoken",
  validateEmployee:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/validateemployee",
  validateName:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/contactinfo/order/validateName",
  validateSigninUrl:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/validateSignin",
  validateSmartCartContactInfo:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/contactinfo/order/validateSmartCartContactInfo",
  validatecartUrl:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/validate/",
  validatecartUrlEc:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/validate/",
  vendorFlow:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/sessionmanager/vendorflowvalidate",
  vendorFlowToken:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/sessionmanager/vendortokencreate",
  vepsUrl: "https://api-dev2.ebiz.verizon.com/atomapi/v1/veps/veps/payment",
  verifyOTP:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/ssocheck/verifyccpin",
  viewDetail:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/experience/exp/viewdetails",
  viewDetailAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/services/getlongdesc.fios",
  voicetn:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/phoneservices/phoneservices",
    vzFwdEnrollmentDetails: 
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/enrollmentDetails", 
  twsSiginInDetails: 
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/twsSiginInDetails",  
  vzwOfferEligibility:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getWirelessProduct",
  vzOrderInfo:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/vzorderservice/order/vzorderinfo",
  vzOrderDetail:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/vzorderservice/order/vzorderdetail",
  brtcInfo:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/vzorderservice/order/brtc",
  suppCancelCart:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/supp/",
  checkPDCdata:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/checkpdcdata",
    vz15gFlow:"https://api-dev2.ebiz.verizon.com/atomapi/v1/sessionmanager/validate15recomm",
  mfrtnFlow:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/careflowservice/frontliners/save",
  mfrtnmoveEligibleCheck:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/careflowservice/frontliners/retrieve",
  mnhOneClickVzwAccountSave:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/savewirelessaccountsystemobjectdetailstocache/",
  mnhOneClickQualification:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/mobileandhome/ecwlnewfiosqualification",
  wlCustomerCheckoutInfo:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/mobileandhome/wlcustomercheckoutinfo",
  mnhOneClickMarketingProfileSave:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/savemaketingprofiledetailstocache/",
  mnhOneClickLoopQualSave:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/saveloopqualtocache/",
  mnhOneClickLocusAddressValidationSave:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/savelocusaddrvalidationdetailstocache/",
  mnhOneClickOneCreditSave:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/savesfiosonecreditdetailstocache/",
  mnhOneClickEncryptWirelessDataToken:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/mobileandhome/encryptwirelessdatatoken",
  mnhOneClickMLP:
    "https://wwwawssit.ebiz.verizon.com/content/verizon/personal/services/fivegoneclick.nocache.html",
  ssoMHAuthiniticate:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk",
  fiosReferralCCAToken: "https://api-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
  fiosReferralVerifyToken: "https://api-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
    ssoMHEmailAuthiniticate:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",

  pollingIGBackendUrl:
    "https://securesit1.verizon.com/accessmanager/public/adaptiveauth/2fa/polling",
  verification:
    'https://api-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/verification',
  ssoMHGetName:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname",
    ssoMHGetCustomerDetails:"https://api-dev2.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getcustomerdetailsresponse",
  
  runtimeValuesUrl:
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/common/pageflow/getruntimevalues?runtimekey=",
  generateTokenForVzw:"https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/mh/encryptvzwexternaltoken",
  storePickupCRP:"https://api-dev2.ebiz.verizon.com/atomapi/v1/notificationservice/whatsnext/storepickup",
  getAffinityCompanyList:"https://api-dev2.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/getCompaniesList",
  emailValidationURL:"https://api-dev2.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/validateemail",
  manualEmailValidationURL:"https://api-dev2.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/manualvalidation",
  getFccLabel:"https://api-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/fccLabelData",
  getMovesThrottle: "https://api-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/nsathrottlelist",
  disconnectBanner: "https://sso-np.ebiz.verizon.com/consumer/myverizon/homeoffers",
  mvaDisconnectBanner: "https://www.verizon.com/consumer/fios/secure/ui/acct/homeoffers", 
  sendVisitId: "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/updateSSP/",
  retentionOffer : "https://api-dev2.ebiz.verizon.com/atomapi/v1/cart/cart/checkEligibleOffer/",
  hmpFindActiveSchedule:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/hmpDigital/findActiveSchedule",
  hmpEligibilityChecks:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/hmpDigital/hmpEligibilityChecks",
  hmpHome:"https://vzwqa1.sdc.vzwcorp.com/soe/digital/prospect/qualificationservice/optin",
  retailStoreDetails: "https://vzwqa2.sdc.vzwcorp.com/soe/digital/prospect/peripheralsservice/getClosingAgencyDetails",
  lookupReferralNumber: "https://vzwqa2.sdc.vzwcorp.com/soe/digital/prospect/peripheralsservice/lookupRetailCollaborationCode",
  cradleService: "https://vzwqa2.sdc.vzwcorp.com/soe/digital/prospect/assisted/auth/cradleservice/assistedService",
  getPerksAEM: "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/caas/plan/aggregated-perks.model.json",
  getpzaiRatingNumber: "https://api-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/fiospzai",
  getCentralAgreementTermsAEM: "https://api-dev2.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/tosCentralAgreement",  
  ...changente1Apigee
};

const nte3Proxy = {
  getPerksAEM: "https://sales-bau-sit1-publisher.ebiz.verizon.com/content/caas/plan/aggregated-perks.model.json",
  Wireless5Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
careFlowFormValidation:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/careflow/careflow/affinityvalidation",
channelLineupPackageView:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/channellookup/channels/packageviewbyname",
channelLineupPackagesUrl:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/channellookup/channels/allpackages",
channelLineupVhoUrl:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/channellookup/channels/vho",
channelProgramMasterUrl:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/channellookup/channels/channelprogrammaster",
channelProgramSearchUrl:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/channellookup/channels/searchforchannelprogram",
chatEncry: "Y",
chatEncrypt:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/chatinfo/chatInfo/hvals",
chatReint: "N",
chatStore:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/chatinfo/chatInfo/storeChatInfo",
checkAddr:
"https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/addressqualification/address/qualification?addressID=",
checkportability:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/tnportability/tnportability",
clearCart:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/accordion/clearcart",
clearCartEC:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/accordion/clearcartec",
compareCart:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/accordion/compare",
configEntry:
  "https://wwwnte1aws.ebiz.verizon.com/content/verizon/personal/services/getaccordionmapping.runtimekeys.json",
contractConfigUrl:
  "https://wwwawssit.ebiz.verizon.com/personal/services/getaccordionmapping.contracttile.json",
emergencyNotificationStatesConfigUrl:
  "https://wwwawssit.ebiz.verizon.com/personal/services/getaccordionmapping.notification.json",
createVisitId:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/sessionmanager/visitid",
creditAssessment:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/creditcheck/creditcheck/creditfiosassessment",
creditCheck:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/creditcheck/creditcheck/creditworthiness",
creditRefresh:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/creditcheck/creditcheck/creditrefresh?triggerCRVCredit=Y",
creditRefreshSupp:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/creditcheck/creditcheck/creditrefreshsupp",
decryptUrl:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/accountqualification/account/decryptData",
dobundle:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/product/products/dobundle",
  vecorder:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/product/products/vecorder",
dtmurl:
  "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
ecFooter: "/inhome/ecFooter",
ecHeader: "/inhome/ecHeader",
encryptUrl:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/accountqualification/account/encryptData",
fbeGetSoc:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/experience/exp/getSoc",
fbePostSoc:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/soc/fbe/PostSoc",
futurenotification:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/addresslookup/addresses/futurenotification",
generateToken:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/careflow/careflow/gettoken",
getAccount:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/accountqualification/account",
getBanners:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/experience/exp/banners",
getCacheValue:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/experience/exp/getcachevalue",
getCartAcc:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/accordion",
getCartAccEc:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/accordion",
getDisclaimer:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/experience/exp/disclaimer",
getDisclaimerAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getorderingdisclaimer.model.json",
getDisclaimerProducts:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/experience/exp/productdisclaimer",
getDisclaimerProductsAEM:
  "https://wwwawssit.ebiz.verizon.com/personal/cas/getproductsdisclaimer.model.json",
getDisclaimerCommon:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/experience/exp/commondisclaimer",
getFccLabel:"https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/accordion/products/fccLabelData",
getMovesThrottle: "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/accordion/products/nsathrottlelist",
getCommonAEM:
  "https://wwwawssit.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
getPlansPromo:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/experience/exp/planspromo",
getPlansPromoAEM:
  "https://wwwawssit.ebiz.verizon.com/personal/cas/getplanspromo.model.json",
getLqAEMBanner:
  "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
getDueDate:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/duedate/duedate/triggerduedate",
getExistingService:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/addresslookup/addresses/existingservice",
getFaq:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/experience/exp/faq",
  getFaqAEM:
  "https://wwwawssit.ebiz.verizon.com/personal/cas/getfaq.model.json",
getMon: "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/mon/order/mon",
getPartialStreetAddr:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/addresslookup/addresses/street?streetterm=",
getCompleteAddress:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/addresslookup/addresses/address?addressid=",
getProduct:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/product/accordion/products",
getProductPerks:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/product/accordion/products",
getProductPerksEC:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/productec/accordion/products",
getProductEc:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/productec/accordion/products",
getVoiceProductEc:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/productec/products",
getSmartCartPersonalInfo:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/contactinfovalidation/order/smartcartpersonalinfo",
getStreetAddr:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/addresslookup/addresses/streetbyzip",
getStreetAddrLocus1:
  "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
locusapikey1: "VAiecKGNC721VnSn9fQrmpMumsdxZYu3",
getStreetAddrLocus2:
  "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
locusapikey2: "MvaCGJaWUOM1zkdFJietJiYyq15SJGdF",
qualification5G:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/addressqualification/address/fixedwirelesscoveragecheck",
getTerms:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/experience/exp/terms",
getTermsAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getorderingtos.model.json", 
  // getCentralAgreementTermsAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement~html.json",
getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
getTos:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/experience/exp/tos",
getUnit:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/addresslookup/addresses/units",
getUnitLocus:
  "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-unit",
getUpsell:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/product/accordion/products/upsell/",
getVZID:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/registration/registration/getVzid",
getZipcode:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/addresslookup/addresses/zip",
getSmartCartStatus:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/smartcart/order/smartcartstatus",
getvendorvisitdetails:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/sessionmanager/getvendorvisitdetails",
jsNotify:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/common/logger/logmsg",
kafkaErrorAppLogs:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/common/kafka/atom_applogs",
kafkaPageLogs:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/common/kafka/atom_pagelogs",
kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
kafkaVisitLogs:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/common/kafka/atom_visitdetails",
learnCustomTv:
  "https://wwwawssit.ebiz.verizon.com/home/popup/customgeneric?&acfl=Y",
lofRegistrationUrl:
  "https://wwwawssit.ebiz.verizon.com/orderinfo/doregistration",
lofStatus:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/vendorexperience/vendorexperience/checkrapdetails",
lofUserNameCheckUrl:
  "https://wwwawssit.ebiz.verizon.com/orderinfo/validateuserName",
lofWidgetUrl:
  "https://wwwawssit.ebiz.verizon.com/orderinfo/registrationwidget",
loggingEnabler:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/common/kafka/pageconfig",
nsiNotify:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/addresslookup/addresses/nsinotification",
orderConfirmation:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/experience/exp/getorderconfirmation",
performEID:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/creditcheck/creditcheck/performeid",
personlisationdmp:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/personalisation/personalization/getvzdmptoak",
pieUrl: "https://pie.uat.verizon.com/pie/v1",
postCacheValue:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/experience/exp/updatecachestorage",
processSave:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/smartcart/order/processsmartcart",
productOffersUrl:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/product/offer/products/manual",
profileCart:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/profile",
rapurl: "https://wwwawssit.ebiz.verizon.com/orderinfo/?src=olo",
chatDetails:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/chatinfo/chatInfo/chatdetails",
referFrinedValidation:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/chatinfo/chatInfo/validateReferralCode",
ffCouponValidation:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/vzwoffereligibility/eligibility/validateffredemptioncode",
refreshPromotionsUrl:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/product/products/refreshPromotions",
removePromoCode:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/product/products/removePromotions",
resumeSmartCart:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/smartcart/order/resumesmartcart",
retrieveQualdetails:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/addressqualification/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
retrieveSmartCart:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/smartcart/order/retrievesmartcart",
sameDaydelivery:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/storepickup/switch/samedaydelivery",
seeFcpDetail:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/experience/exp/fcpspecialoffers",
sendLofNotification:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/lof/lof/sendnotification",
sendOTP:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/contactinfovalidation/ssocheck/validatemtnownership",
sendRtcItp:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/registration/registration/sendrtcitp",
sendSmsOrEmail:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/common/notification/sendsmsoremail",
  setBrowserInfo: "/inhome/setbrowserinfo",
setDueDate:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/duedate/duedate/reserveduedate",
smartAutoSave:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/smartcart/order/smartcartsave",
smartSave:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/smartcart/order/smartcartsavewithparam",
smartcartCancel:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/smartcart/order/smartcartcancel",
storePickUp:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/storepickup/switch/storepickup",
submitOrder:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/ordersubmission/order/submit",
tcChatUrl:
  "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
updateCartAcc:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/accordion/updatecart",
updateCartAccEc:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/accordion/updatecart",
updateintentcart:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/updateintent",
updateintentcartAcc:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/accordion/updateintent",
updateintentcartAccEc:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/accordion/updateintent",
updateintentcartEc:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/updateintent",
uploadFile:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/careflow/careflow/employeeproof",
updateFireAlarm:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/product/products/voice/firealarm",
getFireAlarm:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/product/products/voice/getfirealarm",
validateBillingAdress:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/billingvalidation/order/billing",
validateContactInfo:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/contactinfovalidation/order/contact",
validateCouponToken:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/careflow/careflow/validatecoupontoken",
validateEmployee:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/careflow/careflow/validateemployee",
validateName:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/contactinfovalidation/order/validateName",
validateSigninUrl:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/accountqualification/account/validateSignin",
validateSmartCartContactInfo:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/contactinfovalidation/order/validateSmartCartContactInfo",
validatecartUrl:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/accordion/validate/",
validatecartUrlEc:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/accordion/validate/",
vendorFlow:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/sessionmanager/vendorflowvalidate",
vendorFlowToken:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/sessionmanager/vendortokencreate",
vepsUrl:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/veps/veps/payment",
verifyOTP:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/contactinfovalidation/ssocheck/verifyccpin",
viewDetail:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/experience/exp/viewdetails",
viewDetailAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/services/getlongdesc.fios",
voicetn:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/phoneservices/phoneservices",
  vzFwdEnrollmentDetails: 
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/addressqualification/address/enrollmentDetails", 
  twsSiginInDetails: 
    "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/addressqualification/address/twsSiginInDetails", 
vzwOfferEligibility:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/vzwoffereligibility/eligibility/vzwoffereligibility",
getWirelessProduct:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/vzwoffereligibility/eligibility/getWirelessProduct",
vzOrderInfo:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/vzorder/order/vzorderinfo",
vzOrderDetail:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/vzorder/order/vzorderdetail",
brtcInfo:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/vzorder/order/brtc",
suppCancelCart:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/cart/cart/supp/",
checkPDCdata:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/personalisation/personalization/checkpdcdata",
updateFlowType:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/sessionmanager/updateflowtype",
MoveCheckoutExperience:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/contactinfovalidation/order/moves/getCheckoutExperience",
MoveLandingExperience:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/product/products/moves/getMovesExperience",
mfrtnFlow:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/careflow/frontliners/save",
ssoMHAuthiniticate:
    "https://atomserviceseksuateast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
fiosReferralAdaptiveAuthentication:
    "https://atomserviceseksuateast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk",
    fiosReferralCCAToken: "https://atomserviceseksuateast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
    fiosReferralVerifyToken: "https://atomserviceseksuateast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
    ssoMHEmailAuthiniticate:
    "https://atomserviceseksuateast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",

pollingIGBackendUrl:
    "https://securesit1.verizon.com/accessmanager/public/adaptiveauth/2fa/polling",
ssoMHGetName:
    "https://atomserviceseksuateast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname", 
    ssoMHGetCustomerDetails:"https://atomserviceseksuateast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getcustomerdetailsresponse",
 
      
mfrtnmoveEligibleCheck:
  "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/careflow/frontliners/retrieve",
  disconnectBanner: "https://sso-np.ebiz.verizon.com/consumer/myverizon/homeoffers",
  mvaDisconnectBanner: "https://www.verizon.com/consumer/fios/secure/ui/acct/homeoffers", 
  getpzaiRatingNumber: "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/accordion/products/fiospzai",
  getCentralAgreementTermsAEM: "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/qa/product/products/tosCentralAgreement",  
  ...changeUATProxy
};
const nte3Apigee = {
  getPerksAEM: "https://sales-bau-sit1-publisher.ebiz.verizon.com/content/caas/plan/aggregated-perks.model.json",
  MoveCheckoutExperience:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/contactinfo/order/moves/getCheckoutExperience",
  MoveLandingExperience:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/moves/getMovesExperience",
    
  MyVzSigninAF:
    "https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www.verizon.com&remainInOverlay=N&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3A%2F%2Fwww.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3Ftarget%3Dhttps%253A%252F%252Fwww.verizon.com%252Fforyourhome%252Fordering%252Fmyverizonnew%252Fregistrationbridge.aspx",
  MyVzSigninMV98:"https://pprd-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://www98.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fwww98.verizon.com%2fconsumer%2fmyverizon%2frouter%3ftarget%3dhttps%253a%252f%252fwww98.verizon.com%252finhome%252fmoves%252fqualification%253fismvflow%253dy",
  MyVzSigninMV:
    "https://sit-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://wwwawssit.ebiz.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fsso-np.ebiz.verizon.com%2fconsumer%2fmyverizon%2frouter%3ftarget%3dhttps%253a%252f%252fwwwnte1aws.ebiz.verizon.com%252finhome%252fmoves%252fqualification%253fismvflow%253dy",
  MyVzSigninMVBAU:
    "https://sit-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&sourceDomain=https://wwwawssit.ebiz.verizon.com&remainInOverlay=N&mode=i&modeAfterSubmit=o&fromVZT=Y&userNameOnly=false&clientId=VZCOMBQ&goto=https%3a%2f%2fsit-ssoauth.verizon.com%2fsso%2fProcessLoginServlet%3floginType%3dconsumer%26target%3dhttps%253a%252f%252fsso-np.ebiz.verizon.com%252fconsumer%252fmyverizon%252frouter%253ftarget%253dhttps%25253a%25252f%25252fwwwawssit.ebiz.verizon.com%25252fforyourhome%25252fordering%25252fcheckavailabilitylq.aspx%25253fismvflow%25253dy",
  getAccount:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account",
  Wireless5Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://api-uat.verizon.com/atomapi/v1/careflowservice/careflow/affinityvalidation",
  channelLineupPackageView:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/channellookup/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/channellookup/channels/allpackages",
  channelLineupVhoUrl:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/channellookup/channels/vho",
  channelProgramMasterUrl:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/channellookup/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/channellookup/channels/searchforchannelprogram",
  chatEncry: "Y",
  validatepartner: "/inhome/validatepartner",
  chatEncrypt:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/hvals",
  chatReint: "N",
  chatStore:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/storeChatInfo",
  checkAddr:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addressqualification/address/qualification?addressID=",
  fiosMnhFetch:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addressqualification/address/fiosmnh",
  checkportability:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/tnportability/tnportability",
  clearCart:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/clearcart",
  clearCartEC:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/clearcartec",
  compareCart:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/compare",
  configEntry:
    "https://wwwnte1aws.ebiz.verizon.com/content/verizon/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://wwwawssit.ebiz.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://wwwawssit.ebiz.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId: "/inhome/generatevisitid",
  creditAssessment:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditfiosassessment",
  creditCheck:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditworthiness",
  creditRefresh:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://api-uat.verizon.com/atomapi/v1/accountqualificationservice/account/decryptData",
  dobundle:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/dobundle",
    vecorder:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "/inhome/ecFooter",
  ecHeader: "/inhome/ecHeader",
  encryptUrl:
    "https://api-uat.verizon.com/atomapi/v1/accountqualificationservice/account/encryptData",
  fbeGetSoc: "https://oa-uat.ebiz.verizon.com/atomapi/v1/experience/exp/getSoc",
  fbePostSoc: "https://oa-uat.ebiz.verizon.com/atomapi/v1/soc/fbe/PostSoc",
  futurenotification:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/futurenotification",
  generateToken:
    "https://api-uat.verizon.com/atomapi/v1/careflowservice/careflow/gettoken",
  getBanners:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/experience/exp/banners",
  getCacheValue:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/experience/exp/getcachevalue",
  getCartAcc: "https://oa-uat.ebiz.verizon.com/atomapi/v1/cart/cart/accordion",
  getFccLabel:"https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/fccLabelData",
  getMovesThrottle: "https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/nsathrottlelist",
  getCartAccEc:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/cart/cart/accordion",
  getDisclaimer:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/experience/exp/disclaimer",
  //getDisclaimerAEM:
    //"https://wwwawssit.ebiz.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getDisclaimerAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getPlansPromo:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/experience/exp/planspromo",
  //getPlansPromoAEM:
    //"https://wwwawssit.ebiz.verizon.com/personal/cas/getplanspromo.model.json",
  getPlansPromoAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDisclaimerProducts:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/experience/exp/productdisclaimer",
 // getDisclaimerProductsAEM:
  //  "https://wwwawssit.ebiz.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerProductsAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/experience/exp/commondisclaimer",
  //getCommonAEM:
  //"https://wwwawssit.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getCommonAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getDueDate:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/duedateservice/duedate/triggerduedate",
  getExistingService:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/existingservice",
  getFaq: "https://oa-uat.ebiz.verizon.com/atomapi/v1/experience/exp/faq",
  //getFaqAEM:"https://wwwawssit.ebiz.verizon.com/personal/cas/getfaq.model.json",
  getFaqAEM:"https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getfaq.model.json",
  getMon:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/masterordernumber/order/mon",
  getPartialStreetAddr:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/street?streetterm=",
  getCompleteAddress:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/address?addressid=",
  getProduct:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products",  
  getProductEc:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/ecproductservice/accordion/products",
  getProductPerks:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products",
  getProductPerksEC:
    "https://atomserviceseksuateast.ebiz.verizon.com/v05g/uat/productec/accordion/products",
  getVoiceProductEc:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/ecproductservice/products",
  getSmartCartPersonalInfo:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/contactinfo/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "VAiecKGNC721VnSn9fQrmpMumsdxZYu3",
  getStreetAddrLocus2:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "MvaCGJaWUOM1zkdFJietJiYyq15SJGdF",
  qualification5G:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addressqualification/address/fixedwirelesscoveragecheck",
  getTerms: "https://oa-uat.ebiz.verizon.com/atomapi/v1/experience/exp/terms",
 // getTermsAEM:
   // "https://wwwawssit.ebiz.verizon.com/personal/cas/getorderingtos.model.json", 
  getTermsAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/cas/getorderingtos.model.json",  
getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos: "https://oa-uat.ebiz.verizon.com/atomapi/v1/experience/exp/tos",
  getUnit:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/units",
  getUnitLocus:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-unit",
  getVZID:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/registryservice/registration/getVzid",
  getZipcode:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/zip",
  getvendorvisitdetails:
    "https://api-uat.verizon.com/atomapi/v1/sessionmanager/getvendorvisitdetails",
  jsNotify:
  "https://oa-uat.ebiz.verizon.com/atomapi/v1/common/logger/logmsg",
  kafkaErrorAppLogs:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/common/kafka/atom_applogs",
  kafkaPageLogs:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/common/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/common/kafka/atom_visitdetails",
  learnCustomTv:
    "https://wwwawssit.ebiz.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://wwwawssit.ebiz.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://wwwawssit.ebiz.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl:
    "https://wwwawssit.ebiz.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/common/kafka/pageconfig",
  nsiNotify:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/nsinotification",
  orderConfirmation:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/experience/exp/getorderconfirmation",
  performEID:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/performeid",
  personlisationdmp:
    "https://api-uat.verizon.com/atomapi/v1/persionalizationservice/personalization/getvzdmptoak",
  pieUrl: "https://pie.uat.verizon.com/pie/v1",
  postCacheValue:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/experience/exp/updatecachestorage",
  processSave:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/smartcart/order/processsmartcart",
  productOffersUrl:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/offer/products/manual",
  profileCart:
    "https://api-uat.verizon.com/atomapi/v1/cart/cart/profile",
  rapurl: "https://wwwnte3aws.ebiz.verizon.com/orderinfo/?src=olo",
  chatDetails:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/chatdetails",
  referFrinedValidation:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/refreshPromotions",
  removePromoCode:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/removePromotions",
  resumeSmartCart:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/smartcart/order/resumesmartcart",
  retrieveQualdetails:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addressqualification/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/smartcart/order/retrievesmartcart",
  sameDaydelivery:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/storepickup/switch/samedaydelivery",
  seeFcpDetail:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/experience/exp/fcpspecialoffers",
  sendLofNotification:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/lofservice/lof/sendnotification",
  sendOTP:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/registryservice/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/common/notification/sendsmsoremail",
    setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/duedateservice/duedate/reserveduedate",
  smartAutoSave:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartsave",
  smartSave:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartsavewithparam",
  smartcartCancel:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartcancel",
  getSmartCartStatus:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartstatus",
  storePickUp:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/storepickup/switch/storepickup",
  submitOrder: "https://oa-uat.ebiz.verizon.com/atomapi/v1/order/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  tokenGeneration: "/inhome/generatetoken",
  updateCartAcc:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateCartAccEc:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateintentcart:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/cart/cart/updateintent",
  updateintentcartAcc:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartEc:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/cart/cart/updateintent",
  uploadFile:
    "https://api-uat.verizon.com/atomapi/v1/careflowservice/careflow/employeeproof",
  updateFireAlarm:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/voice/firealarm",
  updateFlowType:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/sessionmanager/updateflowtype",
  getFireAlarm:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/voice/getfirealarm",
  validateBillingAdress:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/billing/order/billing",
  validateContactInfo:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/contactinfo/order/contact",
  validateCouponToken:
    "https://api-uat.verizon.com/atomapi/v1/careflowservice/careflow/validatecoupontoken",
  validateEmployee:
    "https://api-uat.verizon.com/atomapi/v1/careflowservice/careflow/validateemployee",
  validateName:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/contactinfo/order/validateName",
  validateSigninUrl:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/validateSignin",
  validateSmartCartContactInfo:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/contactinfo/order/validateSmartCartContactInfo",
  validatecartUrl:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/cart/cart/validate/",
  validatecartUrlEc:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/validate/",
  vendorFlow:
    "https://api-uat.verizon.com/atomapi/v1/sessionmanager/vendorflowvalidate",
  vendorFlowToken:
    "https://api-uat.verizon.com/atomapi/v1/sessionmanager/vendortokencreate",
  vepsUrl: "https://oa-uat.ebiz.verizon.com/atomapi/v1/veps/veps/payment",
  verifyOTP: "https://oa-uat.ebiz.verizon.com/atomapi/v1/ssocheck/verifyccpin",
  viewDetail:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/experience/exp/viewdetails",
  viewDetailAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/services/getlongdesc.fios",
  voicetn:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/phoneservices/phoneservices",
    vzFwdEnrollmentDetails: 
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addressqualification/address/enrollmentDetails", 
  twsSiginInDetails: 
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addressqualification/address/twsSiginInDetails", 
  vzwOfferEligibility:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getWirelessProduct",
  checkPDCdata:
    "https://api-uat.verizon.com/atomapi/v1/persionalizationservice/personalization/checkpdcdata",
  vzOrderInfo:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/vzorderservice/order/vzorderinfo",
  vzOrderDetail:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/vzorderservice/order/vzorderdetail",
  brtcInfo:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/vzorderservice/order/brtc",
  suppCancelCart: 
  "https://oa-uat.ebiz.verizon.com/atomapi/v1/cart/cart/supp/",
  mnhOneClickVzwAccountSave:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addressqualification/address/savewirelessaccountsystemobjectdetailstocache/",
  mnhOneClickQualification:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addressqualification/mobileandhome/ecwlnewfiosqualification",
  wlCustomerCheckoutInfo:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addressqualification/mobileandhome/wlcustomercheckoutinfo",
  mnhOneClickMarketingProfileSave:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addressqualification/address/savemaketingprofiledetailstocache/",
  mnhOneClickLoopQualSave:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addressqualification/address/saveloopqualtocache/",
  mnhOneClickLocusAddressValidationSave:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addressqualification/address/savelocusaddrvalidationdetailstocache/",
  mnhOneClickOneCreditSave:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/savesfiosonecreditdetailstocache/",
  mnhOneClickEncryptWirelessDataToken:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/addressqualification/mobileandhome/encryptwirelessdatatoken",
  mnhOneClickMLP:
    "https://wwwawssit.ebiz.verizon.com/content/verizon/personal/services/fivegoneclick.nocache.html",
  ssoMHAuthiniticate:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://oa-uat.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk",
    fiosReferralCCAToken: "https://oa-uat.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
    fiosReferralVerifyToken: "https://oa-uat.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
    ssoMHEmailAuthiniticate:
    "https://oa-uat.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",

  pollingIGBackendUrl:
    "https://securesit1.verizon.com/accessmanager/public/adaptiveauth/2fa/polling",
  verification:
    'https://oa-uat.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/verification',
  ssoMHGetName:
    "https://oa-uat.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname",  
    ssoMHGetCustomerDetails:"https://atomserviceseksuateast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getcustomerdetailsresponse",

    runtimeValuesUrl:
    "https://oa-uat.ebiz.verizon.com/atomapi/v1/common/pageflow/getruntimevalues?runtimekey=",
    disconnectBanner: "https://sso-np.ebiz.verizon.com/consumer/myverizon/homeoffers",
    mvaDisconnectBanner: "https://www.verizon.com/consumer/fios/secure/ui/acct/homeoffers", 
    getpzaiRatingNumber: "https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/fiospzai",
    getCentralAgreementTermsAEM: "https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/tosCentralAgreement",
  ...changeUATApigee
};

const nte4Proxy = {
  Wireless5Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
Lte4Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://atomcareflownte4.cfappsawsnpwest.ebiz.verizon.com/careflow/affinityvalidation",
  channelLineupPackageView:
    "https://atomchannellookupnte4.cfappsawsnpwest.ebiz.verizon.com/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://atomchannellookupnte4.cfappsawsnpwest.ebiz.verizon.com/channels/allpackages",
  channelLineupVhoUrl:
    "https://atomchannellookupnte4.cfappsawsnpwest.ebiz.verizon.com/channels/vho",
  channelProgramMasterUrl:
    "https://atomchannellookupnte4.cfappsawsnpwest.ebiz.verizon.com/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://atomchannellookupnte4.cfappsawsnpwest.ebiz.verizon.com/channels/searchforchannelprogram",
  chatEncry: "Y",
  chatEncrypt:
    "https://atomchatinfonte4.cfappsawsnpwest.ebiz.verizon.com/chatInfo/hvals",
  chatReint: "N",
  chatStore:
    "https://atomchatinfonte4.cfappsawsnpwest.ebiz.verizon.com/chatInfo/storeChatInfo",
  checkAddr:
    "https://atomaddressqualificationnte4.cfappsawsnpwest.ebiz.verizon.com/address/qualification?addressID=",
  checkportability:
    "https://atomtnportabilitynte4.cfappsawsnpwest.ebiz.verizon.com/tnportability",
  clearCart:
    "https://atomcartnte4.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/clearcart",
  clearCartEC:
    "https://atomcartecnte4.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/clearcartec",
  compareCart:
    "https://atomcartnte4.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/compare",
  configEntry:
    "https://wwwnte4aws.ebiz.verizon.com/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://wwwnte4aws.ebiz.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://wwwnte4aws.ebiz.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId:
    "https://atomsessionmanagernte4.cfappsawsnpwest.ebiz.verizon.com/visitid",
  creditAssessment:
    "https://atomcreditchecknte4.cfappsawsnpwest.ebiz.verizon.com/creditcheck/creditfiosassessment",
  creditCheck:
    "https://atomcreditchecknte4.cfappsawsnpwest.ebiz.verizon.com/creditcheck/creditworthiness",
  creditRefresh:
    "https://atomcreditchecknte4.cfappsawsnpwest.ebiz.verizon.com/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://atomcreditchecknte4.cfappsawsnpwest.ebiz.verizon.com/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://atomaccountqualificationte4.cfappsawsnpwest.ebiz.verizon.com/account/decryptData",
  dobundle:
    "https://atomproductnte4.cfappsawsnpwest.ebiz.verizon.com/products/dobundle",
    vecorder:
    "https://atomproductnte4.cfappsawsnpwest.ebiz.verizon.com/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "/inhome/ecFooter",
  ecHeader: "/inhome/ecHeader",
  encryptUrl:
    "https://atomaccountqualificationte4.cfappsawsnpwest.ebiz.verizon.com/account/encryptData",
  fbeGetSoc:
    "https://atomexperiencente4.cfappsawsnpwest.ebiz.verizon.com/exp/getSoc",
  fbePostSoc:
    "https://atomsocnte4.cfappsawsnpwest.ebiz.verizon.com/fbe/PostSoc",
  futurenotification:
    "https://atomaddresslookupnte4.cfappsawsnpwest.ebiz.verizon.com/addresses/futurenotification",
  generateToken:
    "https://atomcareflownte4.cfappsawsnpwest.ebiz.verizon.com/careflow/gettoken",
  getAccount:
    "https://atomsessionmanagernte4.cfappsawsnpwest.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account",
  getBanners:
    "https://atomexperiencente4.cfappsawsnpwest.ebiz.verizon.com/exp/banners",
  getCacheValue:
    "https://atomexperiencente4.cfappsawsnpwest.ebiz.verizon.com/exp/getcachevalue",
  getCartAcc:
    "https://atomcartnte4.cfappsawsnpwest.ebiz.verizon.com/cart/accordion",
  getCartAccEc:
    "https://atomcartnte4.cfappsawsnpwest.ebiz.verizon.com/cart/accordion",
  getDisclaimer:
    "https://atomexperiencente4.cfappsawsnpwest.ebiz.verizon.com/exp/disclaimer",
  getDisclaimerAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getPlansPromo:
    "https://atomexperiencente4.cfappsawsnpwest.ebiz.verizon.com/exp/planspromo",
  getPlansPromoAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDisclaimerProducts:
    "https://atomexperiencente4.cfappsawsnpwest.ebiz.verizon.com/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://atomexperiencente4.cfappsawsnpwest.ebiz.verizon.com/exp/commondisclaimer",
  getCommonAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getDueDate:
    "https://atomduedatente4.cfappsawsnpwest.ebiz.verizon.com/duedate/triggerduedate",
  getExistingService:
    "https://atomaddresslookupnte4.cfappsawsnpwest.ebiz.verizon.com/addresses/existingservice",
  getFaq: "https://atomexperiencente4.cfappsawsnpwest.ebiz.verizon.com/exp/faq",
  getFaqAEM:
  "https://wwwawssit.ebiz.verizon.com/personal/cas/getfaq.model.json",
  getMon: "https://atommonnte4.cfappsawsnpwest.ebiz.verizon.com/order/mon",
  getPartialStreetAddr:
    "https://atomaddresslookupnte4.cfappsawsnpwest.ebiz.verizon.com/addresses/street?streetterm=",
  getCompleteAddress:
    "https://atomaddresslookupnte4.cfappsawsnpwest.ebiz.verizon.com/addresses/address?addressid=",
  getProduct:
    "https://atomproductnte4.cfappsawsnpwest.ebiz.verizon.com/accordion/products",
  getProductEc:
    "https://atomproductecexpnte4.cfappsawsnpwest.ebiz.verizon.com/accordion/products",
  getVoiceProductEc:
    "https://atomproductecexpnte4.cfappsawsnpwest.ebiz.verizon.com/products",
  getSmartCartPersonalInfo:
    "https://atomcontactinfovalidationnte4.cfappsawsnpwest.ebiz.verizon.com/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://atomaddresslookupnte4.cfappsawsnpwest.ebiz.verizon.com/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "VAiecKGNC721VnSn9fQrmpMumsdxZYu3",
  getStreetAddrLocus2:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "MvaCGJaWUOM1zkdFJietJiYyq15SJGdF",
  getTerms:
    "https://atomexperiencente4.cfappsawsnpwest.ebiz.verizon.com/exp/terms",
  getTermsAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getorderingtos.model.json",
    getCentralAgreementTermsAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement~html.json",
  getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json", 
  getTos: "https://atomexperiencente4.cfappsawsnpwest.ebiz.verizon.com/exp/tos",
  getUnit:
    "https://atomaddresslookupnte4.cfappsawsnpwest.ebiz.verizon.com/addresses/units",
  getUnitLocus:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-unit",
  getVZID:
    "https://atomregistrationnte4.cfappsawsnpwest.ebiz.verizon.com/registration/getVzid",
  getZipcode:
    "https://atomaddresslookupnte4.cfappsawsnpwest.ebiz.verizon.com/addresses/zip",
  getvendorvisitdetails:
    "https://atomsessionmanagernte4.cfappsawsnpwest.ebiz.verizon.com/getvendorvisitdetails",
  jsNotify:
    "https://atomcommonnte4.cfappsawsnpwest.ebiz.verizon.com/logger/logmsg",    
  kafkaErrorAppLogs:
    "https://atomcommonnte4.cfappsawsnpwest.ebiz.verizon.com/kafka/atom_applogs",
  kafkaPageLogs:
    "https://atomcommonnte4.cfappsawsnpwest.ebiz.verizon.com/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://atomcommonnte4.cfappsawsnpwest.ebiz.verizon.com/kafka/atom_visitdetails",
  learnCustomTv:
    "https://wwwawssit.ebiz.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://dev-activate.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://atomvendorexperiencente4.cfappsawsnpwest.ebiz.verizon.com/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://dev-activate.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl: "https://dev-activate.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://atomcommonnte4.cfappsawsnpwest.ebiz.verizon.com/kafka/pageconfig",
  nsiNotify:
    "https://atomaddresslookupnte4.cfappsawsnpwest.ebiz.verizon.com/addresses/nsinotification",
  orderConfirmation:
    "https://atomexperiencente4.cfappsawsnpwest.ebiz.verizon.com/exp/getorderconfirmation",
  performEID:
    "https://atomcreditchecknte4.cfappsawsnpwest.ebiz.verizon.com/creditcheck/performeid",
  personlisationdmp:
    "https://atompersonalisationnte4.cfappsawsnpwest.ebiz.verizon.com/personalization/getvzdmptoak",
  pieUrl: "https://pie.uat.verizon.com/pie/v1",
  postCacheValue:
    "https://atomexperiencente4.cfappsawsnpwest.ebiz.verizon.com/exp/updatecachestorage",
  processSave:
    "https://atomsmartcartnte4.cfappsawsnpwest.ebiz.verizon.com/order/processsmartcart",
  productOffersUrl:
    "https://atomproductnte4.cfappsawsnpwest.ebiz.verizon.com/offer/products/manual",
  profileCart:
    "https://atomcartecnte4.cfappsawsnpwest.ebiz.verizon.com/cart/profile",
  chatDetails:
    "https://atomchatinfonte4.cfappsawsnpwest.ebiz.verizon.com/chatInfo/chatdetails",
  referFrinedValidation:
    "https://atomchatinfonte4.cfappsawsnpwest.ebiz.verizon.com/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://atomvzwoffereligibilitynte4.cfappsawsnpwest.ebiz.verizon.com/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://atomproductnte4.cfappsawsnpwest.ebiz.verizon.com/products/refreshPromotions",
  removePromoCode:
    "https://atomproductnte4.cfappsawsnpwest.ebiz.verizon.com/products/removePromotions",
  resumeSmartCart:
    "https://atomsmartcartnte4.cfappsawsnpwest.ebiz.verizon.com/order/resumesmartcart",
  retrieveQualdetails:
    "https://atomaddressqualificationnte4.cfappsawsnpwest.ebiz.verizon.com/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://atomsmartcartnte4.cfappsawsnpwest.ebiz.verizon.com/order/retrievesmartcart",
  sameDaydelivery:
    "https://atomstorepickupnte4.cfappsawsnpwest.ebiz.verizon.com/switch/samedaydelivery",
  seeFcpDetail:
    "https://atomexperiencente4.cfappsawsnpwest.ebiz.verizon.com/exp/fcpspecialoffers",
  sendLofNotification:
    "https://atomlofnte4.cfappsawsnpwest.ebiz.verizon.com/lof/sendnotification",
  sendOTP:
    "https://atomssochecknte4.cfappsawsnpwest.ebiz.verizon.com/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://atomregistrationnte4.cfappsawsnpwest.ebiz.verizon.com/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://atomcommonnte4.cfappsawsnpwest.ebiz.verizon.com/notification/sendsmsoremail",
    setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://atomduedatente4.cfappsawsnpwest.ebiz.verizon.com/duedate/reserveduedate",
  smartAutoSave:
    "https://atomsmartcartnte4.cfappsawsnpwest.ebiz.verizon.com/order/smartcartsave",
  smartSave:
    "https://atomsmartcartnte4.cfappsawsnpwest.ebiz.verizon.com/order/smartcartsavewithparam",
  smartcartCancel:
    "https://atomsmartcartnte4.cfappsawsnpwest.ebiz.verizon.com/order/smartcartcancel",
  getSmartCartStatus:
    "https://atomsmartcartnte4.cfappsawsnpwest.ebiz.verizon.com/order/smartcartstatus",
  storePickUp:
    "https://atomstorepickupnte4.cfappsawsnpwest.ebiz.verizon.com/switch/storepickup",
  submitOrder:
    "https://atomordersubmissionnte4.cfappsawsnpwest.ebiz.verizon.com/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  updateCartAcc:
    "https://atomcartnte4.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/updatecart",
  updateCartAccEc:
    "https://atomcartnte4.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/updatecart",
  updateintentcart:
    "https://atomcartnte4.cfappsawsnpwest.ebiz.verizon.com/cart/updateintent",
  updateintentcartAcc:
    "https://atomcartnte4.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://atomcartnte4.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/updateintent",
  updateintentcartEc:
    "https://atomcartnte4.cfappsawsnpwest.ebiz.verizon.com/cart/updateintent",
  uploadFile:
    "https://atomcareflownte4.cfappsawsnpwest.ebiz.verizon.com/careflow/employeeproof",
  validateBillingAdress:
    "https://atombillingvalidationnte4.cfappsawsnpwest.ebiz.verizon.com/order/billing",
  validateContactInfo:
    "https://atomcontactinfovalidationnte4.cfappsawsnpwest.ebiz.verizon.com/order/contact",
  validateCouponToken:
    "https://atomcareflownte4.cfappsawsnpwest.ebiz.verizon.com/careflow/validatecoupontoken",
  validateEmployee:
    "https://atomcareflownte4.cfappsawsnpwest.ebiz.verizon.com/careflow/validateemployee",
  validateName:
    "https://atomcontactinfovalidationnte4.cfappsawsnpwest.ebiz.verizon.com/order/validateName",
  validateSigninUrl:
    "https://atomaccountqualificationte4.cfappsawsnpwest.ebiz.verizon.com/account/validateSignin",
  validateSmartCartContactInfo:
    "https://atomcontactinfovalidationnte4.cfappsawsnpwest.ebiz.verizon.com/order/validateSmartCartContactInfo",
  validatecartUrl:
    "https://atomcartnte4.cfappsawsnpwest.ebiz.verizon.com/cart/validate/",
  validatecartUrlEc:
    "https://atomcartnte4.cfappsawsnpwest.ebiz.verizon.com/cart/accordion/validate/",
  vendorFlow:
    "https://atomsessionmanagernte4.cfappsawsnpwest.ebiz.verizon.com/vendorflowvalidate",
  vendorFlowToken:
    "https://atomsessionmanagernte4.cfappsawsnpwest.ebiz.verizon.com/vendortokencreate",
  vepsUrl: "https://atomvepsnte4.cfappsawsnpwest.ebiz.verizon.com/veps/payment",
  verifyOTP:
    "https://atomssochecknte4.cfappsawsnpwest.ebiz.verizon.com/ssocheck/verifyccpin",
  viewDetail:
    "https://atomexperiencente4.cfappsawsnpwest.ebiz.verizon.com/exp/viewdetails",
  viewDetailAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/services/getlongdesc.fios",
  voicetn:
    "https://atomphoneservicesnte4.cfappsawsnpwest.ebiz.verizon.com/phoneservices",
    vzFwdEnrollmentDetails: 
    "https://atomaddressqualificationnte4.cfappsawsnpwest.ebiz.verizon.com/address/enrollmentDetails", 
  twsSiginInDetails: 
    "https://atomaddressqualificationnte4.cfappsawsnpwest.ebiz.verizon.com/address/twsSiginInDetails",
  vzwOfferEligibility:
    "https://atomvzwoffereligibilitynte4.cfappsawsnpwest.ebiz.verizon.com/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://atomvzwoffereligibilitynte4.cfappsawsnpwest.ebiz.verizon.com/eligibility/getWirelessProduct",
  checkPDCdata:
    "https://atompersonalisationnte4.cfappsawsnpwest.ebiz.verizon.com/personalization/checkpdcdata",
  vzOrderInfo:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/sit/vzorder/order/vzorderinfo",
  vzOrderDetail:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/sit/vzorder/order/vzorderdetail",
  brtcInfo:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/sit/vzorder/order/brtc",
  suppCancelCart:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/sit/cart/cart/supp/",
  ssoMHAuthiniticate:
    "https://atomserviceseksqaeast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://atomserviceseksqaeast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk", 
    fiosReferralCCAToken: "https://atomserviceseksqaeast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
    fiosReferralVerifyToken: "https://atomserviceseksqaeast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
    ssoMHEmailAuthiniticate:
    "https://atomserviceseksqaeast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",

  pollingIGBackendUrl:
    "https://securesit1.verizon.com/accessmanager/public/adaptiveauth/2fa/polling",
  ssoMHGetName:
    "https://atomserviceseksqaeast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname",  
  mfrtnFlow:
    "https://atomserviceseastnte4.ebiz.verizon.com/v05g/stg/careflow/frontliners/save"
};

const nte4Apigee = {
  MoveCheckoutExperience:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/contactinfo/order/moves/getCheckoutExperience",
  MoveLandingExperience:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/moves/getMovesExperience",
    
  Wireless5Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/affinityvalidation",
  channelLineupPackageView:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/channellookup/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/channellookup/channels/allpackages",
  channelLineupVhoUrl:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/channellookup/channels/vho",
  channelProgramMasterUrl:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/channellookup/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/channellookup/channels/searchforchannelprogram",
  chatEncry: "Y",
  chatEncrypt:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/hvals",
  chatReint: "N",
  validatepartner: "/inhome/validatepartner",
  chatStore:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/storeChatInfo",
  checkAddr:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/addressqualification/address/qualification?addressID=",
  fiosMnhFetch:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/addressqualification/address/fiosmnh",
  checkportability:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/tnportability/tnportability",
  clearCart:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/clearcart",
  clearCartEC:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/clearcartec",
  compareCart:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/compare",
  configEntry:
    "https://wwwnte4aws.ebiz.verizon.com/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://wwwawssit.ebiz.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://wwwawssit.ebiz.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId: "/inhome/generatevisitid",
  creditAssessment:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditfiosassessment",
  creditCheck:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditworthiness",
  creditRefresh:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/decryptData",
  dobundle:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/dobundle",
    vecorder:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "/inhome/ecFooter",
  ecHeader: "/inhome/ecHeader",
  encryptUrl:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/encryptData",
  fbeGetSoc: "https://oa-dev.ebiz.verizon.com/atomapi/v1/experience/exp/getSoc",
  fbePostSoc: "https://oa-dev.ebiz.verizon.com/atomapi/v1/soc/fbe/PostSoc",
  futurenotification:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/futurenotification",
  generateToken:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/gettoken",
  getAccount:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account",
  getBanners:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/experience/exp/banners",
  getCacheValue:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/experience/exp/getcachevalue",
  getCartAcc: "https://oa-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion",
  getCartAccEc:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion",
  getDisclaimer:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/experience/exp/disclaimer",
  getDisclaimerAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getPlansPromo:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/experience/exp/planspromo",
  getPlansPromoAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDisclaimerProducts:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/experience/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/experience/exp/commondisclaimer",
  getCommonAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getDueDate:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/duedateservice/duedate/triggerduedate",
  getExistingService:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/existingservice",
  getFaq: "https://oa-dev.ebiz.verizon.com/atomapi/v1/experience/exp/faq",
  getFaqAEM:
  "https://wwwawssit.ebiz.verizon.com/personal/cas/getfaq.model.json",
  getMon:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/masterordernumber/order/mon",
  getPartialStreetAddr:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/street?streetterm=",
  getCompleteAddress:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/address?addressid=",
  getProduct:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products",
  getProductEc:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/ecproductservice/accordion/products",
  getVoiceProductEc:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/ecproductservice/products",
  getSmartCartPersonalInfo:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/contactinfo/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "VAiecKGNC721VnSn9fQrmpMumsdxZYu3",
  getStreetAddrLocus2:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "MvaCGJaWUOM1zkdFJietJiYyq15SJGdF",
  getTerms: "https://oa-dev.ebiz.verizon.com/atomapi/v1/experience/exp/terms",
  getTermsAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getorderingtos.model.json", 
  getCentralAgreementTermsAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement~html.json",
getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos: "https://oa-dev.ebiz.verizon.com/atomapi/v1/experience/exp/tos",
  getUnit:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/units",
  getUnitLocus:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-unit",
  getVZID:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/registryservice/registration/getVzid",
  getZipcode:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/zip",
  getvendorvisitdetails:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/sessionmanager/getvendorvisitdetails",
  jsNotify:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/common/logger/logmsg",
  kafkaErrorAppLogs:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/common/kafka/atom_applogs",
  kafkaPageLogs:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/common/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/common/kafka/atom_visitdetails",
  learnCustomTv:
    "https://wwwawssit.ebiz.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://sit-activate.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://sit-activate.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl: "https://sit-activate.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/common/kafka/pageconfig",
  nsiNotify:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/nsinotification",
  orderConfirmation:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/experience/exp/getorderconfirmation",
  performEID:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/performeid",
  personlisationdmp:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/getvzdmptoak",
  pieUrl: "https://pie.uat.verizon.com/pie/v1",
  postCacheValue:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/experience/exp/updatecachestorage",
  processSave:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/smartcart/order/processsmartcart",
  productOffersUrl:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/qualifiedproducts/offer/products/manual",
  profileCart:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/cart/cart/profile",
  chatDetails:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/chatdetails",
  referFrinedValidation:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/refreshPromotions",
  removePromoCode:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/removePromotions",
  resumeSmartCart:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/smartcart/order/resumesmartcart",
  retrieveQualdetails:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/addressqualification/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/smartcart/order/retrievesmartcart",
  sameDaydelivery:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/storepickup/switch/samedaydelivery",
  seeFcpDetail:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/experience/exp/fcpspecialoffers",
  sendLofNotification:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/lofservice/lof/sendnotification",
  sendOTP:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/registryservice/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/common/notification/sendsmsoremail",
    setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/duedateservice/duedate/reserveduedate",
  smartAutoSave:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartsave",
  smartSave:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartsavewithparam",
  smartcartCancel:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartcancel",
  getSmartCartStatus:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartstatus",
  storePickUp:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/storepickup/switch/storepickup",
  submitOrder: "https://oa-dev.ebiz.verizon.com/atomapi/v1/order/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  tokenGeneration: "/inhome/generatetoken",
  updateCartAcc:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateCartAccEc:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateFlowType:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/sessionmanager/updateflowtype",
  updateintentcart:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/cart/cart/updateintent",
  updateintentcartAcc:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartEc:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/cart/cart/updateintent",
  uploadFile:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/employeeproof",
  validateBillingAdress:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/billing/order/billing",
  validateContactInfo:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/contactinfo/order/contact",
  validateCouponToken:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/validatecoupontoken",
  validateEmployee:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/validateemployee",
  validateName:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/contactinfo/order/validateName",
  validateSigninUrl:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/validateSignin",
  validateSmartCartContactInfo:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/contactinfo/order/validateSmartCartContactInfo",
  validatecartUrl:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/cart/cart/validate/",
  validatecartUrlEc:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/validate/",
  vendorFlow:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/sessionmanager/vendorflowvalidate",
  vendorFlowToken:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/sessionmanager/vendortokencreate",
  vepsUrl: "https://oa-dev.ebiz.verizon.com/atomapi/v1/veps/veps/payment",
  verifyOTP: "https://oa-dev.ebiz.verizon.com/atomapi/v1/ssocheck/verifyccpin",
  viewDetail:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/experience/exp/viewdetails",
  viewDetailAEM:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/services/getlongdesc.fios",
  voicetn:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/phoneservices/phoneservices",
    vzFwdEnrollmentDetails: 
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/addressqualification/address/enrollmentDetails", 
  twsSiginInDetails: 
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/addressqualification/address/twsSiginInDetails", 
  vzwOfferEligibility:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getWirelessProduct",
  checkPDCdata:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/checkpdcdata",
  vzOrderInfo:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/vzorderservice/order/vzorderinfo",
  vzOrderDetail:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/vzorderservice/order/vzorderdetail",
  brtcInfo:
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/vzorderservice/order/brtc",
  suppCancelCart: 
    "https://oa-dev.ebiz.verizon.com/atomapi/v1/cart/cart/supp/",
  ssoMHAuthiniticate:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk", 
  fiosReferralCCAToken: "https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
  fiosReferralVerifyToken: "https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
  ssoMHEmailAuthiniticate:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",

  pollingIGBackendUrl:
    "https://securesit1.verizon.com/accessmanager/public/adaptiveauth/2fa/polling",
  ssoMHGetName:
    "https://api-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname",
    getPerksAEM:"https://wwwawssit.ebiz.verizon.com/content/caas/plan/aggregated-perks.model.json", 
    getpzaiRatingNumber: "https://oa-uat.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products/fiospzai", 
};

const nte5Proxy = {
  MoveCheckoutExperience:
    "https://atomcontactinfovalidationnte5.cfappsawsnpeast.ebiz.verizon.com/order/moves/getCheckoutExperience",
  MoveLandingExperience:
    "https://atomproductnte5.cfappsawsnpeast.ebiz.verizon.com/products/moves/getMovesExperience",
  Wireless5Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://atomcareflownte5.cfappsawsnpeast.ebiz.verizon.com/careflow/affinityvalidation",
  channelLineupPackageView:
    "https://atomchannellookupnte5.cfappsawsnpeast.ebiz.verizon.com/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://atomchannellookupnte5.cfappsawsnpeast.ebiz.verizon.com/channels/allpackages",
  channelLineupVhoUrl:
    "https://atomchannellookupnte5.cfappsawsnpeast.ebiz.verizon.com/channels/vho",
  channelProgramMasterUrl:
    "https://atomchannellookupnte5.cfappsawsnpeast.ebiz.verizon.com/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://atomchannellookupnte5.cfappsawsnpeast.ebiz.verizon.com/channels/searchforchannelprogram",
  chatEncry: "Y",
  chatEncrypt:
    "https://atomchatinfonte5.cfappsawsnpeast.ebiz.verizon.com/chatInfo/hvals",
  chatReint: "N",
  chatStore:
    "https://atomchatinfonte5.cfappsawsnpeast.ebiz.verizon.com/chatInfo/storeChatInfo",
  checkAddr:
    "https://atomaddressqualificationnte5.cfappsawsnpeast.ebiz.verizon.com/address/qualification?addressID=",
  checkportability:
    "https://atomtnportabilitynte5.cfappsawsnpeast.ebiz.verizon.com/tnportability",
  clearCart:
    "https://atomcartnte5.cfappsawsnpeast.ebiz.verizon.com/cart/accordion/clearcart",
  clearCartEC:
    "https://atomcartecnte5.cfappsawsnpeast.ebiz.verizon.com/cart/accordion/clearcartec",
  compareCart:
    "https://atomcartnte5.cfappsawsnpeast.ebiz.verizon.com/cart/accordion/compare",
  configEntry:
    "https://wwwnte1aws.ebiz.verizon.com/content/verizon/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://wwwawsnte5.ebiz.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://wwwawssit.ebiz.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId:
    "https://atomsessionmanagernte5.cfappsawsnpeast.ebiz.verizon.com/visitid",
  creditAssessment:
    "https://atomcreditchecknte5.cfappsawsnpeast.ebiz.verizon.com/creditcheck/creditfiosassessment",
  creditCheck:
    "https://atomcreditchecknte5.cfappsawsnpeast.ebiz.verizon.com/creditcheck/creditworthiness",
  creditRefresh:
    "https://atomcreditchecknte5.cfappsawsnpeast.ebiz.verizon.com/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://atomcreditchecknte5.cfappsawsnpeast.ebiz.verizon.com/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://atomaccountqualificationnte5.cfappsawsnpeast.ebiz.verizon.com/account/decryptData",
  dobundle:
    "https://atomproductnte5.cfappsawsnpeast.ebiz.verizon.com/products/dobundle",
    vecorder:
    "https://atomproductnte5.cfappsawsnpeast.ebiz.verizon.com/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "/inhome/ecFooter",
  ecHeader: "/inhome/ecHeader",
  encryptUrl:
    "https://atomaccountqualificationnte5.cfappsawsnpeast.ebiz.verizon.com/account/encryptData",
  fbeGetSoc:
    "https://atomexperiencente5.cfappsawsnpeast.ebiz.verizon.com/exp/getSoc",
  fbePostSoc:
    "https://atomsocnte5.cfappsawsnpeast.ebiz.verizon.com/fbe/PostSoc",
  futurenotification:
    "https://atomaddresslookupnte5.cfappsawsnpeast.ebiz.verizon.com/addresses/futurenotification",
  getAccount:
    "https://atomaccountqualificationnte5.cfappsawsnpeast.ebiz.verizon.com/account",
  getBanners:
    "https://atomexperiencente5.cfappsawsnpeast.ebiz.verizon.com/exp/banners",
  getCacheValue:
    "https://atomexperiencente5.cfappsawsnpeast.ebiz.verizon.com/exp/getcachevalue",
  getCartAcc:
    "https://atomcartnte5.cfappsawsnpeast.ebiz.verizon.com/cart/accordion",
  getCartAccEc:
    "https://atomcartecnte5.cfappsawsnpeast.ebiz.verizon.com/cart/accordion",
  getDisclaimer:
    "https://atomexperiencente5.cfappsawsnpeast.ebiz.verizon.com/exp/disclaimer",
  getDisclaimerAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getPlansPromo:
    "https://atomexperiencente5.cfappsawsnpeast.ebiz.verizon.com/exp/planspromo",
  getPlansPromoAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDisclaimerProducts:
    "https://atomexperiencente5.cfappsawsnpeast.ebiz.verizon.com/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://atomexperiencente5.cfappsawsnpeast.ebiz.verizon.com/exp/commondisclaimer",
  getCommonAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getDueDate:
    "https://atomduedatente5.cfappsawsnpeast.ebiz.verizon.com/duedate/triggerduedate",
  getExistingService:
    "https://atomaddresslookupnte5.cfappsawsnpeast.ebiz.verizon.com/addresses/existingservice",
  getFaq: "https://atomexperiencente5.cfappsawsnpeast.ebiz.verizon.com/exp/faq",
  getFaqAEM:
  "https://wwwawssit.ebiz.verizon.com/personal/cas/getfaq.model.json",
  getMon: "https://atommonnte5.cfappsawsnpeast.ebiz.verizon.com/order/mon",
  getPartialStreetAddr:
    "https://atomaddresslookupnte5.cfappsawsnpeast.ebiz.verizon.com/addresses/street?streetterm=",
  getCompleteAddress:
    "https://atomaddresslookupnte5.cfappsawsnpeast.ebiz.verizon.com/addresses/address?addressid=",
  getProduct:
    "https://atomproductnte5.cfappsawsnpeast.ebiz.verizon.com/accordion/products",
  getProductEc:
    "https://atomproductecexpnte5.cfappsawsnpeast.ebiz.verizon.com/accordion/products",
  getVoiceProductEc:
    "https://atomproductecexpnte5.cfappsawsnpeast.ebiz.verizon.com/products",
  getSmartCartPersonalInfo:
    "https://atomcontactinfovalidationnte5.cfappsawsnpeast.ebiz.verizon.com/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://atomaddresslookupnte5.cfappsawsnpeast.ebiz.verizon.com/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "VAiecKGNC721VnSn9fQrmpMumsdxZYu3",
  getStreetAddrLocus2:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "MvaCGJaWUOM1zkdFJietJiYyq15SJGdF",
  getTerms:
    "https://atomexperiencente5.cfappsawsnpeast.ebiz.verizon.com/exp/terms",
  getTermsAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getorderingtos.model.json", 
    getCentralAgreementTermsAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement~html.json",
  getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos: "https://atomexperiencente5.cfappsawsnpeast.ebiz.verizon.com/exp/tos",
  getUnit:
    "https://atomaddresslookupnte5.cfappsawsnpeast.ebiz.verizon.com/addresses/units",
  getUnitLocus:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-unit",
  getVZID:
    "https://atomregistrationnte5.cfappsawsnpeast.ebiz.verizon.com/registration/getVzid",
  getZipcode:
    "https://atomaddresslookupnte5.cfappsawsnpeast.ebiz.verizon.com/addresses/zip",
  getvendorvisitdetails:
    "https://atomsessionmanagernte5.cfappsawsnpeast.ebiz.verizon.com/getvendorvisitdetails",
  jsNotify:
    "https://atomcommonnte5.cfappsawsnpeast.ebiz.verizon.com/logger/logmsg",
  kafkaErrorAppLogs:
    "https://atomcommonnte5.cfappsawsnpeast.ebiz.verizon.com/kafka/atom_applogs",
  kafkaPageLogs:
    "https://atomcommonnte5.cfappsawsnpeast.ebiz.verizon.com/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://atomcommonnte5.cfappsawsnpeast.ebiz.verizon.com/kafka/atom_visitdetails",
  learnCustomTv:
    "https://wwwawssit.ebiz.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://dev-activate.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://atomvendorexperiencente5.cfappsawsnpeast.ebiz.verizon.com/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://dev-activate.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl: "https://dev-activate.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://atomcommonnte5.cfappsawsnpeast.ebiz.verizon.com/kafka/pageconfig",
  nsiNotify:
    "https://atomaddresslookupnte5.cfappsawsnpeast.ebiz.verizon.com/addresses/nsinotification",
  orderConfirmation:
    "https://atomexperiencente5.cfappsawsnpeast.ebiz.verizon.com/exp/getorderconfirmation",
  performEID:
    "https://atomcreditchecknte5.cfappsawsnpeast.ebiz.verizon.com/creditcheck/performeid",
  personlisationdmp:
    "https://atompersonalisationnte5.cfappsawsnpeast.ebiz.verizon.com/personalization/getvzdmptoak",
  pieUrl: "https://pie.uat.verizon.com/pie/v1",
  postCacheValue:
    "https://atomexperiencente5.cfappsawsnpeast.ebiz.verizon.com/exp/updatecachestorage",
  processSave:
    "https://atomsmartcartnte5.cfappsawsnpeast.ebiz.verizon.com/order/processsmartcart",
  productOffersUrl:
    "https://atomproductnte5.cfappsawsnpeast.ebiz.verizon.com/offer/products/manual",
  profileCart:
    "https://atomcartecnte5.cfappsawsnpeast.ebiz.verizon.com/cart/profile",
  chatDetails:
    "https://atomchatinfonte5.cfappsawsnpeast.ebiz.verizon.com/chatInfo/chatdetails",
  referFrinedValidation:
    "https://atomchatinfonte5.cfappsawsnpeast.ebiz.verizon.com/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://atomvzwoffereligibilitynte5.cfappsawsnpeast.ebiz.verizon.com/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://atomproductnte5.cfappsawsnpeast.ebiz.verizon.com/products/refreshPromotions",
  removePromoCode:
    "https://atomproductnte5.cfappsawsnpeast.ebiz.verizon.com/products/removePromotions",
  resumeSmartCart:
    "https://atomsmartcartnte5.cfappsawsnpeast.ebiz.verizon.com/order/resumesmartcart",
  retrieveQualdetails:
    "https://atomaddressqualificationnte5.cfappsawsnpeast.ebiz.verizon.com/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://atomsmartcartnte5.cfappsawsnpeast.ebiz.verizon.com/order/retrievesmartcart",
  sameDaydelivery:
    "https://atomstorepickupnte5.cfappsawsnpeast.ebiz.verizon.com/switch/samedaydelivery",
  seeFcpDetail:
    "https://atomexperiencente5.cfappsawsnpeast.ebiz.verizon.com/exp/fcpspecialoffers",
  sendLofNotification:
    "https://atomlofnte5.cfappsawsnpeast.ebiz.verizon.com/lof/sendnotification",
  sendOTP:
    "https://atomssochecknte5.cfappsawsnpeast.ebiz.verizon.com/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://atomregistrationnte5.cfappsawsnpeast.ebiz.verizon.com/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://atomcommonnte5.cfappsawsnpeast.ebiz.verizon.com/notification/sendsmsoremail",
    setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://atomduedatente5.cfappsawsnpeast.ebiz.verizon.com/duedate/reserveduedate",
  smartAutoSave:
    "https://atomsmartcartnte5.cfappsawsnpeast.ebiz.verizon.com/order/smartcartsave",
  smartSave:
    "https://atomsmartcartnte5.cfappsawsnpeast.ebiz.verizon.com/order/smartcartsavewithparam",
  smartcartCancel:
    "https://atomsmartcartnte5.cfappsawsnpeast.ebiz.verizon.com/order/smartcartcancel",
  getSmartCartStatus:
    "https:/atomsmartcartnte5.cfappsawsnpeast.ebiz.verizon.com/order/smartcartstatus",
  storePickUp:
    "https://atomstorepickupnte5.cfappsawsnpeast.ebiz.verizon.com/switch/storepickup",
  submitOrder:
    "https://atomordersubmissionnte5.cfappsawsnpeast.ebiz.verizon.com/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  updateCartAcc:
    "https://atomcartnte5.cfappsawsnpeast.ebiz.verizon.com/cart/accordion/updatecart",
  updateCartAccEc:
    "https://atomcartecnte5.cfappsawsnpeast.ebiz.verizon.com/cart/accordion/updatecart",
  updateFlowType:
    "https://atomsessionmanagernte5.cfappsawsnpeast.ebiz.verizon.com/updateflowtype",
  updateintentcart:
    "https://atomcartnte5.cfappsawsnpeast.ebiz.verizon.com/cart/updateintent",
  updateintentcartAcc:
    "https://atomcartnte5.cfappsawsnpeast.ebiz.verizon.com/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://atomcartecnte5.cfappsawsnpeast.ebiz.verizon.com/cart/accordion/updateintent",
  updateintentcartEc:
    "https://atomcartecnte5.cfappsawsnpeast.ebiz.verizon.com/cart/updateintent",
  uploadFile:
    "https://atomcareflownte5.cfappsawsnpwest.ebiz.verizon.com/careflow/employeeproof",
  validateBillingAdress:
    "https://atombillingvalidationnte5.cfappsawsnpeast.ebiz.verizon.com/order/billing",
  validateContactInfo:
    "https://atomcontactinfovalidationnte5.cfappsawsnpeast.ebiz.verizon.com/order/contact",
  validateCouponToken:
    "https://atomcareflownte5.cfappsawsnpeast.ebiz.verizon.com/careflow/validatecoupontoken",
  validateEmployee:
    "https://atomcareflownte5.cfappsawsnpeast.ebiz.verizon.com/careflow/validateemployee",
  validateName:
    "https://atomcontactinfovalidationnte5.cfappsawsnpeast.ebiz.verizon.com/order/validateName",
  validateSigninUrl:
    "https://atomaccountqualificationnte5.cfappsawsnpeast.ebiz.verizon.com/account/validateSignin",
  validateSmartCartContactInfo:
    "https://atomcontactinfovalidationnte5.cfappsawsnpeast.ebiz.verizon.com/order/validateSmartCartContactInfo",
  validatecartUrl:
    "https://atomcartnte5.cfappsawsnpeast.ebiz.verizon.com/cart/validate/",
  validatecartUrlEc:
    "https://atomcartecnte5.cfappsawsnpeast.ebiz.verizon.com/cart/accordion/validate/",
  vendorFlow:
    "https://atomsessionmanagernte5.cfappsawsnpeast.ebiz.verizon.com/vendorflowvalidate",
  vendorFlowToken:
    "https://atomsessionmanagernte5.cfappsawsnpeast.ebiz.verizon.com/vendortokencreate",
  vepsUrl: "https://atomvepsnte5.cfappsawsnpeast.ebiz.verizon.com/veps/payment",
  verifyOTP:
    "https://atomssochecknte5.cfappsawsnpeast.ebiz.verizon.com/ssocheck/verifyccpin",
  viewDetail:
    "https://atomexperiencente5.cfappsawsnpeast.ebiz.verizon.com/exp/viewdetails",
  viewDetailAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/services/getlongdesc.fios",
  voicetn:
    "https://atomphoneservicesnte5.cfappsawsnpeast.ebiz.verizon.com/phoneservices",
    vzFwdEnrollmentDetails: 
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/enrollmentDetails", 
  twsSiginInDetails: 
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/twsSiginInDetails", 
  vzwOfferEligibility:
    "https://atomvzwoffereligibilitynte5.cfappsawsnpeast.ebiz.verizon.com/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://atomvzwoffereligibilitynte5.cfappsawsnpeast.ebiz.verizon.com/eligibility/getWirelessProduct",
  checkPDCdata:
    "https://atompersonalisationnte5.cfappsawsnpeast.ebiz.verizon.com/personalization/checkpdcdata",
  vzOrderInfo:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/sit/vzorder/order/vzorderinfo",
  vzOrderDetail:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/sit/vzorder/order/vzorderdetail",
  brtcInfo:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/sit/vzorder/order/brtc",
  suppCancelCart:
    "https://atomserviceseksqaeast.ebiz.verizon.com/v05g/sit/cart/cart/supp/",
  mfrtnFlow:
    "https://atomserviceseastnte5.ebiz.verizon.com/v05g/stg/careflow/frontliners/save",
  ssoMHAuthiniticate:
    "https://atomserviceseksqaeast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
    "https://atomserviceseksqaeast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk",
  fiosReferralCCAToken: "https://atomserviceseksqaeast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
  fiosReferralVerifyToken: "https://atomserviceseksqaeast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
  ssoMHEmailAuthiniticate:
    "https://atomserviceseksqaeast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",
  pollingIGBackendUrl:
    "https://securesit1.verizon.com/accessmanager/public/adaptiveauth/2fa/polling",
  ssoMHGetName:
    "https://atomserviceseksqaeast.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname", 
    getPerksAEM:"https://wwwawssit.ebiz.verizon.com/content/caas/plan/aggregated-perks.model.json",
};

const nte5Apigee = {
  MoveCheckoutExperience:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/contactinfo/order/moves/getCheckoutExperience",
  MoveLandingExperience:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/moves/getMovesExperience",
  Wireless5Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  Lte4Gurl: "https://vzwqa1.verizonwireless.com/5g/home/?src=inhome&doLqCall=Y",
  careFlowFormValidation:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/affinityvalidation",
  channelLineupPackageView:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/channellookup/channels/packageviewbyname",
  channelLineupPackagesUrl:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/channellookup/channels/allpackages",
  channelLineupVhoUrl:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/channellookup/channels/vho",
  channelProgramMasterUrl:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/channellookup/channels/channelprogrammaster",
  channelProgramSearchUrl:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/channellookup/channels/searchforchannelprogram",
  chatEncry: "Y",
  chatEncrypt:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/hvals",
  chatReint: "N",
  validatepartner: "/inhome/validatepartner",
  chatStore:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/storeChatInfo",
  checkAddr:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/addressqualification/address/qualification?addressID=",
  fiosMnhFetch:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/addressqualification/address/fiosmnh",
  checkportability:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/tnportability/tnportability",
  clearCart:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/clearcart",
  clearCartEC:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/clearcartec",
  compareCart:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/compare",
  configEntry:
    "https://wwwnte4aws.ebiz.verizon.com/personal/services/getaccordionmapping.runtimekeys.json",
  contractConfigUrl:
    "https://wwwawssit.ebiz.verizon.com/personal/services/getaccordionmapping.contracttile.json",
  emergencyNotificationStatesConfigUrl:
    "https://wwwawssit.ebiz.verizon.com/personal/services/getaccordionmapping.notification.json",
  createVisitId: "/inhome/generatevisitid",
  creditAssessment:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditfiosassessment",
  creditCheck:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditworthiness",
  creditRefresh:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefresh?triggerCRVCredit=Y",
  creditRefreshSupp:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/creditrefreshsupp",
  decryptUrl:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/decryptData",
  dobundle:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/dobundle",
    vecorder:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/vecorder",
  dtmurl:
    "https://assets.adobedtm.com/10d5272d092923c410feae744225087686012423/satelliteLib-8df7d93db820b272138ecb04dbe4ed7f5023b893-staging.js",
  ecFooter: "/inhome/ecFooter",
  ecHeader: "/inhome/ecHeader",
  encryptUrl:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/encryptData",
  fbeGetSoc: "https://oa-qa.ebiz.verizon.com/atomapi/v1/experience/exp/getSoc",
  fbePostSoc: "https://oa-qa.ebiz.verizon.com/atomapi/v1/soc/fbe/PostSoc",
  futurenotification:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/futurenotification",
  generateToken:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/gettoken",
  getAccount:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account",
  getBanners:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/experience/exp/banners",
  getCacheValue:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/experience/exp/getcachevalue",
  getCartAcc: "https://oa-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion",
  getCartAccEc:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion",
  getDisclaimer:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/experience/exp/disclaimer",
  getDisclaimerAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getorderingdisclaimer.model.json",
  getPlansPromo:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/experience/exp/planspromo",
  getPlansPromoAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getplanspromo.model.json",
  getLqAEMBanner:
    "https://sales-bau-sit2-publisher.ebiz.verizon.com/content/vcg/homeservices/homeLQ.model.json",
  getDisclaimerProducts:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/experience/exp/productdisclaimer",
  getDisclaimerProductsAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getproductsdisclaimer.model.json",
  getDisclaimerCommon:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/experience/exp/commondisclaimer",
  getCommonAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getcommondisclaimer.model.json",
  getDueDate:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/duedateservice/duedate/triggerduedate",
  getExistingService:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/existingservice",
  getFaq: "https://oa-qa.ebiz.verizon.com/atomapi/v1/experience/exp/faq",
  getFaqAEM:
  "https://wwwawssit.ebiz.verizon.com/personal/cas/getfaq.model.json",
  getMon:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/masterordernumber/order/mon",
  getPartialStreetAddr:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/street?streetterm=",
  getCompleteAddress:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/address?addressid=",
  getProduct:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/accordion/products",
  getProductEc:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/ecproductservice/accordion/products",
  getVoiceProductEc:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/ecproductservice/products",
  getSmartCartPersonalInfo:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/contactinfo/order/smartcartpersonalinfo",
  getStreetAddr:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/streetbyzip",
  getStreetAddrLocus1:
    "https://oa-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=",
  locusapikey1: "VAiecKGNC721VnSn9fQrmpMumsdxZYu3",
  getStreetAddrLocus2:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-address?streetterm=",
  locusapikey2: "MvaCGJaWUOM1zkdFJietJiYyq15SJGdF",
  getTerms: "https://oa-qa.ebiz.verizon.com/atomapi/v1/experience/exp/terms",
  getTermsAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/cas/getorderingtos.model.json", 
    getCentralAgreementTermsAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement~html.json",
  getCentralAgreementTermsSpanishAEM: "https://vzwqa1.sdc.vzwcorp.com/content/support/servlets/getLegalPagesContent.wireline-customer-agreement-es~html.json",
  getTos: "https://oa-qa.ebiz.verizon.com/atomapi/v1/experience/exp/tos",
  getUnit:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/units",
  getUnitLocus:
    "https://oa-qa.ebiz.verizon.com/locus-address-api/address/typeahead-unit",
  getVZID:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/registryservice/registration/getVzid",
  getZipcode:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/zip",
  getvendorvisitdetails:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/sessionmanager/getvendorvisitdetails",
  jsNotify:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/common/logger/logmsg",
  kafkaErrorAppLogs:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/common/kafka/atom_applogs",
  kafkaPageLogs:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/common/kafka/atom_pagelogs",
  kafkaPageLogsUrl: "/inhome/pagelogs",
kafkaAppLogsUrl: "/inhome/applogs",
logmsgUrl: "/inhome/logmsg",
  kafkaVisitLogs:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/common/kafka/atom_visitdetails",
  learnCustomTv:
    "https://wwwawssit.ebiz.verizon.com/home/popup/customgeneric?&acfl=Y",
  lofRegistrationUrl:
    "https://sit-activate.verizon.com/orderinfo/doregistration",
  lofStatus:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/vendorexperienceservice/vendorexperience/checkrapdetails",
  lofUserNameCheckUrl:
    "https://sit-activate.verizon.com/orderinfo/validateuserName",
  lofWidgetUrl: "https://sit-activate.verizon.com/orderinfo/registrationwidget",
  loggingEnabler:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/common/kafka/pageconfig",
  nsiNotify:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/addresslookup/addresses/nsinotification",
  orderConfirmation:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/experience/exp/getorderconfirmation",
  performEID:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/creditcheckservice/creditcheck/performeid",
  personlisationdmp:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/getvzdmptoak",
  pieUrl: "https://pie.uat.verizon.com/pie/v1",
  postCacheValue:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/experience/exp/updatecachestorage",
  processSave:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/smartcart/order/processsmartcart",
  productOffersUrl:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/offer/products/manual",
  profileCart:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/cart/cart/profile",
  chatDetails:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/chatdetails",
  referFrinedValidation:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/chatinfoservice/chatInfo/validateReferralCode",
  ffCouponValidation:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validateffredemptioncode",
  refreshPromotionsUrl:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/refreshPromotions",
  removePromoCode:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/qualifiedproducts/products/removePromotions",
  resumeSmartCart:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/smartcart/order/resumesmartcart",
  retrieveQualdetails:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/addressqualification/address/retrievequaldetails?objectType=QUALIFICATION_JSON&objectSubType=GETQUALIFICATIONDETAILS",
  retrieveSmartCart:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/smartcart/order/retrievesmartcart",
  sameDaydelivery:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/storepickup/switch/samedaydelivery",
  seeFcpDetail:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/experience/exp/fcpspecialoffers",
  sendLofNotification:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/lofservice/lof/sendnotification",
  sendOTP:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/ssocheck/validatemtnownership",
  sendRtcItp:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/registryservice/registration/sendrtcitp",
  sendSmsOrEmail:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/common/notification/sendsmsoremail",
    setBrowserInfo: "/inhome/setbrowserinfo",
  setDueDate:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/duedateservice/duedate/reserveduedate",
  smartAutoSave:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartsave",
  smartSave:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartsavewithparam",
  smartcartCancel:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartcancel",
  getSmartCartStatus:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/smartcart/order/smartcartstatus",
  storePickUp:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/storepickup/switch/storepickup",
  submitOrder: "https://oa-qa.ebiz.verizon.com/atomapi/v1/order/order/submit",
  tcChatUrl:
    "https://collaborateextst.verizon.com/comm/includes/scripts/vztc.js",
  tokenGeneration: "/inhome/generatetoken",
  updateCartAcc:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateCartAccEc:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updatecart",
  updateFlowType:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/sessionmanager/updateflowtype",
  updateintentcart:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/cart/cart/updateintent",
  updateintentcartAcc:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartAccEc:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/updateintent",
  updateintentcartEc:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/cart/cart/updateintent",
  uploadFile:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/employeeproof",
  validateBillingAdress:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/billing/order/billing",
  validateContactInfo:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/contactinfo/order/contact",
  validateCouponToken:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/validatecoupontoken",
  validateEmployee:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/careflowservice/careflow/validateemployee",
  validateName:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/contactinfo/order/validateName",
  validateSigninUrl:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/accountqualificationservice/account/validateSignin",
  validateSmartCartContactInfo:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/contactinfo/order/validateSmartCartContactInfo",
  validatecartUrl:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/cart/cart/validate/",
  validatecartUrlEc:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/cart/cart/accordion/validate/",
  vendorFlow:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/sessionmanager/vendorflowvalidate",
  vendorFlowToken:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/sessionmanager/vendortokencreate",
  vepsUrl: "https://oa-qa.ebiz.verizon.com/atomapi/v1/veps/veps/payment",
  verifyOTP: "https://oa-qa.ebiz.verizon.com/atomapi/v1/ssocheck/verifyccpin",
  viewDetail:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/experience/exp/viewdetails",
  viewDetailAEM:
    "https://wwwawssit.ebiz.verizon.com/personal/services/getlongdesc.fios",
  voicetn:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/phoneservices/phoneservices",
    vzFwdEnrollmentDetails: 
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/enrollmentDetails", 
  twsSiginInDetails: 
    "https://api-dev2.ebiz.verizon.com/atomapi/v1/addressqualification/address/twsSiginInDetails", 
  vzwOfferEligibility:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/vzwoffereligibility",
  getWirelessProduct:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getWirelessProduct",
  checkPDCdata:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/persionalizationservice/personalization/checkpdcdata",
  vzOrderInfo:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/vzorderservice/order/vzorderinfo",
  vzOrderDetail:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/vzorderservice/order/vzorderdetail",
  brtcInfo:
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/vzorderservice/order/brtc",
  suppCancelCart: 
    "https://oa-qa.ebiz.verizon.com/atomapi/v1/cart/cart/supp/",
  ssoMHAuthiniticate:
    "https://oa-qa.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/validate",
  fiosReferralAdaptiveAuthentication:
   "https://oa-qa.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/fioReferralKiosk",
   fiosReferralCCAToken: "https://oa-qa.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/generateJwtToken",
   fiosReferralVerifyToken: "https://oa-qa.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/smspinverify",
    ssoMHEmailAuthiniticate:
    "https://oa-qa.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/emailvalidate",

  pollingIGBackendUrl:
    "https://securesit1.verizon.com/accessmanager/public/adaptiveauth/2fa/polling",
  ssoMHGetName:
    "https://oa-qa.ebiz.verizon.verizon.com/atomapi/v1/vzwoffereligibilityservice/eligibility/getfirstname",  
    getPerksAEM:"https://wwwawssit.ebiz.verizon.com/content/caas/plan/aggregated-perks.model.json",
};

export const getVzDomainUrl = () => {
  var envName = window.location.host;
  switch (envName) {
    case ATOM_CONST.SITURL:
      return "https://wwwawssit.ebiz.verizon.com";
    case ATOM_CONST.UATURL:
      return "https://wwwawsuat.ebiz.verizon.com";
    case ATOM_CONST.STAGEURL:
      return "https://www98.verizon.com";
    case ATOM_CONST.STAGEEASTURL:
      return "https://wwwordering-stg-east-yz.ebiz.verizon.com";
    case ATOM_CONST.STAGEWESTURL:
      return "https://wwwordering-stg-west-yz.ebiz.verizon.com";
    case ATOM_CONST.NTE1URL:
      return "https://wwwnte1aws.ebiz.verizon.com";
    case ATOM_CONST.NTE3URL:
      return "https://wwwnte3aws.ebiz.verizon.com";
    case ATOM_CONST.NTE4URL:
      return "https://wwwnte4aws.ebiz.verizon.com";
    case ATOM_CONST.NTE5URL:
      return "https://wwwnte5aws.ebiz.verizon.com";
    case ATOM_CONST.PILOTURL:
      return "https://orderinglite.verizon.com";
    case ATOM_CONST.PILOTURLE:
      return "https://orderinglite-gz-east.vpc.verizon.com";
    case ATOM_CONST.PREPROD:
      return "https://www.preprod.verizon.com";
    case ATOM_CONST.PREPRODEAST:
      return "https://preprod-east-gz.vpc.verizon.com";
    case ATOM_CONST.PRODEASTURL:
      return "https://wwwordering-prod-east-yz.vpc.verizon.com";
    case ATOM_CONST.PRODGSLBURL:
      return "https://wwwordering-gslb-prod-yz.vpc.verizon.com";
    case ATOM_CONST.NTE1SSOWURL:
        return "https://sso-np2.ebiz.verizon.com";
    case ATOM_CONST.PRODSSOERURL:
      return "https://sso-prod-east.r53pr.verizon.com";
    case ATOM_CONST.PRODSSOEURL:
      return "https://sso-pr-east-yz.vpc.verizon.com";
    case ATOM_CONST.PRODSSOWRURL:
      return "https://sso-prod-west.r53pr.verizon.com";
    case ATOM_CONST.PRODSSOWURL:
      return "https://sso-pr-west-yz.vpc.verizon.com";
    case ATOM_CONST.PRODWESTURL:
      return "https://wwwordering-prod-west-yz.vpc.verizon.com";
    case ATOM_CONST.LOCALURL:
      return "http://localhost:3000";
    default:
      return "https://www.verizon.com";
  }
};

const ATOM_CONST = {
  "www.verizon.com": "PROD",
  "wwwordering-prod-east-yz.vpc.verizon.com": "PROD",
  "wwwordering-prod-west-yz.vpc.verizon.com": "PROD",
  "wwwordering-gslb-prod-yz.vpc.verizon.com": "PROD",
  "sso-prod-east.r53pr.verizon.com": "PROD",
  "sso-prod-west.r53pr.verizon.com": "PROD",
  "sso-pr-east-yz.vpc.verizon.com": "PROD",
  "sso-pr-west-yz.vpc.verizon.com": "PROD",
  "sso-np2.ebiz.verizon.com":"NTE1",
  "www98.verizon.com": "STAGE",
  "espanolstage.verizon.com": "STAGE",
  "wwwordering-stg-east-yz.ebiz.verizon.com": "STAGE",
  "wwwordering-stg-west-yz.ebiz.verizon.com": "STAGE",
  "orderinglite.verizon.com": "PILOT",
  "orderinglite-gz-east.vpc.verizon.com": "PILOT",
  "preprod-east-gz.vpc.verizon.com": "PILOT",
  "www.preprod.verizon.com": "PILOT",
  "wwwawssit.ebiz.verizon.com": "SIT",
  "wwwawsuat.ebiz.verizon.com": "UAT",
  "wwwnte1aws.ebiz.verizon.com": "NTE1",
  "wwwnte3aws.ebiz.verizon.com": "NTE3",
  "wwwnte4aws.ebiz.verizon.com": "NTE4",
  "wwwnte5aws.ebiz.verizon.com": "NTE5",
  "espanol.verizon.com": "PROD",
  "localhost:3000": "LOCAL",
  "localhost.verizon.com:3000": "LOCALAPIGEE"
};

const getEnvName = () => {
  const host = window.location.host;
  return ATOM_CONST[host];
};

const env = getEnvName();
let apiURLConfig = null;
//STAGE: [stageApigee, stageProxy],
const proxyURL = {
  SIT: [sitApigee, sitProxy],
  UAT: [uatApigee, nte1Proxy],
  STAGE: [stageApigee, stageProxy], 
  PILOT: [pilotApigee, pilotProxy],
  PREPROD: [preProdApigee, preProdProxy],
  PROD: [prodApigee, prodApigee],
  NTE1: [nte1Apigee, nte1Proxy],
  NTE3: [stageApigee, nte3Proxy],
  NTE4: [nte4Apigee, nte4Proxy],
  NTE5: [uatApigee, uatProxy],
  LOCAL: [nte1Apigee, nte1Proxy],
  LOCALAPIGEE: [sitApigee, sitApigee]
};

export const apiUrl = () => {
  apiURLConfig || (apiURLConfig = getEnvUrlObj());
  return apiURLConfig;
};

const getEnvUrlObj = () => {
  // let isProxyURL = false;
  let isProxyURL = env === "LOCAL";
  let envConfigURL = null;
  // IE 11 window.location.origin Issue fix
  let origin = window.location.origin;
  if (!window.location.origin) {
    origin =
      window.location.protocol +
      "//" +
      window.location.hostname +
      (window.location.port ? ":" + window.location.port : "");
  }
  const urlEnv = proxyURL[env] || proxyURL["LOCAL"];
  envConfigURL = urlEnv[+isProxyURL];
  if (envConfigURL.createVisitId.indexOf("/") === 0) {
    envConfigURL.createVisitId = origin + envConfigURL.createVisitId;
    envConfigURL.tokenGeneration = origin + envConfigURL.tokenGeneration;
  }
  // if(process.env.NODE_ENV === 'development' && envConfigURL.createVisitId.indexOf("/")===0)
  // {
  //   const baseURL = window.location.origin.replace('3000', '8080');//.replace('https', 'http') ;
  //     envConfigURL.createVisitId= baseURL + envConfigURL.createVisitId.slice(7);
  //     envConfigURL.tokenGeneration= baseURL + envConfigURL.tokenGeneration.slice(7);
  // } //localDev
  return envConfigURL;
};

const DOMAINS = {
  PROD: "www.verizon.com",
  PILOT: "orderinglite-gz-east.vpc.verizon.com",
  PREPROD: "www.preprod.verizon.com",
  PREPRODEAST: "preprod-east-gz.vpc.verizon.com",
  STAGE: "www98.verizon.com",
  SIT: "wwwawssit.ebiz.verizon.com",
  UAT: "wwwawsuat.ebiz.verizon.com",
  NTE1: "wwwnte1aws.ebiz.verizon.com",
  NTE3: "wwwnte3aws.ebiz.verizon.com",
  NTE4: "wwwnte4aws.ebiz.verizon.com",
  NTE5: "wwwnte5aws.ebiz.verizon.com",
  ESPANOL: "espanol.verizon.com"
};

export const getGlobalSessionName = () => {
  let hostName = window.location.host;
  let globalName = "";
  if (hostName.indexOf(DOMAINS.SIT) > -1) {
    globalName = "GlobalSessionID_awssit";
  } else if (hostName.indexOf(DOMAINS.UAT) > -1) {
    globalName = "GlobalSessionID_awsuat";
  } else if (hostName.indexOf(DOMAINS.NTE1) > -1) {
    globalName = "GlobalSessionID_awsnte1";
  } else if (hostName.indexOf(DOMAINS.NTE3) > -1) {
    globalName = "GlobalSessionID_awsnte3";
  } else if (hostName.indexOf(DOMAINS.NTE4) > -1) {
    globalName = "GlobalSessionID_awsnte4";
  } else if (hostName.indexOf(DOMAINS.STAGE) > -1) {
    globalName = "GlobalSessionID_98";
  } else if (hostName.indexOf(DOMAINS.PILOT) > -1) {
    globalName = "GlobalSessionID";
  } else if (hostName.indexOf(DOMAINS.PROD) !== -1) {
    globalName = "GlobalSessionID";
  } else {
    globalName = "GlobalSessionID_awssit";
  }
  return globalName;
};
